<!-- eslint-disable vue/no-parsing-error -->
<template>
  <!--所有外设请求弹框组件-->
  <div class="index" style="height:100%;">
    <div id="dialogTip"></div>

    <!-- 报警视频框框 -->
    <div class="alarmDialogDiv" v-if="alarmDialogVideo.visible">
      <div class="videoContent" id="videoContent" v-loading="alarmDialogVideo.loading"
           element-loading-background="rgba(0,0,0,.8)" element-loading-text="视频获取中...">

      </div>
      <i class="el-icon-circle-close closeButton" title="关闭实时视频" @click="iconClose_video_ot"></i>
    </div>

    <el-dialog :visible.sync="dialog.visible" class="endNoticeDialogone" width="1341px" title="呼叫微站" append-to-body
               center
               show-close v-dialogDrag :close-on-click-modal="closeOnClickModal"
               :close-on-press-escape="closeOnPressEscape">
      <div style="padding-botton:15px">
        <el-row :gutter="32" style="background:#000;border-radius:0px 0px 18px 18px;overflow:hidden">
          <el-col :span="18">
            <div style="height:calc(100% - 50px)">
              <iframe id="show_iframe" allow="microphone;camera;midi;encrypted-media;" frameborder=0 name="showHere"
                      scrolling=auto :src="dialogHref" :style="videoHeight"></iframe>
            </div>
          </el-col>

          <el-col :span="6" style="margin-top:20px">
            <div class="callDialogRight" style="height:calc(100% - 50px)">
              <div>
                <p class="callDialogTime">
                  <img src="~@/assets/img/shijian.png" alt=""/>
                  <h2 style="margin-left: 15%;color:#fff">呼叫时间</h2>
                  <!-- // eslint-disable-next-line vue/no-parsing-error -->
                </p>
                <p class="callDialogThings" style="color:#fff">{{ videoRight.sendstartTime }}</p>
                <p class="callDialogThings" style="color:#fff">{{ minute }} 分 {{ second }} 秒</p>
                <br/>
              </div>
              <div v-for="(item, index) in videoRight.reveiveList" :key="index">
                <p class="callDialogTime">
                  <img src="~@/assets/img/callIn1.png" alt=""/>
                  <h2 style="margin-left: 15%;color:#fff">呼入方</h2>
                </p>
                <p class="callDialogThings">{{ item.receivedeptname }}</p>
                <p class="callDialogThings">{{ item.receivedeptmobile }}</p>
                <p class="callDialogThings">{{ item.receivemobile }}</p>
                <p class="callDialogThings">{{ item.receiveoname }}</p>
              </div>
              <br/>
              <div>
                <p class="callDialogTime">
                  <img src="~@/assets/img/callOut1.png" alt=""/>
                  <h2 style="margin-left: 15%;">呼出方</h2>
                </p>
                <p class="callDialogThings">{{ videoRight.senddeptname }}</p>
                <p class="callDialogThings">{{ videoRight.sendmobile }}</p>
                <p class="callDialogThings">{{ videoRight.sendname }}</p>
                <p class="callDialogThings">{{ videoRight.senddeptmobile }}</p>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <!-- 语音呼叫弹框 -->
    <el-dialog class="phoningDialog phoningDialog1" :visible.sync="dialog.phoneVisible" width="400px" title=""
               append-to-body center show-close :close-on-click-modal="closeOnClickModal"
               :close-on-press-escape="closeOnPressEscape">
      <!-- <phoneCallDialog :phoneCallDialog="phoneCallDialog"></phoneCallDialog> -->
      <div class="phoneCallDialog" style="textAlign:center;color:#fff">
        <el-row :gutter="32">
          <el-col :span="24">{{ phoneCallDialog.title }}</el-col>
        </el-row>
        <el-row :gutter="32">
          <el-col :span="24">{{ phoneCallDialog.readStateCn }}</el-col>
        </el-row>
        <el-row :gutter="32" v-if="phoneCallDialog.readState == '0'">
          <el-col :span="24">{{ phoneCallDialog.onState }}</el-col>
        </el-row>
        <el-row :gutter="32" v-if="phoneCallDialog.readState == '1'">
          <el-col :span="24">已通话{{ minute }} 分 {{ second }} 秒</el-col>
        </el-row>
        <el-row :gutter="32">
          <el-col :span="24">{{ phoneCallDialog.msgDetail }}</el-col>
        </el-row>
        <!-- <div style="marginTop:30px;text-align:center;height:30px">
          <img src="~@/assets/img/phone.png" alt="" style="height:30px">
          <span style="width:120px;height: 1px;display: inline-block;"></span>
          <img src="~@/assets/img/endPhone.png" alt="" style="height:30px">
        </div> -->
      </div>
    </el-dialog>

    <!--手动报警--中弹框-->
    <el-dialog :visible.sync="dialog.handAlarmVisible" title="" class="setHandArarm"
               :custom-class="isVideoShow === true ? 'hand-alarm mrl' : 'hand-alarm'" append-to-body center show-close
               :close-on-click-modal="closeOnClickModal" :close-on-press-escape="closeOnPressEscape">
      <handAlarm :alarmId="alarmId" @isVideo="handleIsVideo" @isHandAlarmVisible="isHandAlarmVisible" ref="handAlarm">
      </handAlarm>
      <div v-show="viweShow" class="set-video-wrapper">
        <div id="players" v-if="viweShow"></div>
        <div class="el-icon-close" title="关闭视频" @click="iconClose"></div>
      </div>
    </el-dialog>

    <!--烟感呼叫--中弹框-->
    <el-dialog :visible.sync="dialog.smokeAlarmVisible" class="smokeAlarmCopy " :title="q.smokeName" v-dialogDrag
               append-to-body show-close center :close-on-click-modal="false" custom-class="autoWidth">
      <smokeAlarmAuto :q="q" :alarmId="alarmId" @closeAlarmAuto="closeAlarmAuto" ref="smokeAlarmAuto"></smokeAlarmAuto>
    </el-dialog>

    <!-- 探头 -->
    <el-dialog :visible.sync="dialog.monitorVisible" width="90%" title="" append-to-body show-close center
               :close-on-click-modal="closeOnClickModal" :close-on-press-escape="closeOnPressEscape">
      <!-- <monitorAlarm ref="smokeAlarm" @closeSmokeAlarm="closeSmokeAlarm" :alarmId="alarmId"></monitorAlarm> -->
    </el-dialog>

    <!--语音呼叫挂断填入信息-->
    <el-dialog :visible.sync="dialog.callBreakVisible" class="mokeAlarmCopy" width="30%" title="" append-to-body
               show-close center :close-on-click-modal="closeOnClickModal" :close-on-press-escape="closeOnPressEscape">
      <h4>呼叫总结：</h4><br/>
      <el-input type="textArea" v-model="callBreakContent" placeholder="请输入信息">
      </el-input>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="submitCallBreakContent">提交</el-button>
      </div>
    </el-dialog>

    <!--回拨-->
    <el-dialog :visible.sync="dialog.callbackVisible" width="30%" title="" append-to-body center show-close
               :close-on-click-modal="closeOnClickModal" :close-on-press-escape="closeOnPressEscape">
      <div>{{ callBackInfo.msgTitle }}</div>
      <div>{{ callBackInfo.msgIframeTitle }}</div>
      <div>{{ callBackInfo.msgDetail }}</div>
      <div>{{ callBackInfo.createdate }}</div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="callBack">回拨</el-button>
        <el-button type="info" size="small" @click="dialog.callbackVisible = false">取消</el-button>
      </div>
    </el-dialog>

    <!-- 结束收队弹框 -->
    <el-dialog :visible.sync="dialog.policeEndVisible" :close-on-click-modal='false' class="smokeAlarmCopy"
               width="600px"
               :title="jssd.jssdLs.detail + '处警结束'" append-to-body show-close center>
      <policeEnd @closePoliceEnd="closePoliceEnd" v-bind:jssdLs="jssd.jssdLs" @openReview="openReview(jssd.jssdLs)">
      </policeEnd>
    </el-dialog>

    <!--是否接听视频-->
    <el-dialog :visible.sync="dialog.sureVideoVisible" width="30%" :title="videoMsg.msgTitle" append-to-body show-close
               center>
      <div class="sureVisibleTip">{{ videoMsg.msgDetail }}</div>
      <!-- <div class="sureVisibleTip">{{ videoMsg.msgTitle }}</div> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog.sureVideoVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureVideoCommit">接 受</el-button>
      </span>
    </el-dialog>

    <!--烟感报警自动弹框-->
    <div v-for="v in dialogSmokeList" :key="v.id">
      <el-dialog :visible.sync="v.dialogSmokeIndex" :close-on-click-modal="false" width="592px" :title="v.HiddenTitle"
                 :style="v.style" show-close v-dialogDrag custom-class="q-dialog">
        <div class="autoContent">
          <div class="proBot" style="width: 100%;padding:0px;position:relative;top:-30px;"><span class="dianTitle"
                                                                                                 style="width:auto;letter-spacing: 2px;">{{
              v.msgDetail
            }}</span></div>
          <div class="proBot" style="width: 100%;height: 360px;background:#fff;margin-bottom:20px;padding:0px">
            <div :id="'lnglatAlarm' + v.id" style="height:360px;" v-if="v.alarmMap"></div>
            <div :id="'lnglatAlarm' + v.id"
                 style="height:360px;display:flex;justify-content: center; align-items: center;" v-else><span
              style="display:flex;width:auto;color:#857f7f;font-size:12px;">该设备无经纬度信息！</span></div>
          </div>
          <div class="j-smoke-btn" @click="openFireBookDetail(v); v.dialogSmokeIndex = false"
            style="text-align:center"><img src="~@/assets/img/nowPolicejiejing.png" alt="">
          </div>
        </div>
      </el-dialog>
    </div>

    <!--温感警报自动弹框-->
    <div v-for="v in dialogWgList" :key="v.id">
      <el-dialog :visible.sync="v.dialogSmokeIndex" :close-on-click-modal="false" width="592px" :title="v.HiddenTitle"
                 :style="v.style" show-close v-dialogDrag custom-class="q-dialog">
        <div class="autoContent">
          <div class="proBot" style="width: 100%;padding:0px;position:relative;top:-30px;"><span class="dianTitle"
                                                                                                 style="width:auto;letter-spacing: 2px;">{{
              v.msgDetail
            }}</span></div>
          <div class="proBot" style="width: 100%;height: 360px;background:#fff;margin-bottom:20px;padding:0px">
            <div :id="'lnglatAlarm' + v.id" style="height:360px;" v-if="v.alarmMap"></div>
            <div :id="'lnglatAlarm' + v.id"
                 style="height:360px;display:flex;justify-content: center; align-items: center;" v-else><span
              style="display:flex;width:auto;color:#857f7f;font-size:12px;">该设备无经纬度信息！</span></div>
          </div>
          <!-- <div class="j-smoke-btn" @click="smokeAutoReport(v.equipId, dialogSmokeListNew, v.popUpWay)"
            style="text-align:center"><img src="~@/assets/img/smoke_d.png" alt="" @click="v.dialogSmokeIndex = false">
          </div> -->
        </div>
      </el-dialog>
    </div>

    <!--烟感列表弹框-->
    <div v-for="v in dialogSmokeListNew" :key="v.id">
      <el-dialog :visible.sync="v.dialogSmokeIndexList" :close-on-click-modal="false" width="592px"
                 :title="v.HiddenTitle"
                 :style="v.style" show-close v-dialogDrag custom-class="q-dialog">
        <div class="autoContent">
          <div class="proBot" style="width: 100%;padding:0px;position:relative;top:-30px;"><span class="dianTitle"
                                                                                                 style="width:auto;letter-spacing: 2px;">{{
              v.msgDetail
            }}</span></div>
          <div class="proBot" style="width: 100%;height: 360px;background:#fff;margin-bottom:20px;padding:0px">
            <div :id="'lnglatAlarm' + v.id" style="height:360px;" v-if="v.alarmMap"></div>
            <div :id="'lnglatAlarm' + v.id"
                 style="height:360px;display:flex;justify-content: center; align-items: center;" v-else><span
              style="display:flex;width:auto;color:#857f7f;font-size:12px;">该设备无经纬度信息！</span></div>
          </div>
          <!-- <div class="j-smoke-btn" @click="smokeAutoReport(v.equipId, dialogSmokeListNew, v.popUpWay)"
            style="text-align:center"><img src="~@/assets/img/smoke_d.png" alt="" @click="v.dialogSmokeIndexList = false">
          </div> -->
        </div>
      </el-dialog>
    </div>

    <!--电动车违规预警自动弹框-->
    <div v-for="v in dialogDdcwgyjDataList" :key="v.id">
      <el-dialog :visible.sync="v.dialogCameraIndexDdcwgyj" :close-on-click-modal="false" width="592px" :style="v.style"
                 show-close v-dialogDrag :custom-class="qdialog_smoke">
        <div class="autoContent">
          <div>
            <h1 style="color: #eae6e6;">{{ v.HiddenTitle }}<span v-show="v.num > 1"><span
              style="color:rgb(1,85,114)">&nbsp;&nbsp;{{ v.num }}</span> 次 </span></h1>
          </div>
          <div style="margin-top:50px;"><img src="~@/assets/img/smoke_c.png" alt=""></div>
          <div class="autoAddress">
            {{
              (v.msgDetail.split('|')[0]).indexOf('无单元') ==
              '-1' ? (v.msgDetail.split('|')[0]) : (v.msgDetail.split('|')[0]).split('无单元').join('')
            }}
          </div>
          <div v-if="v.msgDetail.split('|')[1]" class="autoAddress">{{ v.msgDetail.split('|')[1] }}</div>
          <div class="j-smoke-btn" style="margin-top:20px;display:flex;justifyContent: center;">
            <div @click="openFireBookDetail(v); v.dialogCameraIndexDdcwgyj = false"><img src="~@/assets/img/nowPolicexc.png" alt=""></div>
            <div @click="alarmPhoneClick(v)"><img src="~@/assets/img/bodadianhua.png" alt=""></div>
          </div>
        </div>
      </el-dialog>
    </div>

    <!--电动车违规预警列表弹框-->
    <div v-for="v in dialogDdcwgyjDataListNew" :key="v.id">
      <el-dialog :visible.sync="v.dialogCameraIndexDdcwgyjList" :close-on-click-modal="false" width="592px"
                 :style="v.style" show-close v-dialogDrag :custom-class="qdialog_smoke">
        <div class="autoContent">
          <div>
            <h1 style="color: #eae6e6;">{{ v.HiddenTitle }}</h1>
          </div>
          <div style="margin-top:50px;"><img src="~@/assets/img/smoke_c.png" alt=""></div>
          <div class="autoAddress">{{
              (v.msgDetail.split('|')[0]).indexOf('无单元') ==
              '-1' ? (v.msgDetail.split('|')[0]) : (v.msgDetail.split('|')[0]).split('无单元').join('')
            }}
          </div>
          <div v-if="v.msgDetail.split('|')[1]" class="autoAddress">{{ v.msgDetail.split('|')[1] }}</div>
          <div class="j-smoke-btn" style="margin-top:20px;display:flex;justifyContent: center;">
            <div @click="openFireBookDetail(v); v.dialogCameraIndexDdcwgyjList = false"><img src="~@/assets/img/nowPolicexc.png" alt=""></div>
            <div @click="alarmPhoneClick(v)"><img src="~@/assets/img/bodadianhua.png" alt=""></div>
          </div>
        </div>
      </el-dialog>
    </div>

    <!--电气隐患预警警情弹框-->
    <div v-for="v in dialogDqyhDataList" :key="v.id">
      <el-dialog :visible.sync="v.dialogCameraIndexDqyh" :close-on-click-modal="false" width="592px" :style="v.style"
                 show-close v-dialogDrag :custom-class="qdialog_smoke">
        <div class="autoContent">
          <div>
            <h1 style="color: #eae6e6;">{{ v.HiddenTitle }}</h1>
          </div>
          <div style="margin-top:50px;"><img src="~@/assets/img/smoke_c.png" alt=""></div>
          <!-- 地址 -->
          <div class="autoAddress">{{
              (v.msgDetail.split('|')[0]).indexOf('无单元') ==
              '-1' ? (v.msgDetail.split('|')[0]) : (v.msgDetail.split('|')[0]).split('无单元').join('')
            }}
          </div>
          <div v-if="v.msgDetail.split('|')[1]" class="autoAddress">{{ v.msgDetail.split('|')[1] }}</div>
          <!-- 报警类型 -->
          <div class="autoAddress">{{ v.msgTitle }}</div>
          <!-- 报警时间 -->
          <div class="autoAddress">报警时间:{{ v.createTime ? v.createTime : '暂无' }}</div>
          <div class="j-smoke-btn" style="margin-top:20px;display:flex;justifyContent: center;">
            <!-- 1114修改为立即接警 -->
            <!-- <div @click="fourKindAlarm(v, 'ddcwgList')"><img src="~@/assets/img/nowPolicexc.png" alt=""
                @click="v.dialogCameraIndexDqyh = false"></div> -->
            <!-- <div @click="alarmPhoneClick(v)"><img src="~@/assets/img/bodadianhua.png" alt=""></div> -->
            <!-- 1114改为堆物堆料的逻辑 -->
            <!--2024年4月3号 自动派警不要接警按钮了-->
<!--            <div @click="fourKindAlarm(v, 'dwdl'), v.dialogCameraIndexDqyh = false"><img-->
<!--              src="~@/assets/img/nowPolicejiejing.png" alt=""></div>-->
          </div>
        </div>
      </el-dialog>
    </div>
    <!--电气隐患预警列表弹框-->
    <div v-for="v in dialogDqyhDataListNew" :key="v.id">
      <el-dialog :visible.sync="v.dialogCameraIndexDqyh" :close-on-click-modal="false" width="592px" :style="v.style"
                 show-close v-dialogDrag :custom-class="qdialog_smoke">
        <div class="autoContent">
          <div>
            <h1 style="color: #eae6e6;">{{ v.HiddenTitle }}</h1>
          </div>
          <div style="margin-top:50px;"><img src="~@/assets/img/smoke_c.png" alt=""></div>
          <!-- 地址 -->
          <div class="autoAddress">{{
              (v.msgDetail.split('|')[0]).indexOf('无单元') ==
              '-1' ? (v.msgDetail.split('|')[0]) : (v.msgDetail.split('|')[0]).split('无单元').join('')
            }}
          </div>
          <div v-if="v.msgDetail.split('|')[1]" class="autoAddress">{{ v.msgDetail.split('|')[1] }}</div>
          <!-- 报警类型 -->
          <div class="autoAddress">{{ v.msgTitle }}</div>
          <!-- 报警时间 -->
          <div class="autoAddress">报警时间:{{ v.createTime ? v.createTime : '暂无' }}</div>
          <div class="j-smoke-btn" style="margin-top:20px;display:flex;justifyContent: center;">
            <!-- 1114修改为立即接警 -->
            <!-- <div @click="fourKindAlarm(v, 'ddcwgList')"><img src="~@/assets/img/nowPolicexc.png" alt=""
                @click="v.dialogCameraIndexDqyh = false"></div> -->
            <!-- <div @click="alarmPhoneClick(v)"><img src="~@/assets/img/bodadianhua.png" alt=""></div> -->
            <!-- 1114改为堆物堆料的逻辑 -->
            <!--2024年4月3号 自动派警不要接警按钮了-->
            <div @click="fourKindAlarm(v, 'dwdl'), v.dialogCameraIndexDqyh = false"><img
              src="~@/assets/img/nowPolicejiejing.png" alt=""></div>
          </div>
        </div>
      </el-dialog>
    </div>
    <!--低电量预警列表弹框-->
    <div v-for="v in dialogDdlDataList" :key="v.id">
      <el-dialog :visible.sync="v.dialogCameraIndexDdl" :close-on-click-modal="false" width="592px" :style="v.style"
                 show-close v-dialogDrag :custom-class="qdialog_smoke">
        <div class="autoContent">
          <div>
            <h1 style="color: #eae6e6;">{{ v.HiddenTitle }}</h1>
          </div>
          <div style="margin-top:50px;"><img src="~@/assets/img/smoke_c.png" alt=""></div>
          <!-- 地址 -->
          <div class="autoAddress">{{
              (v.msgDetail.split('|')[0]).indexOf('无单元') ==
              '-1' ? (v.msgDetail.split('|')[0]) : (v.msgDetail.split('|')[0]).split('无单元').join('')
            }}
          </div>
          <div v-if="v.msgDetail.split('|')[1]" class="autoAddress">{{ v.msgDetail.split('|')[1] }}</div>
          <!-- 报警类型 -->
          <div class="autoAddress">{{ v.msgTitle }}</div>
          <!-- 报警时间 -->
          <div class="autoAddress">报警时间:{{ v.createTime ? v.createTime : '暂无' }}</div>
          <!-- <div class="j-smoke-btn"
               style="margin-top:20px;display:flex;justifyContent: center;">
           <div @click="fourKindAlarm(v, 'ddcwgList')"><img src="~@/assets/img/nowPolicexc.png"
                   alt=""
                   @click="v.dialogCameraIndexDqyh = false"></div>
            <div @click="alarmPhoneClick(v)"><img src="~@/assets/img/bodadianhua.png"
                   alt=""></div>
          </div> -->
        </div>
      </el-dialog>
    </div>

    <!--光火眼（紫外）报警自动弹框-->
    <div v-for="v in dialogCameraGhyList" :key="v.id">
      <el-dialog :title="v.num > 1 ? v.initPopUp + ' ' + v.num + ' 次' : v.initPopUp" :style="v.style"
                 :visible.sync="v.dialogCameraIndexGhy" show-close v-dialogDrag ref="pinkeyeRef"
                 :close-on-click-modal="false"
                 :custom-class="isButt_ghy ? 'q-dialog q-dialog-left' : 'q-dialog'" @close='handle_close_dialog(v)'>
        <div class="probeFun">
          <!-- <el-image style="width: 100%;  height: 328px; background:#fff" :src="v.img" :preview-src-list="pinkUrls" alt="图片未加载成功"></el-image> -->
          <div style="width: 100%;  height: 128px;"></div>
          <div class="q-video" v-if="isButt_ghy">
            <div class="q-video-inside" style="width:580px;height:566px;margin:-30px auto 0;">
              <div :id='v.id' class="video-paading"></div>
              <div class="el-icon-close" title="关闭实时视频" @click="iconClose_video(v)"></div>
            </div>
            <el-row style="text-align:center;padding-top:20px" v-show="player_voice.forbid">
              <el-button type="primary" @click="voice_open" size="small" v-show="player_voice.sign">开启对讲</el-button>
              <el-button type="danger" @click="voice_close" size="small" v-show="!player_voice.sign">关闭对讲
              </el-button>
            </el-row>
          </div>
          <div class="q-address" >{{ v.msgDetail }}</div>
          <div class="nowPolice" style="text-align:center;">
            <!-- 1130 派单按钮打开 -->
<!--            <img src="~@/assets/img/nowPolice.png" alt="" @click="fourKindAlarm(v, 'ghy')">-->
            <!-- 1124 按钮和紫外光感同步 改为立即派单 -->
            <!--            <img src="~@/assets/img/nowPolice.png" alt="" @click="fourKindVideoAlarm1(v, 'hjbj')">-->
            <!-- <img src="~@/assets/img/smoke_x.png" alt="" @click="errReport(v)" v-if="distort"> -->
<!--            <img src="~@/assets/img/close-video-icon.png" alt="" v-if="isButt_ghy" @click="jumpVideo2_ghy(v)">-->
            <img src="~@/assets/img/pull-icon-quer.png" alt="" @click="v.dialogCameraIndexGhy = false">
            <!-- 之前改的 不会死1124改的 -->
            <!-- <img src="~@/assets/img/newvideo2.png" v-else @click="jumpVideo2_ghy(v)"> -->
          </div>
        </div>
      </el-dialog>
    </div>

    <!--光火眼（紫外）列表报警-->
    <div v-for="v in dialogCameraGhyListNew" :key="v.id">
      <el-dialog :title="v.initPopUp" :style="v.style" :visible.sync="v.dialogCameraIndexGhyList" show-close
                 v-dialogDrag
                 ref="pinkeyeRef" :close-on-click-modal="false"
                 :custom-class="isButt_ghy ? 'q-dialog q-dialog-left' : 'q-dialog'"
                 @close='handle_close_dialog(v)'>
        <div class="probeFun">
          <!-- <el-image style="width: 100%;  height: 328px; background:#fff" :src="v.img" :preview-src-list="pinkUrls" alt="图片未加载成功"></el-image> -->
          <div style="width: 100%;  height: 128px;"></div>
          <div class="q-video" v-if="isButt_ghy">
            <div class="q-video-inside" style="width:580px;height:566px;margin:-30px auto 0;">
              <div :id='v.id' class="video-paading"></div>
              <div class="el-icon-close" title="关闭实时视频" @click="iconClose_video(v)"></div>
            </div>
            <el-row style="text-align:center;padding-top:20px" v-show="player_voice.forbid">
              <el-button type="primary" @click="voice_open" size="small" v-show="player_voice.sign">开启对讲</el-button>
              <el-button type="danger" @click="voice_close" size="small" v-show="!player_voice.sign">关闭对讲
              </el-button>
            </el-row>
          </div>
          <div class="q-address" >{{ v.msgDetail }}</div>
          <div class="nowPolice" style="text-align:center;">
            <!-- 1130 派单按钮打开 -->
<!--            <img src="~@/assets/img/nowPolice.png" alt="" @click="fourKindAlarm(v, 'ghyList')">-->
<!--            <img src="~@/assets/img/smoke_x.png" alt="" @click="errReport(v)" v-if="distort">-->
<!--            <img src="~@/assets/img/close-video-icon.png" alt="" v-if="isButt_ghy" @click="jumpVideo2_ghy(v)">-->
<!--            <img src="~@/assets/img/newvideo2.png" v-else @click="jumpVideo2_ghy(v)">-->
            <img src="~@/assets/img/pull-icon-quer.png" alt="" @click="v.dialogCameraIndexGhyList = false">
          </div>
        </div>
      </el-dialog>
    </div>

    <!--电梯报警自动弹框-->
    <div v-for="v in dialogCameraDiantiList" :key="v.id">
      <el-dialog :title="v.num > 1 ? v.initPopUp + ' ' + v.num + ' 次' : v.initPopUp" :style="v.style"
                 :visible.sync="v.dialogCameraIndexDianti" show-close v-dialogDrag ref="pinkeyeRef"
                 :close-on-click-modal="false"
                 custom-class='q-dialog' @close='handle_close_dialog(v)'>
        <div class="probeFun">
          <div style="width: 100%;  height: 70px;">电梯报警自动弹框</div>
          <div class="proBot"
               style="margin-bottom: -31px;margin-left: 200px;font-size: 36px;height:45px;text-align:center;"><span
            style="width:auto;float: left;text-align: center;">{{ v.msgDetail.split("报警信息：")[1] }}</span></div>
          <div class="proBot" style="margin-bottom:150px"><span style="width:auto">{{
              v.msgDetail.split("报警信息")[0]
            }}</span>
          </div>
          <div class="nowPolice" style="text-align:center;">
            <!-- <img src="~@/assets/img/nowPolice.png" alt="" @click="fourKindAlarm(v, 'dianti')"> -->
            <img src="~@/assets/img/smoke_x.png" alt="" @click="errReport(v)" v-if="distort">
          </div>
        </div>
      </el-dialog>
    </div>

    <!--视频报警自动弹框呼叫火眼报警弹窗-->
    <div v-for="v in dialogCameraSpbjList" :key="v.id">
      <el-dialog :title="v.initPopUp" :style="v.style" :visible.sync="v.dialogCameraIndexSpbj" show-close v-dialogDrag
                 ref="pinkeyeRef" :close-on-click-modal="false"
                 :custom-class="isButt_spbj ? 'q-dialog q-dialog-left' : 'q-dialog'"
                 @close="closeSDK(v, 'zd')">
        <div class="probeFun">
          <div class="proBot" style="width: 100%;padding:0px;position:relative;top:-30px"><span class="dianTitle"
                                                                                                style="width:auto;letter-spacing: 2px;">
              <!-- split报错 -->
              {{ v.msgDetail ? v.msgDetail.split('无单元').join('') : '暂无' }}
            </span></div>
          <div class="q-video" v-show="isButt_spbj">
            <div class="q-video-inside" style="width:580px;height:566px;margin:-30px auto 0;position:relative">
              <video :id="'id' + v.id" class="video-paading" autoplay muted controls style="width:100%"></video>
              <canvas :id="'canvas' + v.id"
                      style="width: 580px;height:326px;top:120px;left:0px;position:absolute"></canvas>
              <audio :id="'audio' + v.id" class="audio" autoPlay></audio>
              <!-- <div class="el-icon-close"
                   title="关闭实时视频"
                   @click="iconClose_video(v, 'zd')"
                   style="top:50px"></div> -->
            </div>
          </div>
          <div class="proBot" style="width: 100%;height: 360px;background:#fff;margin-bottom:20px;padding:0px">
            <div :id="'lnglatAlarm' + v.id" style="height:360px;" v-if="v.alarmMap"></div>
            <div :id="'lnglatAlarm' + v.id"
                 style="height:360px;display:flex;justify-content: center; align-items: center;" v-else><span
              style="display:flex;width:auto;color:#857f7f;font-size:12px;">该设备无经纬度信息！</span></div>
          </div>
          <div style="font-size:18px;color:#fff;">报警时间:{{ v.createTime }}</div>
          <div class="nowPolice" style="text-align: center;margin-top: 20px;display: flex;">
            <img src="~@/assets/img/pull-icon-quer.png" alt="" @click="v.dialogCameraIndexSpbj = false">
<!--            <img src="~@/assets/img/videopaijing.png" alt="" @click="fourKindVideoAlarm(v, 'spbj')">-->
<!--            <img src="~@/assets/img/smoke_x.png" alt="" @click="errReport(v)" v-if="distort">-->
            <!-- 7.25修改按钮样式为查看视频 ~@/assets/img/nowPolicejiejing.png-->
            <!-- <img src="~@/assets/img/newvideo2.png"
                 :id="'img' + v.id"
                 @click="jumpVideo2_spbj(v, 'list');"> -->
<!--            <img src="~@/assets/img/newvideo2.png" :id="'img' + v.id" @click="jumpVideo2_spbj(v, 'zd');">-->
          </div>
        </div>
      </el-dialog>
    </div>

    <!--视频列表报警   应急呼叫弹窗&&呼叫火眼-->
    <div v-for="v in dialogCameraSpbjListNew" :key="v.id">
      <el-dialog :title="v.initPopUp" :style="v.style" :visible.sync="v.dialogCameraIndexSpbjList" show-close
                 v-dialogDrag
                 ref="pinkeyeRef" :close-on-click-modal="false"
                 :custom-class="isButt_spbj ? 'q-dialog q-dialog-left' : 'q-dialog'"
                 @close="closeSDK(v, 'list')">
        <div class="probeFun">
          <!-- 位置 -->
          <div class="q-address" >{{ v.msgDetail }}</div>
          <div class="q-video" v-show="isButt_spbj">
            <div class="q-video-inside" style="width:580px;height:566px;margin:-30px auto 0;">
              <video :id="'id' + v.id" class="video-paading" autoplay muted controls style="width:100%"></video>
              <canvas :id="'canvas' + v.id"
                      style="width: 580px;height:326px;top:120px;left:0px;position:absolute"></canvas>
              <audio :id="'audio' + v.id" class="audio" autoPlay></audio>
              <!-- <div class="el-icon-close"
                   title="关闭实时视频"
                   @click="iconClose_video(v, 'list')"></div> -->
            </div>
          </div>
          <div class="proBot" style="width: 100%;height: 360px;background:#fff;margin-bottom:20px;padding:0px">
            <div :id="'lnglatAlarm' + v.id" style="height:360px;" v-if="v.alarmMap"></div>
            <div :id="'lnglatAlarm' + v.id"
                 style="height:360px;display:flex;justify-content: center; align-items: center;" v-else><span
              style="display:flex;width:auto;color:#857f7f;font-size:12px;">该设备无经纬度信息！</span></div>
          </div>
          <div style="font-size:18px;color:#fff;">报警时间:{{ v.createTime }}</div>
          <div class="nowPolice" style="text-align: center;margin-top: 20px;display: flex;">
<!--            <img src="~@/assets/img/videopaijing.png" alt="" @click="fourKindVideoAlarm(v, 'spbjList')">-->
<!--            <img src="~@/assets/img/smoke_x.png" alt="" @click="errReport(v)" v-if="distort">-->
<!--            <img src="~@/assets/img/nowPolicehuihu.png" v-if="!isButt_spbj" @click="jumpVideo2_spbj(v, 'list')">-->
            <img src="~@/assets/img/pull-icon-quer.png" alt="" @click="v.dialogCameraIndexDwdl = false">
          </div>
        </div>
      </el-dialog>
    </div>


    <!--呼叫火眼报警弹屏-->
    <div v-for="v in dialogCameraHjhyList" :key="v.id">
      <el-dialog :title="v.initPopUp" :style="v.style" :visible.sync="v.dialogCameraIndexHjhy" show-close v-dialogDrag
                 ref="pinkeyeRef" :close-on-click-modal="false"
                 :custom-class="isButt_spbj ? 'q-dialog q-dialog-left' : 'q-dialog'"
                 @close="closeSDK(v, 'list')">
        <div class="probeFun">
          <div class="proBot" style="width: 100%;padding:0px;position:relative;top:-30px"><span class="dianTitle"
                                                                                                style="width:auto;letter-spacing: 2px;">
              <!-- split报错 -->
              {{ v.msgDetail ? v.msgDetail.split('无单元').join('') : '暂无' }}
            </span></div>
          <div class="q-video" v-if="isButt_spbj">
            <div class="q-video-inside" style="width:580px;height:566px;margin:-30px auto 0;position:relative">
              <video :id="'id' + v.id" class="video-paading" autoplay muted controls style="width:100%"></video>
              <canvas :id="'canvas' + v.id"
                      style="width: 580px;height:326px;top:120px;left:0px;position:absolute"></canvas>
              <audio :id="'audio' + v.id" class="audio" autoPlay></audio>
              <!--              &lt;!&ndash; <div class="el-icon-close"-->
              <!--                   title="关闭实时视频"-->
              <!--                   @click="iconClose_video(v, 'zd')"-->
              <!--                   style="top:50px"></div> &ndash;&gt;-->
              <div class="el-icon-close"
                   title="关闭实时视频"
                   @click="iconClose_video(v, 'zd')"></div>
            </div>
          </div>
          <div class="proBot" style="width: 100%;height: 360px;background:#fff;margin-bottom:20px;padding:0px">
            <div :id="'lnglatAlarm' + v.id" style="height:360px;" v-if="v.alarmMap"></div>
            <div :id="'lnglatAlarm' + v.id"
                 style="height:360px;display:flex;justify-content: center; align-items: center;" v-else><span
              style="display:flex;width:auto;color:#857f7f;font-size:12px;">该设备无经纬度信息！</span></div>
          </div>
          <div style="font-size:18px;color:#fff;">报警时间:{{ v.createTime }}</div>
          <div class="nowPolice" style="text-align:center;">
            <!-- 1124 派人处置样式改为 立即派单 但是图片太大了 -->
            <!--            <img src="~@/assets/img/nowPolice.png" alt="" @click="fourKindVideoAlarm1(v, 'hjbj')">-->
            <!-- 1210 又改为派人处置了 -->
<!--            <img src="~@/assets/img/videopaijing.png" alt="" @click="fourKindVideoAlarm1(v, 'hjbj')">-->
            <!-- 1210 实时视频改为立即接警 -->
<!--            <img src="~@/assets/img/smoke_x.png" alt="" @click="errReport(v)" v-if="distort">-->
            <!-- 7.25修改按钮样式为查看视频 ~@/assets/img/nowPolicejiejing.png-->
            <!-- <img src="~@/assets/img/newvideo2.png"
                 :id="'img' + v.id"
                 @click="jumpVideo2_spbj(v, 'list');"> -->
<!--            <img src="~@/assets/img/newvideo2.png" :id="'img' + v.id" @click="jumpVideo2_spbj(v, 'list');">-->
            <img src="~@/assets/img/pull-icon-quer.png" alt="" @click="v.dialogCameraIndexHjhy = false">
          </div>
        </div>
      </el-dialog>
    </div>

    <!--呼叫火眼回呼弹屏-->
    <div v-for="v in dialogCameraHjhyListNew" :key="v.id">
      <el-dialog :title="v.initPopUp" :style="v.style" :visible.sync="v.dialogCameraIndexHjhyList" show-close
                 v-dialogDrag
                 ref="pinkeyeRef" :close-on-click-modal="false"
                 :custom-class="isButt_spbj ? 'q-dialog q-dialog-left' : 'q-dialog'"
                 @close="closeSDK(v, 'list')">
        <div class="probeFun">
          <!-- 位置 -->
          <div class="proBot" style="width: 100%;padding:0px;position:relative;top:-30px;"><span class="dianTitle"
                                                                                                 style="width:auto;letter-spacing: 2px;">
              <!-- {{ v.msgDetail.split('无单元').join('') }} -->
              {{ v.msgDetail }}
            </span></div>
          <div class="q-video" v-if="isButt_spbj">
            <div class="q-video-inside" style="width:580px;height:566px;margin:-30px auto 0;">
              <video :id="'id' + v.id" class="video-paading" autoplay muted controls style="width:100%"></video>
              <canvas :id="'canvas' + v.id"
                      style="width: 580px;height:326px;top:120px;left:0px;position:absolute"></canvas>
              <audio :id="'audio' + v.id" class="audio" autoPlay></audio>
              <!-- <div class="el-icon-close"
                   title="关闭实时视频"
                   @click="iconClose_video(v, 'list')"></div> -->
            </div>
          </div>
          <div class="proBot" style="width: 100%;height: 360px;background:#fff;margin-bottom:20px;padding:0px">
            <div :id="'lnglatAlarm' + v.id" style="height:360px;" v-if="v.alarmMap"></div>
            <div :id="'lnglatAlarm' + v.id"
                 style="height:360px;display:flex;justify-content: center; align-items: center;" v-else><span
              style="display:flex;width:auto;color:#857f7f;font-size:12px;">该设备无经纬度信息！</span></div>
          </div>
          <div style="font-size:18px;color:#fff;">报警时间:{{ v.createTime }}</div>
          <div class="nowPolice" style="text-align:center;">
            <img src="~@/assets/img/pull-icon-quer.png" alt="" @click="v.dialogCameraIndexHjhyList = false">
<!--            <img src="~@/assets/img/videopaijing.png" alt="" @click="fourKindVideoAlarm(v, 'hjbjList')">-->
<!--            <img src="~@/assets/img/smoke_x.png" alt="" @click="errReport(v)" v-if="distort">-->
<!--            <img src="~@/assets/img/nowPolicehuihu.png" v-if="!isButt_spbj" @click="jumpVideo2_spbj(v, 'list')">-->
          </div>
        </div>
      </el-dialog>
    </div>

    <!--光火眼列表弹框-->
    <!-- <div v-for="v in dialogCameraGhyListNew" :key="v.id">
    <el-dialog
      :visible.sync="v.dialogCameraIndexGhyList"
      :close-on-click-modal="false"
      width="592px"
      :style="v.style"
      show-close  v-dialogDrag
      :custom-class="qdialog_smoke">
      <div class="autoContent">
        <div>
          <h1 style="color: #eae6e6;">{{v.HiddenTitle}}</h1>
        </div>
        <div style="margin-top:41px;"><img src="~@/assets/img/smoke_c.png" alt=""></div>
        <div class="autoAddress">{{ v.msgDetail }}</div>
        <div class="j-smoke-btn" @click="smokeAutoReport(v.equipId,dialogCameraGhyListNew,v.popUpWay)"><img src="~@/assets/img/smoke_d.png" alt="" @click="v.dialogCameraIndexGhyList= false"></div>
      </div>
    </el-dialog>
    </div> -->

    <!--水压报警自动弹框-->
    <div v-for="v in dialogWaterList" :key="v.id">
      <el-dialog :visible.sync="v.dialogWaterIndex" :close-on-click-modal="false" width="592px" :style="v.style"
                 show-close v-dialogDrag :custom-class="qdialog_smoke">
        <div class="autoContent">
          <div>
            <h1 style="color: #eae6e6;">{{ v.HiddenTitle }}<span v-show="v.num > 1"><span
              style="color:rgb(1,85,114)">&nbsp;&nbsp;1</span> 次 </span></h1>
          </div>
          <div style="margin-top:41px;"><img src="~@/assets/img/smoke_c.png" alt=""></div>
          <!-- 与服务端约定使用\n将msgDetail字段切分两段落 -->
          <div class="autoAddress">{{ v.msgDetail ? (v.msgDetail.split('\n') && v.msgDetail.split('\n')[0]) || '' : '' }}</div>
          <div class="autoAddress" style="padding: 0 0 22px">当前水压:{{ v.msgDetail ? (v.msgDetail.split('\n') && v.msgDetail.split('\n')[1]) || '' : '' }}</div>
          <div class="j-smoke-btn" @click="toWaterPage(v.equipId)"><img
            src="~@/assets/img/pullQuery.png" alt="" @click="v.dialogWaterIndex = false"></div>
        </div>
      </el-dialog>
    </div>

    <!--水压列表弹框-->
    <div v-for="v in dialogWaterListNew" :key="v.id">
      <el-dialog :visible.sync="v.dialogWaterIndexList" :close-on-click-modal="false" width="592px" :style="v.style"
                 show-close v-dialogDrag :custom-class="qdialog_smoke">
        <div class="autoContent">
          <div>
            <h1 style="color: #eae6e6;">{{ v.HiddenTitle }}</h1>
          </div>
          <div style="margin-top:41px;"><img src="~@/assets/img/smoke_c.png" alt=""></div>
          <div class="autoAddress">{{ v.msgDetail }}</div>
          <div class="j-smoke-btn" @click="waterAutoReport(v.equipId, dialogWaterListNew, v.popUpWay)"><img
            src="~@/assets/img/smoke_d.png" alt="" @click="v.dialogWaterIndexList = false"></div>
        </div>
      </el-dialog>
    </div>
    <!--积水监测报警自动弹框-->
    <div v-for="v in dialogJishuiList" :key="v.id">
      <el-dialog :visible.sync="v.dialogJishuiIndex"
                 :title="v.HiddenTitle"
                 :close-on-click-modal="false" width="592px" :style="v.style"
                 show-close v-dialogDrag
                 :custom-class="isButt_dwdl ? 'q-dialog q-dialog-left' : 'q-dialog'" @close='handle_close_dialog(v)'
      >
        <div class="probeFun">
          <el-image style="width: 100%;  height: 328px; background:#fff" v-if="v.img" :src="v.img"
                    alt="图片未加载成功"></el-image>
          <div class="q-address" style="padding: 20px 0 0;"><span v-for="(line, i) in (v.msgTitle || '').split(',')" :key="i" style="margin-right: 10px;">{{ line }}</span></div>
          <div class="q-address" >{{ v.msgDetail }}</div>
          <div class="nowPolice" style="text-align:center;height: 10px">
            <!-- 1130 派单按钮打开 -->
            <!--            <img src="~@/assets/img/nowPolice.png" alt="" @click="fourKindAlarm(v, 'ljsb')">-->
            <!-- <img src="~@/assets/img/smoke_x.png"
                 alt=""
                 @click="errReport(v)"
                 v-if="distort"> -->
            <!--            <img src="~@/assets/img/newvideo2.png" alt="" @click="jumpVideo2_dwdl_ot(v)">-->
          </div>
        </div>
      </el-dialog>
    </div>

    <!--积水监测列表弹框-->
    <div v-for="v in dialogJishuiListNew" :key="v.id">
      <el-dialog :visible.sync="v.dialogJishuiIndexList" :close-on-click-modal="false" width="592px" :style="v.style"
                 show-close v-dialogDrag :custom-class="qdialog_smoke">
        <div class="autoContent">
          <div>
            <h1 style="color: #eae6e6;">{{ v.HiddenTitle }}</h1>
          </div>
          <div style="margin-top:41px;"><img v-if="v.img" :src="v.img" style="width:450px;height:300px" alt=""></div>
          <div class="jcjc-tag" style="padding: 20px 0 0;"><span v-for="(line, i) in (v.msgTitle || '').split(',')" :key="i" class="autoAddress">{{ line }}</span></div>
          <div class="autoAddress">{{ v.msgDetail }}</div>
          <div class="j-smoke-btn" @click="jishuiAutoReport(v.equipId, dialogJishuiListNew, v.popUpWay)"><img
            src="~@/assets/img/smoke_d.png" alt="" @click="v.dialogJishuiIndexList = false"></div>
        </div>
      </el-dialog>
    </div>

    <!--拉动-->
    <el-dialog :visible.sync="dialog.pullAlarmDialog" width="592px" show-close height="55%" custom-class="pull-dialog">
      <div class="autoContent">
        <div>
          <h1 style="margin-top: 6%;color: white;">消防拉动命令,请接收</h1>
        </div>
        <div class="j-smoke-btn"><img src="~@/assets/img/pullQuery.png" alt="" style=" margin-top: 16%;"
                                      @click="actionPull"></div>
      </div>
    </el-dialog>

    <!-- 微信隐患 -->
    <div v-for="v in dialogHiddenList" :key="v.id">
      <el-dialog :visible.sync="v.dialogHiddenIndex" width="592px" :style="v.style" show-close v-dialogDrag
                 :close-on-click-modal="false" custom-class="auto-dialog1">
        <div class="autoContent">
          <div>
            <h1 style="color: #eae6e6;">{{ v.HiddenTitle }}<span v-show="v.num > 1"><span
              style="color:#d03838">&nbsp;&nbsp;{{ v.num }}</span> 次</span></h1>
          </div>
          <div style="margin-top:41px;"><img src="~@/assets/img/smoke_c.png" alt=""></div>
          <div class="autoAddress">{{ v.msgDetail }}</div>
          <!-- <div class="j-smoke-btn" @click="pinkAlarm(v.alarmId, dialogHiddenList, v.popUpWay)"><img
              src="~@/assets/img/smoke_d.png" alt="" @click="v.dialogHiddenIndex = false"></div> -->
        </div>
      </el-dialog>
    </div>

    <!-- 通知催告 -->
    <div v-for="v in dialogSummonList" :key="v.id">
      <el-dialog :visible.sync="v.dialogSummonIndex" width="400px" :style="v.style" show-close v-dialogDrag
                 :close-on-click-modal="false" custom-class="auto-dialog1 summon-dialog">
        <div class="autoContent">
          <div>
            <h1 style="color: #eae6e6;">{{ v.HiddenTitle }}</h1>
          </div>
          <div style="margin-top:41px;"></div>
          <div class="j-smoke-btn" @click="summonAlarm(v)">
            <button @click="v.dialogSummonIndex = false">{{
                v.ref.msgBtn
              }}
            </button>
          </div>
        </div>
      </el-dialog>
    </div>

    <!--微信隐患列表-->
    <div v-for="v in dialogHiddenListNew" :key="v.id">
      <el-dialog :visible.sync="v.dialogHiddenIndexList" width="592px" :style="v.style" show-close v-dialogDrag
                 :close-on-click-modal="closeOnClickModal" custom-class="auto-dialog1 wache">
        <div class="autoContent">
          <div>
            <h1 style="color: #eae6e6;">{{ v.HiddenTitle }}</h1>
          </div>
          <div style="margin-top:41px;"><img src="~@/assets/img/smoke_c.png" alt=""></div>
          <div class="autoAddress">{{ v.msgDetail }}</div>
          <div class="j-smoke-btn" @click="pinkAlarm(v.alarmId, dialogHiddenListNew, v.popUpWay)"><img
            src="~@/assets/img/smoke_d.png" alt="" @click="v.dialogHiddenIndexList = false"></div>
        </div>
      </el-dialog>
    </div>

    <!-- 微信防火 -->
    <div v-for="v in dialogfhHiddenList" :key="v.id">
      <el-dialog :visible.sync="v.dialogfhHiddenIndex" width="592px" :style="v.style" show-close v-dialogDrag
                 :close-on-click-modal="closeOnClickModal" custom-class="auto-dialog1">
        <div class="autoContent">
          <div>
            <h1 style="color: #eae6e6;">{{ v.HiddenTitle }}<span v-show="v.num > 1"><span
              style="color:#d03838">&nbsp;&nbsp;{{ v.num }}</span> 次</span></h1>
          </div>
          <div style="margin-top:41px;"><img src="~@/assets/img/smoke_c.png" alt=""></div>
          <div class="autoAddress">{{ v.msgDetail }}</div>
          <div class="j-smoke-btn" @click="pinkAlarmFh(v.alarmId, dialogfhHiddenList, v.popUpWay)"><img
            src="~@/assets/img/smoke_d.png" alt="" @click="v.dialogfhHiddenIndex = false"></div>
        </div>
      </el-dialog>
    </div>

    <!-- 微信防火列表 -->
    <div v-for="v in dialogfhHiddenListNew" :key="v.id">
      <el-dialog :visible.sync="v.dialogfhHiddenIndexList" width="592px" :style="v.style" show-close v-dialogDrag
                 :close-on-click-modal="closeOnClickModal" custom-class="auto-dialog1">
        <div class="autoContent">
          <div>
            <h1 style="color: #eae6e6;">{{ v.HiddenTitle }}</h1>
          </div>
          <div style="margin-top:41px;">
            <img v-if="v.filePath" style="width:200px;height:300px" :src="`${resourceBase()}${v.filePath}`"
                 alt="">
            <img v-else src="~@/assets/img/smoke_c.png" alt="">
          </div>
          <div class="autoAddress">{{ v.msgDetail }}</div>
          <div class="j-smoke-btn" @click="pinkAlarmFh(v.alarmId, dialogfhHiddenListNew, v.popUpWay)"><img
            src="~@/assets/img/smoke_d.png" alt="" @click="v.dialogfhHiddenIndexList = false"></div>
        </div>
      </el-dialog>
    </div>

    <!-- 手报报警调度派单 -->
    <el-dialog :visible.sync="handAlarmDialog" class="endNoticeDialog">
      <handAlarmOrder></handAlarmOrder>
    </el-dialog>

    <el-dialog :visible.sync="microStationDialog" width="939px" class="endNoticeDialog">
      <microStation></microStation>
    </el-dialog>

    <!-- 审核页面 -->
    <el-dialog title="提示" :visible.sync="dialog.reviewDialog" width="939px" class="endNoticeDialog">
      <reviewDialog></reviewDialog>
    </el-dialog>

    <!-- 探头预警 -->
    <el-dialog :visible.sync="dialog.probeAlarmDialog" :close-on-click-modal='false' width="1050px"
               title="电动车报警调度派单"
               style="height:800px;overflow-y:scroll;" class="endNoticeDialog electric-wrapper">
      <el-card shadow="never">
        <el-row>
          <el-col :span="6" v-for="(item, index) in probeList" :key="index" style="margin: 0px 0px 20px;">
            <!-- <p>{{ item.floor.split("-").length == 1 ? item.floor : item.floor.split("-")[1] }}</p> -->
            <el-checkbox-group v-model="selectCjPersons">
              <el-checkbox :key="item.id" :label="item.id">{{ item.createAt }}</el-checkbox>
            </el-checkbox-group>
            <el-image :src="item.pictureUrl" alt="" :preview-src-list="srcList" style="width:200px;"></el-image>

          </el-col>
        </el-row>
      </el-card>
      <div slot="footer" style="text-align: center">
        <el-button type="primary" @click="generateAlarm">立即接警</el-button>
        <el-button type="primary" @click="closeTab">关闭窗口</el-button>
      </div>
    </el-dialog>

    <!-- 生成报警 target="_blank" -->
    <el-dialog :visible.sync="dialog.probeAlarmShow" class="endNoticeDialog" width="939px" title="" append-to-body
               show-close center :close-on-click-modal='false'>
      <probeAlarmShow ref="probeAlarmShow" :alarmId="alarmId" @happenClose="happenClose"></probeAlarmShow>
    </el-dialog>

    <!-- 实时视频 -->
    <el-dialog :visible.sync="dialog.nowVideoDialog" width="939px" class="endNoticeDialog" show-close>
    </el-dialog>

    <!-- 电动车报警-->
    <div v-for="(v, i) in dialogCameraDdcList" :key="i">
      <el-dialog :title="v.num > 1 ? v.initPopUp + ' ' + v.num + ' 次' : v.initPopUp" :style="v.style"
                 :visible.sync="v.dialogCameraIndexDdc" show-close v-dialogDrag ref="pinkeyeRef"
                 :close-on-click-modal="false"
                 :custom-class="isButt_ddc ? 'q-dialog q-dialog-left' : 'q-dialog'" @close='handle_close_dialog(v)'>
        <div class="probeFun">

          <el-image style="width: 100%;  height: 328px; background:#fff" :src="v.img" :preview-src-list="pinkUrls"
                    alt="图片未加载成功"></el-image>
          <div class="q-address" >{{ v.msgDetail }}</div>
          <!-- 车牌号 -->
          <div class="proBot">车牌号:{{ v.license ? v.license : '暂无' }}</div>
          <div class="nowPolice" style="text-align:center;">
            <!-- 1130 派单按钮打开 -->
            <img src="~@/assets/img/nowPolice.png" alt="" @click="openFireBookDetail(v); v.dialogCameraIndexDdc = false">
            <!-- <img src="~@/assets/img/smoke_x.png"
                 alt=""
                 @click="errReport(v)"
                 v-if="distort"> -->
            <img src="~@/assets/img/close-video-icon.png" alt="" v-if="isButt_ddc" @click="jumpVideo2_ddc(v)">
            <img src="~@/assets/img/newvideo2.png" v-else @click="jumpVideo2_ddc_ot(v)">
          </div>
        </div>
      </el-dialog>
    </div>

    <!-- 电动车列表-->
    <div v-for="(v, i) in dialogCameraDdcListNew" :key="i">
      <el-dialog :title="v.initPopUp" :style="v.style" :visible.sync="v.dialogCameraIndexDdcList" show-close
                 v-dialogDrag
                 ref="pinkeyeRef" :close-on-click-modal="false"
                 :custom-class="isButt_ddc ? 'q-dialog q-dialog-left' : 'q-dialog'"
                 @close='handle_close_dialog(v)'>
        <div class="probeFun">
          <el-image style="width: 100%;  height: 328px; background:#fff" :src="v.img" :preview-src-list="pinkUrls"
                    alt="图片未加载成功"></el-image>
          <div class="q-address" >{{ v.msgDetail }}</div>
          <div class="nowPolice" style="text-align:center;">
            <img src="~@/assets/img/nowPolice.png" alt="" @click="openFireBookDetail(v); v.dialogCameraIndexDdcList = false">
            <!-- <img src="~@/assets/img/smoke_x.png"
                 alt=""
                 @click="errReport(v)"
                 v-if="distort"> -->
            <img src="~@/assets/img/close-video-icon.png" alt="" v-if="isButt_ddc" @click="jumpVideo2_ddc(v)">
            <img src="~@/assets/img/newvideo2.png" v-else @click="jumpVideo2_ddc_ot(v)">
          </div>
        </div>
      </el-dialog>
    </div>

    <!-- 共享单车报警-->
    <div v-for="(v, i) in dialogCameraGxcheList" :key="i">
      <el-dialog :title="v.num > 1 ? v.initPopUp + ' ' + v.num + ' 次' : v.initPopUp" :style="v.style"
                 :visible.sync="v.dialogCameraIndexGxche" show-close v-dialogDrag ref="pinkeyeRef"
                 :close-on-click-modal="false"
                 :custom-class="isButt_gxche ? 'q-dialog q-dialog-left' : 'q-dialog'" @close='handle_close_dialog(v)'>
        <div class="probeFun">

          <el-image style="width: 100%;  height: 328px; background:#fff" :src="v.img" :preview-src-list="pinkUrls"
                    alt="图片未加载成功"></el-image>
          <div class="q-address" >{{ v.msgDetail }}</div>
          <!-- 车牌号 -->
          <div class="proBot">车牌号:{{ v.license ? v.license : '暂无' }}</div>
          <div class="nowPolice" style="text-align:center;">
            <!-- 1130 派单按钮打开 -->
            <img src="~@/assets/img/nowPolice.png" alt="" @click="fourKindAlarm(v, 'gxche')">
            <img src="~@/assets/img/close-video-icon.png" alt="" v-if="isButt_gxche" @click="jumpVideo2_gxche(v)">
            <img src="~@/assets/img/newvideo2.png" v-else @click="jumpVideo2_gxche_ot(v)">
          </div>
        </div>
      </el-dialog>
    </div>

    <!-- 共享单车列表-->
    <div v-for="(v, i) in dialogCameraGxcheListNew" :key="i">
      <el-dialog :title="v.initPopUp" :style="v.style" :visible.sync="v.dialogCameraIndexGxcheList" show-close
                 v-dialogDrag
                 ref="pinkeyeRef" :close-on-click-modal="false"
                 :custom-class="isButt_gxche ? 'q-dialog q-dialog-left' : 'q-dialog'"
                 @close='handle_close_dialog(v)'>
        <div class="probeFun">
          <el-image style="width: 100%;  height: 328px; background:#fff" :src="v.img" :preview-src-list="pinkUrls"
                    alt="图片未加载成功"></el-image>
          <div class="q-address" >{{ v.msgDetail }}</div>
          <div class="nowPolice" style="text-align:center;">
            <img src="~@/assets/img/nowPolice.png" alt="" @click="fourKindAlarm(v, 'gxcheList')">
            <img src="~@/assets/img/close-video-icon.png" alt="" v-if="isButt_gxche" @click="jumpVideo2_gxche(v)">
            <img src="~@/assets/img/newvideo2.png" v-else @click="jumpVideo2_gxche_ot(v)">
          </div>
        </div>
      </el-dialog>
    </div>

    <!-- 电池报警-->
    <div v-for="(v, i) in dialogCameraDcList" :key="i">
      <el-dialog :title="v.num > 1 ? v.initPopUp + ' ' + v.num + ' 次' : v.initPopUp" :style="v.style"
                 :visible.sync="v.dialogCameraIndexDc" show-close v-dialogDrag ref="pinkeyeRef"
                 :close-on-click-modal="false"
                 :custom-class="isButt_dc ? 'q-dialog q-dialog-left' : 'q-dialog'" @close='handle_close_dialog(v)'>
        <div class="probeFun">
          <el-image style="width: 100%;  height: 328px; background:#fff" :src="v.img" :preview-src-list="pinkUrls"
                    alt="图片未加载成功"></el-image>
<!--          <div class="q-video" v-if="isButt_dc">-->
<!--            <div class="q-video-inside" style="width:580px;height:566px;margin:-30px auto 0;">-->
<!--              <div :id='v.id' class="video-paading"></div>-->
<!--              <div class="el-icon-close" title="关闭实时视频" @click="iconClose_video(v)"></div>-->
<!--            </div>-->
<!--            <el-row style="text-align:center;padding-top:20px" v-show="player_voice.forbid">-->
<!--              <el-button type="primary" @click="voice_open" size="small" v-show="player_voice.sign">开启对讲</el-button>-->
<!--              <el-button type="danger" @click="voice_close" size="small" v-show="!player_voice.sign">关闭对讲-->
<!--              </el-button>-->
<!--            </el-row>-->
<!--          </div>-->
          <div class="q-address" >{{ v.msgDetail }}</div>
          <div class="nowPolice" style="text-align:center;">
            <img src="~@/assets/img/nowPolice.png" alt="" @click="openFireBookDetail(v); v.dialogCameraIndexDc = false">
            <img src="~@/assets/img/pull-icon-quer.png" alt="" @click="v.dialogCameraIndexDc = false">
<!--            <img src="~@/assets/img/smoke_x.png" alt="" @click="errReport(v)" v-if="distort">-->
<!--            <img src="~@/assets/img/close-video-icon.png" alt="" v-if="isButt_dc" @click="jumpVideo2_dc(v)">-->
<!--            <img src="~@/assets/img/newvideo2.png" v-else @click="jumpVideo2_dc(v)">-->
          </div>
        </div>
      </el-dialog>
    </div>

    <!-- 电池列表-->
    <div v-for="(v, i) in dialogCameraDcListNew" :key="i">
      <el-dialog :title="v.initPopUp" :style="v.style" :visible.sync="v.dialogCameraIndexDcList" show-close v-dialogDrag
                 ref="pinkeyeRef" :close-on-click-modal="false"
                 :custom-class="isButt_dc ? 'q-dialog q-dialog-left' : 'q-dialog'"
                 @close='handle_close_dialog(v)'>
        <div class="probeFun">
          <el-image style="width: 100%;  height: 328px; background:#fff" :src="v.img" :preview-src-list="pinkUrls"
                    alt="图片未加载成功"></el-image>
          <div class="q-video" v-if="isButt_dc">
            <div class="q-video-inside" style="width:580px;height:566px;margin:-30px auto 0;">
              <div :id='v.id' class="video-paading"></div>
              <div class="el-icon-close" title="关闭实时视频" @click="iconClose_video(v)"></div>
            </div>
            <el-row style="text-align:center;padding-top:20px" v-show="player_voice.forbid">
              <el-button type="primary" @click="voice_open" size="small" v-show="player_voice.sign">开启对讲</el-button>
              <el-button type="danger" @click="voice_close" size="small" v-show="!player_voice.sign">关闭对讲
              </el-button>
            </el-row>
          </div>
          <div class="q-address" >{{ v.msgDetail }}</div>
          <div class="nowPolice" style="text-align:center;">
            <img src="~@/assets/img/nowPolice.png" alt="" @click="openFireBookDetail(v); v.dialogCameraIndexDcList = false">
            <img src="~@/assets/img/smoke_x.png" alt="" @click="errReport(v)" v-if="distort">
            <img src="~@/assets/img/close-video-icon.png" alt="" v-if="isButt_dc" @click="jumpVideo2_dc(v)">
            <img src="~@/assets/img/newvideo2.png" v-else @click="jumpVideo2_dc(v)">
          </div>
        </div>
      </el-dialog>
    </div>

    <!-- rfid报警-->
    <div v-for="(v, i) in dialogCameraRfidList" :key="i">
      <el-dialog :title="v.num > 1 ? v.initPopUp + ' ' + v.num + ' 次' : v.initPopUp" :style="v.style"
                 :visible.sync="v.dialogCameraIndexRfid" show-close v-dialogDrag ref="pinkeyeRef"
                 :close-on-click-modal="false"
                 :custom-class="isButt_rfid ? 'q-dialog q-dialog-left' : 'q-dialog'" @close='handle_close_dialog(v)'>
        <div class="probeFun">
          <el-image style="width: 100%;  height: 328px; background:#fff" :src="v.img" :preview-src-list="pinkUrls"
                    alt="图片未加载成功"></el-image>
          <div class="q-video" v-if="isButt_rfid">
            <div class="q-video-inside" style="width:580px;height:566px;margin:-30px auto 0;">
              <div :id='v.id' class="video-paading"></div>
              <div class="el-icon-close" title="关闭实时视频" @click="iconClose_video(v)"></div>
            </div>
            <el-row style="text-align:center;padding-top:20px" v-show="player_voice.forbid">
              <el-button type="primary" @click="voice_open" size="small" v-show="player_voice.sign">开启对讲</el-button>
              <el-button type="danger" @click="voice_close" size="small" v-show="!player_voice.sign">关闭对讲
              </el-button>
            </el-row>
          </div>
          <div class="proBot"><span>{{ v.msgDetail }}</span></div>
          <div class="nowPolice" style="text-align:center;">
            <!-- <img src="~@/assets/img/nowPolice.png" alt="" @click="fourKindAlarm(v, 'rfid')"> -->
            <img src="~@/assets/img/smoke_x.png" alt="" @click="errReport(v)" v-if="distort">
            <img src="~@/assets/img/close-video-icon.png" alt="" v-if="isButt_rfid" @click="jumpVideo2_rfid(v)">
            <img src="~@/assets/img/newvideo2.png" v-else @click="jumpVideo2_rfid(v)">
          </div>
        </div>
      </el-dialog>
    </div>

    <!-- rfid列表-->
    <div v-for="(v, i) in dialogCameraRfidListNew" :key="i">
      <el-dialog :title="v.initPopUp" :style="v.style" :visible.sync="v.dialogCameraIndexRfidList" show-close
                 v-dialogDrag
                 ref="pinkeyeRef" :close-on-click-modal="false"
                 :custom-class="isButt_rfid ? 'q-dialog q-dialog-left' : 'q-dialog'"
                 @close='handle_close_dialog(v)'>
        <div class="probeFun">
          <el-image style="width: 100%;  height: 328px; background:#fff" :src="v.img" :preview-src-list="pinkUrls"
                    alt="图片未加载成功"></el-image>
          <div class="q-video" v-if="isButt_rfid">
            <div class="q-video-inside" style="width:580px;height:566px;margin:-30px auto 0;">
              <div :id='v.id' class="video-paading"></div>
              <div class="el-icon-close" title="关闭实时视频" @click="iconClose_video(v)"></div>
            </div>
            <el-row style="text-align:center;padding-top:20px" v-show="player_voice.forbid">
              <el-button type="primary" @click="voice_open" size="small" v-show="player_voice.sign">开启对讲</el-button>
              <el-button type="danger" @click="voice_close" size="small" v-show="!player_voice.sign">关闭对讲
              </el-button>
            </el-row>
          </div>
          <div class="q-address" >{{ v.msgDetail }}</div>
          <div class="nowPolice" style="text-align:center;">
            <!-- <img src="~@/assets/img/nowPolice.png" alt="" @click="fourKindAlarm(v, 'rfidList')"> -->
            <img src="~@/assets/img/smoke_x.png" alt="" @click="errReport(v)" v-if="distort">
            <img src="~@/assets/img/close-video-icon.png" alt="" v-if="isButt_rfid" @click="jumpVideo2_rfid(v)">
            <img src="~@/assets/img/newvideo2.png" v-else @click="jumpVideo2_rfid(v)">
          </div>
        </div>
      </el-dialog>
    </div>

    <!--手报报警-->
    <div v-for="(v, i) in dialogList" :key="i">
      <el-dialog :title="v.num > 1 ? v.HiddenTitle + ' ' + v.num + ' 次' : v.HiddenTitle" :visible.sync="v.dialogIndex"
                 :close-on-click-modal="false" :style="v.style" show-close v-dialogDrag
                 :custom-class="isButt_sb ? 'q-dialog q-dialog-left' : 'q-dialog'" @close="handle_close_dialog(v)">
        <div class="probeFun">
          <!-- <div style="width: 100%;  height: 410px;">
              <div style=" height: 170px;"></div>
              <div class="autoAddress" style="margin-bottom: 27px;font-size:24px;color:#fff;text-align:center">{{ v.msgDetail }}</div>
            </div> -->
          <div class="proBot" style="width: 100%;height: 360px;background:#fff;margin-bottom:20px;padding:0px">
            <div :id="'lnglatAlarm' + v.id" style="height:360px;" v-if="v.alarmMap"></div>
            <div :id="'lnglatAlarm' + v.id"
                 style="height:360px;display:flex;justify-content: center; align-items: center;" v-else><span
              style="display:flex;width:auto;color:#857f7f;font-size:12px;">该设备无经纬度信息！</span></div>
          </div>
          <div style="font-size:18px;color:#fff;">报警时间:{{ v.createTime }}</div>
          <div class="q-video" v-if="isButt_sb">
            <div class="q-video-inside" style="width:580px;height:566px;margin:-30px auto 0;">
              <div :id='v.id' class="video-paading"></div>
              <div class="el-icon-close" title="关闭实时视频" @click="iconClose_video(v)"></div>
            </div>
            <el-row style="text-align:center;padding-top:20px" v-show="player_voice.forbid">
              <el-button type="primary" @click="voice_open" size="small" v-show="player_voice.sign">开启对讲</el-button>
              <el-button type="danger" @click="voice_close" size="small" v-show="!player_voice.sign">关闭对讲
              </el-button>
            </el-row>
          </div>
          <div class="nowPolice" style="text-align:center;">
            <!-- <img src="~@/assets/img/nowPolice.png" alt="" @click="handAutoReport(v.equipId, dialogList, v.popUpWay)"> -->
            <!-- <img src="~@/assets/img/smoke_x.png"
                 alt=""
                 @click="errReport(v)"
                 v-if="distort"> -->
            <span style="display:inline-block;width:100%" v-if="camera_id">
              <img style="width:30%" src="~@/assets/img/close-video-icon.png" alt="" v-if="isButt_sb"
                   @click="jumpVideo2_sb(v)">
              <img style="width:30%" src="~@/assets/img/newvideo2.png" v-else @click="jumpVideo2_sb(v)">
            </span>
          </div>
        </div>
      </el-dialog>
    </div>

    <!--手报列表弹框-->
    <div v-for="(v, i) in dialogListNew" :key="i">
      <el-dialog :title="v.HiddenTitle" :visible.sync="v.dialogIndexList" :close-on-click-modal="false" :style="v.style"
                 show-close v-dialogDrag :custom-class="isButt_sb ? 'q-dialog q-dialog-left' : 'q-dialog'"
                 @close="handle_close_dialog(v)">
        <div class="probeFun">
          <!-- <div style="width: 100%;  height: 410px;">
            <div style=" height: 170px;"></div>
            <div class="autoAddress" style="margin-bottom: 27px;font-size:24px;color:#fff;text-align:center">{{ v.msgDetail }}</div>
          </div> -->
          <div class="proBot" style="width: 100%;height: 360px;background:#fff;margin-bottom:20px;padding:0px">
            <div :id="'lnglatAlarm' + v.id" style="height:360px;" v-if="v.alarmMap"></div>
            <div :id="'lnglatAlarm' + v.id"
                 style="height:360px;display:flex;justify-content: center; align-items: center;" v-else><span
              style="display:flex;width:auto;color:#857f7f;font-size:12px;">该设备无经纬度信息！</span></div>
          </div>
          <div style="font-size:18px;color:#fff;">报警时间:{{ v.createTime }}</div>
          <div class="q-video" v-if="isButt_sb">
            <div class="q-video-inside" style="width:580px;height:566px;margin:-30px auto 0;">
              <div :id='v.id' class="video-paading"></div>
              <div class="el-icon-close" title="关闭实时视频" @click="iconClose_video(v)"></div>
            </div>
            <el-row style="text-align:center;padding-top:20px" v-show="player_voice.forbid">
              <el-button type="primary" @click="voice_open" size="small" v-show="player_voice.sign">开启对讲</el-button>
              <el-button type="danger" @click="voice_close" size="small" v-show="!player_voice.sign">关闭对讲
              </el-button>
            </el-row>
          </div>
          <div class="nowPolice" style="text-align:center;">
            <!-- <img src="~@/assets/img/nowPolice.png" alt="" @click="handAutoReport(v.equipId, dialogListNew, v.popUpWay)"> -->
            <img src="~@/assets/img/smoke_x.png" alt="" @click="errReport(v)" v-if="distort">
            <span v-if="camera_id">
              <img src="~@/assets/img/close-video-icon.png" alt="" v-if="isButt_sb" @click="jumpVideo2_sb(v)">
              <img src="~@/assets/img/newvideo2.png" v-else @click="jumpVideo2_sb(v)">
            </span>
          </div>
        </div>
      </el-dialog>
    </div>

    <!-- 火眼报警-->
    <div v-for="(v, i) in dialogCameraList" :key="i">
      <el-dialog :title="v.num > 1 ? v.initPopUp + ' ' + v.num + ' 次' : v.initPopUp" :style="v.style"
                 :visible.sync="v.dialogCameraIndexHy" show-close v-dialogDrag ref="pinkeyeRef"
                 :close-on-click-modal="false"
                 :custom-class="isButt_hy ? 'q-dialog q-dialog-left' : 'q-dialog'" @close='handle_close_dialog(v)'>
        <div class="probeFun">
          <el-image style="width: 100%;  height: 328px; background:#fff" :src="v.img" :preview-src-list="pinkUrls"
                    alt="图片未加载成功"></el-image>
          <div class="q-address" >{{ v.msgDetail }}</div>
          <div class="nowPolice" style="text-align:center;">
            <!-- 1130 派单按钮打开 -->
            <img src="~@/assets/img/pull-icon-quer.png" alt="" @click="v.dialogCameraIndexHy = false">
<!--            <img src="~@/assets/img/nowPolice.png" alt="" @click="fourKindAlarm(v, 'hy')">-->
            <!-- <img src="~@/assets/img/smoke_x.png"
                 alt=""
                 @click="errReport(v)"
                 v-if="distort"> -->
<!--            <img src="~@/assets/img/close-video-icon.png" alt="" v-if="isButt_hy" @click="jumpVideo2_hy(v)">-->
<!--            <img src="~@/assets/img/newvideo2.png" v-else @click="jumpVideo2_hy_ot(v)">-->
          </div>
        </div>
      </el-dialog>
    </div>

    <!-- 火眼报警列表-->
    <div v-for="(v, i) in dialogCameraListNew" :key="i">
      <el-dialog :title="v.initPopUp" :style="v.style" :visible.sync="v.dialogCameraIndexHyList" show-close v-dialogDrag
                 ref="pinkeyeRef" :close-on-click-modal="false"
                 :custom-class="isButt_hy ? 'q-dialog q-dialog-left' : 'q-dialog'"
                 @close='handle_close_dialog(v)'>
        <div class="probeFun">
          <el-image style="width: 100%;  height: 328px;background:#fff" :src="v.img" :preview-src-list="pinkUrls"
                    alt="图片未加载成功"></el-image>
          <div class="q-address" >{{ v.msgDetail }}</div>
          <div class="nowPolice" style="text-align:center;">
            <!-- 1130 派单按钮打开 -->
            <img src="~@/assets/img/pull-icon-quer.png" alt="" @click="v.dialogCameraIndexHyList = false">
<!--            <img src="~@/assets/img/nowPolice.png" alt="" @click="fourKindAlarm(v, 'hyList')">-->
            <!-- <img src="~@/assets/img/smoke_x.png"
                 alt=""
                 @click="errReport(v)"
                 v-if="distort"> -->
<!--            <img src="~@/assets/img/close-video-icon.png" alt="" v-if="isButt_hy" @click="jumpVideo2_hy(v)">-->
<!--            <img src="~@/assets/img/newvideo2.png" v-else @click="jumpVideo2_hy_ot(v)">-->
          </div>
        </div>
      </el-dialog>
    </div>

    <!-- 后厨报警-->
    <div v-for="(v, i) in dialogCameraCfList" :key="i">
      <el-dialog :title="v.num > 1 ? v.initPopUp + ' ' + v.num + ' 次' : v.initPopUp" :style="v.style"
                 :visible.sync="v.dialogCameraIndexCf" show-close v-dialogDrag ref="pinkeyeRef"
                 :close-on-click-modal="false"
                 :custom-class="isButt_cf ? 'q-dialog q-dialog-left' : 'q-dialog'" @close='handle_close_dialog(v)'>
        <div class="probeFun">
          <el-image style="width: 100%;  height: 328px; background:#fff" :src="v.img" :preview-src-list="pinkUrls"
                    alt="图片未加载成功"></el-image>
          <div class="q-video q-video-open" v-if="isButt_cf">
            <div class="q-video-inside" style="width:580px;height:566px;margin:-30px auto 0;">
              <div :id='v.id' class="video-paading"></div>
              <div class="el-icon-close" title="关闭实时视频" @click="iconClose_video(v)"></div>
            </div>
            <el-row style="text-align:center;padding-top:20px" v-show="player_voice.forbid">
              <el-button type="primary" @click="voice_open" size="small" v-show="player_voice.sign">开启对讲</el-button>
              <el-button type="danger" @click="voice_close" size="small" v-show="!player_voice.sign">关闭对讲
              </el-button>
            </el-row>
          </div>
          <div class="q-address" >{{ v.msgDetail }}</div>
          <div class="nowPolice" style="text-align:center;">
            <!-- <img src="~@/assets/img/nowPolice.png" alt="" @click="fourKindAlarm(v, 'cf')"> -->
            <!-- <img src="~@/assets/img/smoke_x.png"
                 alt=""
                 @click="errReport(v)"
                 v-if="distort"> -->
            <img src="~@/assets/img/close-video-icon.png" alt="" v-if="isButt_cf" @click="jumpVideo2_cf(v)">
            <img src="~@/assets/img/newvideo2.png" v-else @click="jumpVideo2_cf(v)">
          </div>
        </div>
      </el-dialog>
    </div>

    <!-- 后厨报警列表-->
    <div v-for="(v, index) in dialogCameraCfListNew" :key="index">
      <el-dialog :title="v.initPopUp" :style="v.style" :visible.sync="v.dialogCameraIndexCfList" show-close v-dialogDrag
                 ref="pinkeyeRef" :close-on-click-modal="false"
                 :custom-class="isButt_cf ? 'q-dialog q-dialog-left' : 'q-dialog'"
                 @close='handle_close_dialog(v)'>
        <div class="probeFun">
          <el-image style="width: 100%;  height: 328px;background:#fff" :src="v.img" :preview-src-list="pinkUrls"
                    alt="图片未加载成功"></el-image>
          <div class="q-video" v-if="isButt_cf">
            <div class="q-video-inside" style="width:580px;height:566px;margin:-30px auto 0;">
              <div :id='v.id' class="video-paading"></div>
              <div class="el-icon-close" title="关闭实时视频" @click="iconClose_video(v)"></div>
            </div>
            <el-row style="text-align:center;padding-top:20px" v-show="player_voice.forbid">
              <el-button type="primary" @click="voice_open" size="small" v-show="player_voice.sign">开启对讲</el-button>
              <el-button type="danger" @click="voice_close" size="small" v-show="!player_voice.sign">关闭对讲
              </el-button>
            </el-row>
          </div>
          <div class="q-address" >{{ v.msgDetail }}</div>
          <div class="nowPolice" style="text-align:center;">
            <!-- <img src="~@/assets/img/nowPolice.png" alt="" @click="fourKindAlarm(v, 'cfList')"> -->
            <!-- <img src="~@/assets/img/smoke_x.png"
                 alt=""
                 @click="errReport(v)"
                 v-if="distort"> -->
            <img src="~@/assets/img/close-video-icon.png" alt="" v-if="isButt_cf" @click="jumpVideo2_cf(v)">
            <img src="~@/assets/img/newvideo2.png" v-else @click="jumpVideo2_cf(v)">
          </div>
        </div>
      </el-dialog>
    </div>

    <!-- 堆物堆料 -->
    <div v-for="(v, index) in dialogCameraDwdlList" :key="index">
      <el-dialog :title="v.num > 1 ? v.initPopUp + ' ' + v.num + ' 次' : v.initPopUp" :style="v.style"
                 :visible.sync="v.dialogCameraIndexDwdl" show-close v-dialogDrag ref="pinkeyeRef"
                 :close-on-click-modal="false"
                 :custom-class="isButt_dwdl ? 'q-dialog q-dialog-left' : 'q-dialog'" @close='handle_close_dialog(v)'>
        <div class="probeFun">
          <el-image style="width: 100%;  height: 328px; background:#fff" :src="v.img" :preview-src-list="pinkUrls"
                    alt="图片未加载成功"></el-image>
          <div class="q-address" >{{ v.msgDetail }}</div>
          <div class="nowPolice" style="text-align:center;">
            <!-- 1130 派单按钮打开 -->
<!--            <img src="~@/assets/img/nowPolice.png" alt="" @click="fourKindAlarm(v, 'dwdl')">-->
            <img src="~@/assets/img/pull-icon-quer.png" alt="" @click="v.dialogCameraIndexDwdl = false">
            <!-- <img src="~@/assets/img/smoke_x.png"
                 alt=""
                 @click="errReport(v)"
                 v-if="distort"> -->
<!--            <img src="~@/assets/img/newvideo2.png" alt="" @click="jumpVideo2_dwdl_ot(v)">-->
          </div>
        </div>
      </el-dialog>
    </div>

    <!-- 堆物堆料列表 -->
    <div v-for="(v, index) in dialogCameraDwdlListNew" :key="index">
      <el-dialog :title="v.initPopUp" :style="v.style" :visible.sync="v.dialogCameraIndexDwdlList" show-close
                 v-dialogDrag
                 ref="pinkeyeRef" :close-on-click-modal="false"
                 :custom-class="isButt_dwdl ? 'q-dialog q-dialog-left' : 'q-dialog'"
                 @close='handle_close_dialog(v)'>
        <div class="probeFun">
          <el-image style="width: 100%;  height: 328px; background:#fff" :src="v.img" :preview-src-list="pinkUrls"
                    alt="图片未加载成功"></el-image>
          <div class="q-address" >{{ v.msgDetail }}</div>
          <div class="nowPolice" style="text-align:center;">
            <img src="~@/assets/img/nowPolice.png" alt="" @click="fourKindAlarm(v, 'dwdlList')">
            <!--            <img src="~@/assets/img/smoke_x.png"-->
            <!--                 alt=""-->
            <!--                 @click="errReport(v)"-->
            <!--                 v-if="distort">-->
            <img src="~@/assets/img/newvideo2.png" alt="" @click="jumpVideo2_dwdl_ot(v)">
          </div>
        </div>
      </el-dialog>
    </div>

    <!-- 垃圾溢满 -->
    <div v-for="(v, index) in dialogCameraLjsbList" :key="index">
      <el-dialog :title="v.num > 1 ? v.initPopUp + ' ' + v.num + ' 次' : v.initPopUp" :style="v.style"
                 :visible.sync="v.dialogCameraIndexLjsb" show-close v-dialogDrag ref="pinkeyeRef"
                 :close-on-click-modal="false"
                 :custom-class="isButt_dwdl ? 'q-dialog q-dialog-left' : 'q-dialog'" @close='handle_close_dialog(v)'>
        <div class="probeFun">
          <el-image style="width: 100%;  height: 328px; background:#fff" :src="v.img" :preview-src-list="pinkUrls"
                    alt="图片未加载成功"></el-image>

          <div class="q-address" >{{ v.msgDetail }}</div>
          <div class="nowPolice" style="text-align:center;height: 10px">
            <!-- 1130 派单按钮打开 -->
<!--            <img src="~@/assets/img/nowPolice.png" alt="" @click="fourKindAlarm(v, 'ljsb')">-->
            <!-- <img src="~@/assets/img/smoke_x.png"
                 alt=""
                 @click="errReport(v)"
                 v-if="distort"> -->
<!--            <img src="~@/assets/img/newvideo2.png" alt="" @click="jumpVideo2_dwdl_ot(v)">-->
          </div>
        </div>
      </el-dialog>
    </div>

    <!--垃圾溢满列表 -->
    <div v-for="(v, index) in dialogCameraLjsbListNew" :key="index">
      <el-dialog :title="v.initPopUp" :style="v.style" :visible.sync="v.dialogCameraIndexLjsbList" show-close
                 v-dialogDrag
                 ref="pinkeyeRef" :close-on-click-modal="false"
                 :custom-class="isButt_dwdl ? 'q-dialog q-dialog-left' : 'q-dialog'"
                 @close='handle_close_dialog(v)'>
        <div class="probeFun">
          <el-image style="width: 100%;  height: 328px; background:#fff" :src="v.img" :preview-src-list="pinkUrls"
                    alt="图片未加载成功"></el-image>
          <div class="q-address" >{{ v.msgDetail }}</div>
          <div class="nowPolice" style="text-align:center;">
            <!-- <img src="~@/assets/img/smoke_x.png"
                 alt=""
                 @click="errReport(v)"
                 v-if="distort"> -->
            <img src="~@/assets/img/newvideo2.png" alt="" @click="jumpVideo2_dwdl_ot(v)">
          </div>
        </div>
      </el-dialog>
    </div>

    <!-- 防火门 -->
    <div v-for="(v, index) in dialogCameraFhmList" :key="index">
      <el-dialog :title="v.num > 1 ? v.initPopUp + ' ' + v.num + ' 次' : v.initPopUp" :style="v.style"
                 :visible.sync="v.dialogCameraIndexFhm" show-close v-dialogDrag ref="pinkeyeRef"
                 :close-on-click-modal="false"
                 :custom-class="isButt_fhm ? 'q-dialog q-dialog-left' : 'q-dialog'" @close="handle_close_dialog(v)">
        <div class="probeFun">
          <el-image style="width: 100%;  height: 328px; background:#fff" :src="v.img" :preview-src-list="pinkUrls"
                    alt="图片未加载成功"></el-image>
          <div class="q-address" >{{ v.msgDetail }}</div>
          <div class="nowPolice" style="text-align:center;">
            <!-- <img src="~@/assets/img/nowPolice.png" alt="" @click="fourKindAlarm(v, 'fhm')"> -->
            <!-- <img src="~@/assets/img/smoke_x.png"
                 alt=""
                 @click="errReport(v)"
                 v-if="distort"> -->
            <img src="~@/assets/img/close-video-icon.png" alt="" v-if="isButt_fhm === true" @click="jumpVideo2_fhm(v)">
            <img src="~@/assets/img/newvideo2.png" v-else @click="jumpVideo2_fhm_ot(v)">
          </div>
        </div>
      </el-dialog>
    </div>

    <!-- 防火门列表 -->
    <div v-for="(v, index) in dialogCameraFhmListNew" :key="index">
      <el-dialog :title="v.initPopUp" :style="v.style" :visible.sync="v.dialogCameraIndexFhmList" show-close
                 v-dialogDrag
                 ref="pinkeyeRef" :close-on-click-modal="false"
                 :custom-class="isButt_fhm ? 'q-dialog q-dialog-left' : 'q-dialog'"
                 @close="handle_close_dialog(v)">
        <div class="probeFun">
          <el-image style="width: 100%;  height: 328px; background:#fff" :src="v.img" :preview-src-list="pinkUrls"
                    alt="图片未加载成功"></el-image>
          <div class="q-address" >{{ v.msgDetail }}</div>
          <div class="nowPolice" style="text-align:center;">
            <!-- <img src="~@/assets/img/nowPolice.png" alt="" @click="fourKindAlarm(v, 'fhmList')"> -->
            <!-- <img src="~@/assets/img/smoke_x.png"
                 alt=""
                 @click="errReport(v)"
                 v-if="distort"> -->
            <img src="~@/assets/img/close-video-icon.png" alt="" v-if="isButt_fhm" @click="jumpVideo2_fhm(v)">
            <img src="~@/assets/img/newvideo2.png" v-else @click="jumpVideo2_fhm_ot(v)">
          </div>
        </div>
      </el-dialog>
    </div>

    <!-- 消防车道 -->
    <div v-for="(v, index) in dialogCameraXftdList" :key="index">
      <el-dialog :title="v.num > 1 ? v.initPopUp + ' ' + v.num + ' 次' : v.initPopUp" :style="v.style"
                 :visible.sync="v.dialogCameraIndexXftd" show-close v-dialogDrag ref="pinkeyeRef"
                 :close-on-click-modal="false"
                 :custom-class="isButt_xftd ? 'q-dialog q-dialog-left' : 'q-dialog'" @close="handle_close_dialog(v)">
        <div class="probeFun">
          <el-image style="width: 100%;  height: 328px; background:#fff" :src="v.img" :preview-src-list="pinkUrls"
                    alt="图片未加载成功"></el-image>
          <div class="q-address" >{{ v.msgDetail }}</div>
          <div class="nowPolice" style="text-align:center;">
            <!-- 1130 派单按钮打开 -->
            <img src="~@/assets/img/nowPolice.png" alt="" @click="fourKindAlarm(v, 'xftd')">
            <!-- <img src="~@/assets/img/smoke_x.png"
                 alt=""
                 @click="errReport(v)"
                 v-if="distort"> -->
            <img src="~@/assets/img/close-video-icon.png" alt="" v-if="isButt_xftd" @click="jumpVideo2_xftd(v)">
            <img src="~@/assets/img/newvideo2.png" v-else @click="jumpVideo2_xftd_ot(v)">
          </div>
        </div>
      </el-dialog>
    </div>

    <!-- 消防车道列表 -->
    <div v-for="(v, index) in dialogCameraXftdListNew" :key="index">
      <el-dialog :title="v.initPopUp" :style="v.style" :visible.sync="v.dialogCameraIndexXftdList" show-close
                 v-dialogDrag
                 ref="pinkeyeRef" :close-on-click-modal="false"
                 :custom-class="isButt_xftd ? 'q-dialog q-dialog-left' : 'q-dialog'"
                 @close="handle_close_dialog(v)">
        <div class="probeFun">
          <el-image style="width: 100%;  height: 328px;" :src="v.img" :preview-src-list="pinkUrls"></el-image>
          <div class="q-address" >{{ v.msgDetail }}</div>
          <div class="nowPolice" style="text-align:center;">
            <!-- 1130 派单按钮打开 -->
            <img src="~@/assets/img/nowPolice.png" alt="" @click="fourKindAlarm(v, 'xftdList')">
            <!-- <img src="~@/assets/img/smoke_x.png"
                 alt=""
                 @click="errReport(v)"
                 v-if="distort"> -->
            <img src="~@/assets/img/close-video-icon.png" alt="" v-if="isButt_xftd" @click="jumpVideo2_xftd(v)">
            <img src="~@/assets/img/newvideo2.png" v-else @click="jumpVideo2_xftd_ot(v)">
          </div>
        </div>
      </el-dialog>
    </div>

    <!-- 感温线缆 -->
    <div v-for="(v, index) in dialogCameraGwxlList" :key="'gwxl-' + index">
      <el-dialog
        :title="v.num > 1 ? v.initPopUp + ' ' + v.num + ' 次' : v.initPopUp"
        :style="v.style"
        width="622px"
        :visible.sync="v.dialogCameraIndexGwxl"
        show-close
        append-to-body
        v-dialogDrag
        ref="pinkeyeRef"
        :close-on-click-modal="false"
        custom-class="q-dialog gwxl-dialog-warp"
        @close="handle_close_dialog(v)"
        @open="openGwxlVideo(v)"
      >
        <div class="probeFun">
          <div class="gwxl-camera-tabs" v-if="v.videoRows && v.videoRows.length > 1">
            <span
              v-for="(cam, ci) in v.videoRows"
              :key="ci"
              :class="['gwxl-camera-tab', { active: v.activeCameraIndex === ci }]"
              @click="switchGwxlCamera(v, ci)"
            ><i class="el-icon-video-camera"></i> {{ cam.address || cam.address1 || ('摄像头' + (ci + 1)) }}</span>
          </div>
          <look-video
            :show-title="false"
            :window-close="false"
            :show-address="false"
            :key="v.id"
            :ref="'gwxlLookVideo' + v.id"
            class="gwxl-look-video"
            videoHeight="278"
            style="width: 100%; height: 278px; margin-top: 0; background: #fff"
            @closeVideo="closeGwxlVideo(v)"
            hidePadding
          />
          <div class="q-address" style="padding: 20px 0 0">报警内容：{{ v.alarmContent || '感温线缆温度异常，请及时处理' }}</div>
          <div class="q-address" style="padding: 2px 0">位置：{{ v.location || v.address || v.msgDetail || '暂无' }}</div>
        </div>
      </el-dialog>
    </div>

    <!-- 感温线缆列表 -->
    <div v-for="(v, index) in dialogCameraGwxlListNew" :key="'gwxl-list-' + index">
      <el-dialog
        :title="v.initPopUp"
        :style="v.style"
        width="622px"
        :visible.sync="v.dialogCameraIndexGwxlList"
        show-close
        append-to-body
        v-dialogDrag
        ref="pinkeyeRef"

        :close-on-click-modal="false"
        custom-class="q-dialog"
        @close="handle_close_dialog(v)"
        @open="openGwxlVideo(v)"
      >
        <div class="probeFun">
          <div class="gwxl-camera-tabs" v-if="v.videoRows && v.videoRows.length > 1">
            <span
              v-for="(cam, ci) in v.videoRows"
              :key="ci"
              :class="['gwxl-camera-tab', { active: v.activeCameraIndex === ci }]"
              @click="switchGwxlCamera(v, ci)"
            ><i class="el-icon-video-camera"></i> {{ cam.address || cam.address1 || ('摄像头' + (ci + 1)) }}</span>
          </div>
          <look-video
            :show-title="false"
            :window-close="false"
            :key="v.id"
            :ref="'gwxlLookVideo' + v.id"
            class="gwxl-look-video"
            videoHeight="278"
            style="width: 100%; height: 278px; background: #fff"
            @closeVideo="closeGwxlVideo(v)"
            hidePadding
          />
          <div class="q-address" style="padding: 5px 0">报警内容：{{ v.alarmContent || '感温线缆温度异常，请及时处理' }}</div>
<!--          <div class="q-address" style="padding: 5px 0">异常点位：{{ getGwxlPoint(v) || '暂无' }}</div>-->
          <div class="q-address" style="padding: 5px 0">位置：{{ v.location || v.address || v.msgDetail || '暂无' }}</div>
<!--          <div class="q-address" style="padding: 5px 0">报警时间：{{ v.alarmTimeText || v.alarmTime }}</div>-->
        </div>
      </el-dialog>
    </div>

    <!-- 设备误报 -->
    <el-dialog :visible.sync="dialog.errReportDialog" title="设备误报" width="400px" :close-on-click-modal='false'
               show-close
               custom-class="q-report">
      <el-form ref="errForm" :model="errForm" label-width="100px">
        <el-form-item label="误报内容">
          <el-input type="textarea" v-model="errForm.content" :rows="5" style="padding-right:40px"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleReport">提交</el-button>
          <el-button @click="dialog.errReportDialog = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog :visible.sync="dialog.pinkAlarmDialog" width="1200px" :title="dialogTitle" style="margin-top:-8vh;"
               :close-on-click-modal='false' show-close class="endNoticeDialog fire_margin" center>
      <firePink :alarmId="alarmId" @closePinkAlarmDialog="closePinkAlarmDialog" ref="firePink"></firePink>
    </el-dialog>

    <!-- 事件接报详情 -->
    <el-dialog :visible.sync="dialogVisible" v-if="fireBookDialog" :width="dialogWidth" title="报警详情"
               show-close append-to-body center custom-class="smoke-wrap" :class="{ 'red-theme-dialog': isRedStyleTp }" class="dialog"
               @close="closeFireBookDetail">
      <firePinkAlarm :dataFinish="dataFinish" :show-time="false" :alarmId="alarmId"></firePinkAlarm>
    </el-dialog>

    <!-- 审核页面 -->
    <el-dialog class="fireDoc" :close-on-click-modal='false' :visible.sync="dialog.handAlarmVisibled" width="30%"
               title="出动总结" append-to-body center>
      <el-input type="textarea" placeholder="请输入" v-model="content" maxlength="30" rows="10"
                show-word-limit></el-input>
      <div slot="footer" class="dialog-footer j-smoke-btn">
        <span>
          <el-button @click="auditInfo()"
                     style=" width: 206px; height: 43px; background: #0080db; border-radius: 22px; "
                     round type="primary">
            <label style="font-size: 18px; font-weight: bold; color: #fff">提交</label>
          </el-button>
        </span>
      </div>
    </el-dialog>
    <dialogBox :alarmId="alarmId" ref="dialogBox" @stopBellRing="stopBellRing()">
    </dialogBox>
    <!-- <div style="border:1px solid red;width:100px;"> -->
    <audio v-show="false" ref="audioJb" autoplay controls height="100" width="100" id="audioJb">
      <!-- <source :src="MP3List[videoSrcNum]"  type="audio/mpeg">
        <source :src="MP3List[videoSrcNum]" type="audio/ogg">
        <embed height="50" width="100" :src="MP3List[videoSrcNum]"> -->
      <source :src="MP3List[videoSrcNum]" type="audio/mpeg">
    </audio>
    <!-- </div> -->
  </div>
</template>
<script>
import {resourceBase} from "@/js/constants";

var dialogCameraIndex = 0; //报警摄像头
var dialogSytleIndex_hy = 0; //报警样式-火眼
var dialogSytleIndex_sb = 0; //报警样式-手报
var dialogSytleIndex_fhm = 0; //报警样式-防火门
var dialogSytleIndex_ddc = 0; //报警样式-电动车
var dialogSytleIndex_gxche = 0; //报警样式-共享单车
var dialogSytleIndex_dc = 0; //报警样式-电池
var dialogSytleIndex_rfid = 0; //报警样式-rfid
var dialogSytleIndex_xftd = 0; //报警样式-消防车道
var dialogSytleIndex_hb = 0; //报警样式-119、微信隐患、防火、防火巡查
var dialogSytleIndex_yg = 0; //报警样式-烟感
var dialogSytleIndex_dwdl = 0; //报警样式-堆物堆料
var dialogSytleIndex_sy = 0; //报警样式-水压
var dialogSytleIndex_cf = 0; //报警样式-后厨
var dialogSytleIndex_ghy = 0; //报警样式-光火眼
var dialogSytleIndex_spbj = 0; //报警样式-视频报警
var dialogSytleIndex_hjhy = 0; //报警样式-呼叫火眼
var dialogSytleIndex_dianti = 0; //报警样式-电梯报警
var dialogSytleIndex_ddcwgyj = 0; //报警样式-电动车违规报警
var dialogSytleIndex_wg = 0; //报警样式-温感
var dialogSytleIndex_jishui = 0; //报警样式-积水监测
var dialogSytleIndex_gwxl = 0; //报警样式-感温线缆

// 报警弹框视频id
// var dialogIndexList=0;  //报警手报
// var dialogSmokeIndexList=0;  //烟感
// var dialogHiddenIndexList=0;  //报警隐患
// var dialogfhHiddenIndexList=0;  //报警防火隐患
// var dialogCameraIndexHyList = 0;  //报警摄像头 -- 火眼报警
// var dialogCameraIndexDwdlList=0;  //报警摄像头 -- 堆物堆料
// var dialogCameraIndexFhmList=0;  //报警摄像头 -- 防火门
// var dialogCameraIndexXftdList=0;  //报警摄像头 -- 消防车道
// var dialogCameraIndexDdcList=0;  //报警摄像头 -- 电动车

let _this;
import probeAlarmShow from "@/components/probeAlarmShow";
import handAlarm from "@/components/handAlarm";
import callDialog from "@/pages/websocketdialog/callDialog";
import phoneCallDialog from "@/pages/phoneCallDialog/phoneCallDialog";
import smokeAlarm from "@/pages/alarm/smokeAlarm";
import monitorAlarm from "@/pages/alarm/monitorAlarm";
import policeEnd from "@/components/policeEnd";
import smokeAlarmAuto from "@/pages/alarm/smokeAlarmAuto";
import microStation from "@/components/microStation";
import reviewDialog from "@/components/reviewDialog";
import handAlarmOrder from "@/pages/alarm/handAlarmOrder";
import firePink from "@/pages/fireBook/firePink";
import firePinkAlarm from "@/pages/fireBook/firePinkAlarm";
import dialogBox from "@/components/dialogBox";
import lookVideo from "@/components/lookVideo.vue";
import {begin, end} from "@/js/mike";
import {closeAlarm, closeAudio, closeVideo, openAudio, openSDK} from "@/js/shieldKing"; //关闭接警 //关语音 //关监控 //开语音 //开sdk
import securityDoor from "@/pages/pileThing/securityDoor"; //防火门
import HandNewspaperDangers from "@/pages/handNewspaperDangers/listHandNewspaperDangers"; //手报
import MonitorDangers from "@/pages/monitorDangers/listMonitorDangers"; //电动车
// import MonitorDangers from '@/pages/monitorDangers/listMonitorDangers' //电池
import pinkeyeDangers from "@/pages/pinkeyeDangers/pinkeyeDangers"; //火眼
import pileThing from "@/pages/pileThing/pileThing"; //堆物堆料
import fireEngine from "@/pages/fireEngine/fireEngine"; //消防车道
import {lnglatAlarm} from "@/js/lnglatAlarm"; //地图文件
import {redStyleTp} from "@/js/constants";

export default {
  name: "index",
  components: {
    firePink: firePink,
    firePinkAlarm,
    probeAlarmShow: probeAlarmShow,
    callDialog,
    phoneCallDialog,
    handAlarm,
    smokeAlarm,
    policeEnd,
    monitorAlarm,
    smokeAlarmAuto,
    microStation,
    reviewDialog,
    handAlarmOrder,
    dialogBox,
    lookVideo,

    securityDoor,
    HandNewspaperDangers,
    MonitorDangers,
    pinkeyeDangers,
    pileThing,
    fireEngine,
  },
  data() {
    return {
      videoSrcNum: 1,
      MP3List: {
        // 紧急疏散语音
        "-1": require("../../assets/mp3/1-huojing.mp3"),
        // 119火警（没有）
        "-2": require("../../assets/mp3/119.mp3"),
        // 高空火眼
        15: require("../../assets/mp3/huoyan.mp3"),
        // 手报报警
        22: require("../../assets/mp3/shoubao.mp3"),
        // 微信报警（没有）
        "-3": require("../../assets/mp3/weixin.mp3"),
        // 烟感报警
        3: require("../../assets/mp3/yangan.mp3"),
        // 电瓶进楼
        26: require("../../assets/mp3/dianchi.mp3"),
        // 电动车进楼
        14: require("../../assets/mp3/diandongche.mp3"),
        // 共享单车报警
        40: require("../../assets/mp3/gongxiangdanche.mp3"),
        // 楼道堆物
        17: require("../../assets/mp3/duiwu.mp3"),
        // 检查报警-防火检查
        21: require("../../assets/mp3/fanghuojiancha.mp3"),
        // 防火门报警
        18: require("../../assets/mp3/fanghuomen.mp3"),
        // 消防车道
        16: require("../../assets/mp3/tongdao.mp3"),
        // 举报报警
        8: require("../../assets/mp3/yinhuanjubao.mp3"),
        // 紫外报警
        28: require("../../assets/mp3/ziwaibaojing.mp3"),
        // 垃圾溢满
        33: require("../../assets/mp3/laji.mp3"),
        // 一键报警
        30: require("../../assets/mp3/yijianbaojing.wav"),
        // 电气隐患-电瓶充电
        // 35: require("../../assets/mp3/dainqingchongdian.mp3"),
        // 电气隐患-统一
        35: require("../../assets/mp3/dianqiyinhuan.mp3"),
        // 积水监测
        38: require("../../assets/mp3/jishui.mp3"),
        // 感温线缆
        39: require("../../assets/mp3/gwxl.mp3"),
      },


      show1: true,
      srcList: [],
      selectCjPersons: [],
      isVideoShow: false,
      isviwo: false,
      camera_id: false, //判断手报位置旁边是否有摄像头
      closeOnClickModal: false,
      closeOnPressEscape: false,
      initPopUp: "",
      distort: false,
      socket: Object,
      alarmId: "",
      dialogVisible: false,
      fireBookDialog: false,
      dialogWidth: "1550px",
      dataFinish: false,
      nextAlarmId: "",
      alarmIdtwo: "",
      videoMsg: "",
      dialog: {
        pullAlarmDialog: false,
        hiddenAlarm: false,
        visible: false,
        phoneVisible: false,
        handAlarmVisible: false,
        arrDialog: false,
        arr: "",
        smokeAlarmVisible: false,
        callbackVisible: false,
        policeEndVisible: false,
        callBreakVisible: false,
        sureVideoVisible: false,
        monitorVisible: false,
        smokeAutoAlarmDialog: false,
        reviewDialog: false,
        probeAlarmDialog: false, //电动车-1
        probeAlarmShow: false,
        nowVideoDialog: false,
        pinkeyeDialog: false, //火眼处警
        aisleDialog: false, //消防车道
        fireEyeDialog: false, //火眼调度派单
        pinkAlarmDialog: false, //任务接警页面
        errReportDialog: false, //设备误报弹屏
        handAlarmVisibled: false,
      },
      //实时播放定时器
      setInterval: {
        sbvideo: null, //手报
        ddcvideo: null, //电动车
        gxchevideo: null, //共享单车
        dcvideo: null, //电池
        dwdlvideo: null, //堆物堆料
        xftdvideo: null, //消防车道
        fhmvideo: null, //防火门
        hyvideo: null, //火眼
        rfidvideo: null, //rfid
        cfvideo: null, //后厨
        ghyvideo: null, //光火眼
        ddcwgyjvideo: null, //电动车违规预警
      },
      errForm: {
        content: "",
      },
      second: 0,
      minute: 0,
      smoke: 0,
      callBackUrl: "",
      dialogHref: "",
      viweShow: false,
      videoHeight: {height: "true", width: "100%"},
      squadronStreetList: [],
      squadronStreet: {},
      videoRight: {
        sendstartTime: "",
        timeLength: "",
        senddeptname: "",
        sendmobile: "",
        sendname: "",
        senddeptmobile: "",
        reveiveList: [],
      },
      phoneCallDialog: {
        title: "",
        readStateCn: "",
        time: "",
        msgDetail: "",
        calTime: 0,
        onState: "",
      },
      HiddenmsgDetail: "",
      qdialog: "",
      qdialog_smoke: "", //烟感弹框
      callBackInfo: {},
      dialogTitle: "",
      timer: "",
      callBreakContent: "",
      microStationDialog: false,
      handAlarmDialog: false,
      smAdd: {},
      probeList: [],
      player: "",
      player_voice: {
        sign: true,
        forbid: true,
        type: "",
        cvrDevice: "",
        cvrChannel: "",
      }, //视频对讲
      player_hy: "", //火眼
      player_sb: "", //手报
      player_ddc: "", //电动车
      player_gxche: "", //共享单车
      player_dc: "", //电池
      player_rfid: "", //rfid
      player_fhm: "", //防火门
      player_xftd: "", //消防车道
      player_dwdl: "", //堆物堆料
      player_sy: "", //水压
      player_cf: "", //后厨
      player_ghy: "", //光火眼
      player_spbj: "", //视频报警
      player_ddcwgyj: "", //电动车违规预警

      player1: "",
      proId: [],
      proVillage: [],
      proTower: [],
      alarmInfo: {},
      vigPic: [],
      activeName: "first",
      isChoose: 0,
      proPic: [],
      pinkList: [],
      pinkTime: "",
      pinkUrls: [],
      btnClose: true,
      isButt: false,
      isButt_hy: false, //火眼
      isButt_sb: false, //手报
      isButt_ddc: false, //电动车
      isButt_gxche: false, //共享单车
      isButt_dc: false, //电池
      isButt_rfid: false, //rfid
      isButt_fhm: false, //防火门
      isButt_xftd: false, //消防车道
      isButt_dwdl: false, //堆物堆料
      isButt_sy: false, //水压
      isButt_cf: false, //后厨
      isButt_ghy: false, //光火眼
      isButt_spbj: false, //视频报警
      isButt_dianti: false, //电梯报警
      isButt_ddcwgyj: false, //电动车违规报警
      content: "",
      msgUrl: "",
      q: {
        id: "",
        msgDetail: "",
        smokeName: "",
        pinkName: "火眼报警",
      },

      //点击误报弹框的信息
      wbData: {},

      //催告弹框
      dialogSummonList: [], //催告--实际数据集合

      //微信隐患报警
      wx_sign: "", //弹窗标记--微信隐患  0 首页弹窗   1 列表弹窗
      dialogWxyhData: [], //数据临时存储
      WxyhAlermId: [], //取消弹框的任务id
      dialogHiddenList: [], //隐患--实际数据存储集合
      dialogHiddenListNew: [], //弹框--列表--实际数据集合

      //微信防火举报
      wxfh_sign: "", //弹窗标记--微信防火
      dialogWxfhData: [], //数据临时存储
      // WxfhAlermId:[],//取消弹框的任务id
      dialogfhHiddenList: [], //防火隐患--实际数据存储集合
      dialogfhHiddenListNew: [], //弹框--列表--实际数据集合

      //手报报警
      sb_sign: "", //弹窗标记--手报
      dialogSbData: [], //数据临时存储
      SbAlermId: [], //取消弹框的任务id
      dialogList: [], //手报-实际数据存储集合
      dialogListNew: [], //弹框--列表--实际数据集合

      //烟感报警
      yg_sign: "", //弹窗标记--烟感
      dialogYgData: [], //数据临时存储
      YgAlermId: [], //取消弹框的任务id
      dialogSmokeList: [], //烟感--实际数据存储集合
      dialogSmokeListNew: [], //弹框--列表--实际数据集合

      //温感报警
      wg_sign: "", //弹窗标记--温感
      dialogWgData: [], //数据临时存储
      WgAlermId: [], //取消弹框的任务id
      dialogWgList: [], //温感--实际数据存储集合
      dialogWgListNew: [], //温感--列表--实际数据集合

      //电动车
      ddc_sign: "", //弹窗标记--电动车
      dialogDdcData: [], //数据临时存储
      DdcAlermId: [], //取消弹框的任务id
      dialogCameraDdcList: [], //电动车报警--实际数据存储集合
      dialogCameraDdcListNew: [], //电动车--列表--实际数据集合

      //共享单车
      gxche_sign: "", //弹窗标记--共享单车
      dialogGxcheData: [], //数据临时存储
      GxcheAlermId: [], //取消弹框的任务id
      dialogCameraGxcheList: [], //共享单车报警--实际数据存储集合
      dialogCameraGxcheListNew: [], //共享单车--列表--实际数据集合

      //电池
      dc_sign: "", //弹窗标记--电池
      dialogDcData: [], //数据临时存储
      DcAlermId: [], //取消弹框的任务id
      dialogCameraDcList: [], //电池报警--实际数据存储集合
      dialogCameraDcListNew: [], //电池--列表--实际数据集合

      //rfid
      rfid_sign: "", //弹窗标记--rfid
      dialogRfidData: [], //数据临时存储
      RfidAlermId: [], //取消弹框的任务id
      dialogCameraRfidList: [], //rfid报警--实际数据存储集合
      dialogCameraRfidListNew: [], //rfid--列表--实际数据集合

      //火眼
      hy_sign: "", //弹窗标记--堆物堆料
      dialogHyData: [], //数据临时存储
      HyAlermId: [], //取消弹框的任务id
      dialogCameraList: [], //火眼报警--实际数据存储集合
      dialogCameraListNew: [], //火眼--列表--实际数据集合

      //堆物堆料
      dwdl_sign: "", //弹窗标记--堆物堆料
      dialogDwdlData: [], //数据临时存储
      DwdlAlermId: [], //取消弹框的任务id
      dialogCameraDwdlList: [], //堆物堆料--实际数据存储集合
      dialogCameraDwdlListNew: [], //弹框--列表--实际数据集合

      //垃圾溢满`
      ljsb_sign: "", //弹窗标记--垃圾溢满
      dialogLjsbData: [], //数据临时存储
      ljsbAlermId: [], //取消弹框的任务id
      dialogCameraLjsbList: [], //垃圾溢满--实际数据存储集合
      dialogCameraLjsbListNew: [], //弹框--列表--实际数据集合

      //防火门
      fhm_sign: "", //弹窗标记--防火门
      dialogFhmData: [], //数据临时存储
      FhmAlermId: [], //取消弹框的任务id
      dialogCameraFhmList: [], //防火门--实际数据存储集合
      dialogCameraFhmListNew: [], //弹框--列表--实际数据集合

      //消防车道
      xftd_sign: "", //弹窗标记--防火门
      dialogXftdData: [], //数据临时存储
      XftdAlermId: [], //取消弹框的任务id
      dialogCameraXftdList: [], //防火门--实际数据存储集合
      dialogCameraXftdListNew: [], //弹框--列表--实际数据集合

      //水压报警
      sy_sign: "", //弹窗标记--水压
      dialogSyData: [], //数据临时存储
      SyAlermId: [], //取消弹框的任务id
      dialogWaterList: [], //水压--实际数据存储集合
      dialogWaterListNew: [], //弹框--列表--实际数据集合

      //后厨
      cf_sign: "", //弹窗标记--堆物堆料
      dialogCfData: [], //数据临时存储
      CfAlermId: [], //取消弹框的任务id
      dialogCameraCfList: [], //火眼报警--实际数据存储集合
      dialogCameraCfListNew: [], //火眼--列表--实际数据集合

      sign_hywb: false, //火眼误报 false 表示没有火眼报警

      //光感
      ghy_sign: "", //弹窗标记--光感
      dialogGhyData: [], //数据临时存储
      GhyAlermId: [], //取消弹框的任务id
      dialogCameraGhyList: [], //光感--实际数据存储集合
      dialogCameraGhyListNew: [], //弹框--列表--实际数据集合

      //视频报警
      spbj_sign: "", //弹窗标记--视频
      dialogSpbjData: [], //数据临时存储
      SpbjAlermId: [], //取消弹框的任务id
      dialogCameraSpbjList: [], //光感--实际数据存储集合
      dialogCameraSpbjListNew: [], //弹框--列表--实际数据集合

      //呼叫火眼报警
      hjhy_sign: "", //弹窗标记--视频
      dialogHjhyData: [], //数据临时存储
      HjhyAlermId: [], //取消弹框的任务id
      dialogCameraHjhyList: [], //光感--实际数据存储集合
      dialogCameraHjhyListNew: [], //弹框--列表--实际数据集合

      //电梯
      dialogDiantiData: [], //数据临时存储
      dialogCameraDiantiList: [], //光感--实际数据存储集合
      dialogCameraDiantiListNew: [], //弹框--列表--实际数据集合

      //电动车违规预警
      ddcwgyj_sign: "", //弹窗标记--电动车违规预警
      dialogDdcwgyjData: [], //数据临时存储
      dialogDdcwgyjDataList: [], //电动车违规预警--实际数据存储集合
      dialogDdcwgyjDataListNew: [], //弹框--列表--实际数据集合

      //电气隐患预警
      dqyh_sign: "", //弹窗标记--电动车违规预警
      dialogDqyhData: [], //数据临时存储
      dialogDqyhDataList: [], //电动车违规预警--实际数据存储集合
      dialogDqyhDataListNew: [], //弹框--列表--实际数据集合

      //低电量预警
      ddl_sign: "", //弹窗标记--电动车违规预警
      dialogDdlData: [], //数据临时存储
      dialogDdlDataList: [], //电动车违规预警--实际数据存储集合
      dialogDdlDataListNew: [], //弹框--列表--实际数据集合

      //积水监测报警
      jishui_sign: "", //弹窗标记--积水监测
      dialogJishuiData: [], //数据临时存储
      JishuiAlermId: [], //取消弹框的任务id
      dialogJishuiList: [], //积水监测--实际数据存储集合
      dialogJishuiListNew: [], //弹框--列表--实际数据集合

      //感温线缆报警
      gwxl_sign: "", //弹窗标记--感温线缆
      dialogGwxlData: [], //数据临时存储
      GwxlAlermId: [], //取消弹框的任务id
      dialogCameraGwxlList: [], //感温线缆--实际数据存储集合
      dialogCameraGwxlListNew: [], //弹框--列表--实际数据集合

      //视频截流
      video_close: {
        close_hy: "",
      },

      jssd: {
        jssdLs: {},
        jssdData: {},
      }, //结束收队

      //拨打电话限制时长，避免重复拨打
      photoSign: 0,

      //报警弹框显示与否
      alarmDialogVideo: {
        visible: false,
        //暂存的已经打开视频流
        videoObj: {},
        loading: false,
      },

      //呼叫报警得标记
      sdkSign: null,
      //打开sdk视频的标记
      closeSDKSign: false,
    };
  },
  created() {
    _this = this;
    _this.errForm.content = "";
    _this.videoHeight.height = window.innerHeight - 310 + "px";
    _this.probeFun();
    console.log(_this.$store.state.sdkUserName,'弹屏sdk----')
  },
  mounted() {
    if (_this.$store.state.ref !== "") {
      _this.init();
    }
    _this.timer = setInterval(_this.time, 1000);
    _this.$root.eventHub.$on("send", _this.send);
    _this.$root.eventHub.$on("initWebsocket", _this.init);
    _this.$root.eventHub.$on("websocketclose", _this.websocketclose);
    _this.$root.eventHub.$on("stopBellRing", _this.stopBellRing);
    // _this.$root.eventHub.$on('closePinkAlarmDialog', _this.closePinkAlarmDialog)
  },
  beforeDestroy() {
    _this.$root.eventHub.$off("websocketclose");
    _this.$root.eventHub.$off("initWebsocket");
    _this.$root.eventHub.$off("send"); //从总线上页面解除绑定
  },

  computed: {
    isRedStyleTp() {
      return this.$store.state.styleTp === redStyleTp;
    },
  },

  methods: {
    resourceBase () {
      return resourceBase
    },
    handleIsVideo(val) {
      this.isVideoShow = !this.isVideoShow;
      this.btnJumpVideo();
    },
    btnJumpVideo() {
      let _this = this;
      var success = function (resp) {
        if (resp != null) {
          _this.player1 = new WasmPlayer(null, "players", _this.callbackfun);
          _this.player1.play(resp.url, 1);
          _this.player1.closeAudio();
          _this.viweShow = true;
          _this.isviwo = true;
        } else {
          _this.isviwo = false;
        }
      };
      _this.http.post(
        "/webapi/probeEquipment/seevideo",
        {id: this.alarmId},
        success
      );
    },
    //判断是否有模块权限
    menu_judge(data) {
      //判断是否有模块权限
      // 0.119出警  --- 0
      // 1.拉动演练   --- 2
      // 2.烟感触发 --- 3
      // 3.微信派单  --- 4
      // 4.隐患报警  --- 8
      // 5.手控报警 --- 22
      // 6.探头报警 --- 14
      // 7.消防车道报警 --- 16
      // 8.火眼报警   --- 15
      // 9.堆物堆料报警  --- 17
      // 10.防火门 --- 18
      // 11防火检查 --- 21
      // 12水压报警 --- 24
      // 13后厨报警 --- 25
      // 14电池报警 --- 26
      // 15rfid报警 --- 27
      // 18光火焰报警 --- 28

      let a = "";

      if (data.msgSource == "0") {
        a = 0;
      } else if (data.msgSource == "2") {
        a = 1;
      } else if (data.msgSource == "3") {
        a = 2;
      } else if (data.msgSource == "4") {
        a = 3;
      } else if (data.msgSource == "8") {
        a = 4;
      } else if (data.msgSource == "22") {
        a = 5;
      } else if (data.msgSource == "14") {
        a = 6;
      } else if (data.msgSource == "16") {
        a = 7;
      } else if (data.msgSource == "15") {
        a = 8;
      } else if (data.msgSource == "17") {
        a = 9;
      } else if (data.msgSource == "18") {
        a = 10;
      } else if (data.msgSource == "21") {
        a = 11;
      } else if (data.msgSource == "24") {
        a = 12;
      } else if (data.msgSource == "25") {
        a = 13;
      } else if (data.msgSource == "26") {
        a = 14;
      } else if (data.msgSource == "27") {
        a = 15;
      } else if (data.msgSource == "28") {
        a = 18;
      } else if (data.msgSource == "33") {
        //垃圾溢满
        a = 21;
      } else if (data.msgSource == "38") {
        //积水监测
        a = 36;
      } else if (data.msgSource == "40") {
        //共享单车报警（复用探头报警权限）
        a = 6;
      }

      if (_this.$store.state.menu.filter((v) => v == a).length < 1) {
        return;
      }
    },
    getMessage: function (msg) {
      this.$forceUpdate();
      let data = JSON.parse(msg.data);
      console.log("报警弹屏信息====")
      console.log(data)
      // 与桌面应用交互
      localStorage.setItem("electronData", msg.data);
      // 修改时间
      const date = new Date(data.createTime);
      const year = date.getFullYear(); // 获取年份
      const month = date.getMonth() + 1; // 获取月份（注意：月份从 0 开始，0 表示一月）
      const day = date.getDate(); // 获取日期
      const hours = date.getHours(); // 获取小时
      const minutes = date.getMinutes(); // 获取分钟
      const seconds = date.getSeconds(); // 获取秒钟
      // 添加零前缀
      const padZero = (num) => (num < 10 ? `0${num}` : num);

      const createTime = `${year}年${month}月${day}日 ${padZero(hours)}:${padZero(minutes)}:${padZero(seconds)}`;
      // const  createTime =  `${year}年${month}月${day}日${hours}:${minutes}:${seconds}`
      if (data.msgSource == 100) {
        return;
      }
      _this.menu_judge(data);
      //获取当前的路径；当页面再登录页面的时候  禁止弹屏
      if (!_this.$route.name || _this.$route.name == "Login") {
        return;
      }
      // return;
      data.id = data.idStr; //id为字符串，防止丢失精度

      //如果此时正在派警则当次不报  派警页面
      if (_this.dialog.pinkAlarmDialog) {
        return;
      }
      // 声音播报
      _this.setElectron(data);
      if (data.msgSource == 15) {
        //火眼
        _this.q.msgDetail = data.msgDetail;
        _this.pinkTime = data.createdate;

        _this.idStr = data.idStr;
        this.q.id = data.alarmId; //**###***
        _this.msgUrl = data.msgUrl; //**###**
        _this.distort = true; //**###*** 设备误报
        _this.pinkUrls.push(data.img);

        if (data.popUpWay == "0") {
          dialogSytleIndex_hy++;
          if (dialogSytleIndex_hy > 50) {
            dialogSytleIndex_hy = 0;
          }
          // data.num = 1;
          //弹框警报信息列表的数据暂存库  _this.dialogHyData  新报警信息 data
          //获取数据库暂存表中与该信息相同的数据(判断依据： 设备id)
          // var a = _this.dialogHyData.filter((v)=>(v.equipId == data.equipId));
          //首次警报判断
          // if(_this.dialogHyData.length>0){
          //   //判断重复举报
          //   if(a.length>0){
          //     //===有重复的
          //     //匹配到数据库暂存表找到该数据;  _this.dialogHyData
          //     const list = _this.dialogHyData.filter((v) => (v.equipId == data.equipId))
          //     //储存取消弹框的任务id,(留以后备用)
          //     _this.HyAlermId.push(list.equipId)
          //     //改变num
          //     // const newNum = list[0].num + 1;
          //     //过滤掉重复的警报
          //     const detelList = _this.dialogHyData.filter((v)=>(v.equipId !== list[0].equipId));
          //     //更新最新的重复警报的数量（也就是当前data）
          //     // data = Object.assign({},data,{num:newNum})
          //     //重新压入到要呈现弹框的数据列表中
          //     detelList.push(data);
          //     _this.pinkVi(data);
          //     //清空暂存表
          //     _this.dialogHyData = [];
          //     //清空弹框，重新弹
          //     _this.dialogCameraList = [];
          //     for(var i = 0; i<detelList.length; i++){
          //       const aj = detelList[i];
          //       //将最新的数据更新到数据库暂存表里
          //       _this.dialogHyData.push(aj);
          //       _this.dialogCameraList.push({ref:aj,id:'id'+ aj.id,dialogTitle:"火眼报警派单",initPopUp:"火眼报警",msgSourceId:aj.msgSource,dialogCameraIndexHy:true,style:"margin-left:"+ dialogSytleIndex_hy/3 +"%",msgSource:true,popUpWay:aj.popUpWay,msgDetail:aj.msgDetail,equipId:aj.equipId,num:aj.alarmNumber,img:aj.img})
          //     }
          //   }else{
          //     //===判断第二次弹框并且暂存数据库无一致的
          //     _this.dialogHyData.push(data)
          //     _this.pinkVi(data);
          //     _this.dialogCameraList.push({ref:data,id:'id'+ data.id,dialogTitle:"火眼报警派单",initPopUp:"火眼报警",msgSourceId:data.msgSource,dialogCameraIndexHy:true,style:"margin-left:"+ dialogSytleIndex_hy/3 +"%",msgSource:true,popUpWay:data.popUpWay,msgDetail:data.msgDetail,equipId:data.equipId,num:data.alarmNumber,img:data.img,})
          //   }
          // }else{
          //===判断第一次弹框
          _this.dialogHyData.push(data);
          _this.pinkVi(data);
          _this.dialogCameraList.push({
            ref: data,
            id: "id" + data.id,
            dialogTitle: "火眼报警派单",
            initPopUp: "火眼报警",
            msgSourceId: data.msgSource,
            dialogCameraIndexHy: true,
            style: "margin-left:" + dialogSytleIndex_hy / 3 + "%",
            msgSource: true,
            popUpWay: data.popUpWay,
            msgDetail: data.msgDetail,
            equipId: data.equipId,
            num: data.alarmNumber,
            img: data.img,
          });
          // }
        } else if (data.popUpWay == "1") {
          //列表
          _this.pinkVi(data);
          _this.dialogCameraListNew = [];
          _this.dialogCameraListNew.push({
            ref: data,
            id: "id" + data.id,
            dialogTitle: "火眼报警派单",
            initPopUp: "火眼报警",
            msgSourceId: data.msgSource,
            dialogCameraIndexHyList: true,
            style: "margin-left:0",
            msgSource: true,
            popUpWay: data.popUpWay,
            msgDetail: data.msgDetail,
            equipId: data.equipId,
            img: data.img,
          });
        }
      }

      _this.videoMsg = data;
      _this.alarmId = data.alarmId;

      if (data.msgSource == 1) {
        //视频呼叫
        _this.videoCall(data);
      } else if (data.msgSource == 12) {
        //语音
        _this.phoneCall(data);
      } else if (data.msgSource == 0) {
        //119
        if (data.msgLevel == 0) {
          _this.alarmfire(data);
        }
      } else if (data.msgSource == 2) {
        //拉动
        _this.pull(data);
      } else if (data.msgSource == -1) {
        //提示关闭
        _this.dialog.visible = false;
      } else if (data.msgSource == 3) {
        // ==烟感报警  //钱磊磊1
        _this.qdialog_smoke = "smoke-dialog";

        // dialogYgData:[], 烟感的弹框数据临时存储  YgAlermId:[], 取消弹框的任务id  popUpWay 1 列表 0 警报
        //判断是首页警报还是从列表页过来的
        _this.yg_sign = data.popUpWay; //将标记储存

        if (data.lng && data.lat) {
          lnglatAlarm(
            "alarm",
            {id: `lnglatAlarmid${data.id}`},
            {lng: data.lng, lat: data.lat, name: data.msgDetail}
          );
          data.alarmMap = true;
        } else {
          data.alarmMap = false;
        }

        if (data.popUpWay == "0") {
          //警报
          dialogSytleIndex_yg++;
          if (dialogSytleIndex_yg > 50) {
            dialogSytleIndex_yg = 0;
          }
          //弹框警报信息列表的数据暂存库  _this.dialogYgData  新报警信息 data
          //获取数据库暂存表中与该信息相同的数据(判断依据： 设备id)
          var a = _this.dialogYgData.filter((v) => v.equipId == data.equipId);
          //首次警报判断
          if (_this.dialogYgData.length > 0) {
            //判断重复举报
            if (a.length > 0) {
              //===有重复的
              //匹配到数据库暂存表找到该数据;  _this.dialogYgData
              const list = _this.dialogYgData.filter(
                (v) => v.equipId == data.equipId
              );
              //储存取消弹框的任务id,(留以后备用)
              _this.YgAlermId.push(list.equipId);
              //过滤掉重复的警报
              const detelList = _this.dialogYgData.filter(
                (v) => v.equipId !== list[0].equipId
              );
              //重新压入到要呈现弹框的数据列表中
              detelList.push(data);
              _this.smokingCall(data);
              //清空暂存表
              _this.dialogYgData = [];
              //清空弹框，重新弹
              _this.dialogSmokeList = [];
              for (var i = 0; i < detelList.length; i++) {
                const aj = detelList[i];
                //将最新的数据更新到数据库暂存表里
                _this.dialogYgData.push(aj);
                _this.dialogSmokeList.push({
                  alarmId: aj.alarmId,
                  id: "id" + aj.id,
                  dialogSmokeIndex: true,
                  style: "margin-left:" + dialogSytleIndex_yg / 3 + "%",
                  popUpWay: aj.popUpWay,
                  msgDetail: aj.msgDetail,
                  HiddenTitle: "烟感报警",
                  equipId: aj.equipId,
                  num: aj.alarmNumber,
                });
              }
            } else {
              //===判断第二次弹框并且暂存数据库无一致的
              _this.dialogYgData.push(data);
              _this.smokingCall(data);
              _this.dialogSmokeList.push({
                alarmId: data.alarmId,
                id: "id" + data.id,
                dialogSmokeIndex: true,
                style: "margin-left:" + dialogSytleIndex_yg / 3 + "%",
                popUpWay: data.popUpWay,
                msgDetail: data.msgDetail,
                HiddenTitle: "烟感报警",
                equipId: data.equipId,
                num: data.alarmNumber,
              });
            }
          } else {
            //===判断第一次弹框
            _this.dialogYgData.push(data);
            _this.smokingCall(data);
            _this.dialogSmokeList.push({
              alarmId: data.alarmId,
              id: "id" + data.id,
              dialogSmokeIndex: true,
              style: "margin-left:" + dialogSytleIndex_yg / 3 + "%",
              popUpWay: data.popUpWay,
              msgDetail: data.msgDetail,
              HiddenTitle: "烟感报警",
              equipId: data.equipId,
              num: data.alarmNumber,
            });
          }
        } else if (data.popUpWay == "1") {
          //列表
          _this.smokingCall(data);
          _this.dialogSmokeListNew.push({
            alarmId: data.alarmId,
            id: "id" + data.id,
            dialogSmokeIndexList: true,
            style: "margin-left:0",
            popUpWay: data.popUpWay,
            msgDetail: data.msgDetail,
            HiddenTitle: "烟感报警",
            equipId: data.equipId,
          });
        }
      } else if (data.msgSource == 4) {
        //微信报警
        _this.$refs.dialogBox.wechatFire(data);
      } else if (data.msgSource == 6) {
        //回拨
        _this.returnCall(data);
      } else if (data.msgSource == 8 || data.msgSource == 21) {
        //隐患举报
        _this.dialogTitle =
          data.msgSource == 8 ? "隐患举报派单" : "防火巡查派单";
        dialogSytleIndex_hb++;
        if (dialogSytleIndex_hb > 50) {
          dialogSytleIndex_hb = 0;
        }
        if (data.msgSource == 8) {
          _this.wx_sign = data.popUpWay; //将标记储存
          //判断是首页警报还是从列表页过来的
          if (data.popUpWay == "0") {
            //警报
            //弹框警报信息列表的数据暂存库 _this.dialogWxyhData    新报警信息  data  popUpWay 1 列表 0 警报
            //获取数据库暂存表中与该信息相同的数据(判断依据：电话及隐患地址)
            var a = _this.dialogWxyhData.filter(
              (v) => v.phone == data.phone && v.msgDetail == data.msgDetail
            );
            //首次警报判断
            if (_this.dialogWxyhData.length > 0) {
              //判断重复举报
              if (a.length > 0) {
                //===有重复的
                //匹配到数据库暂存表找到该数据;
                const list = _this.dialogWxyhData.filter(
                  (v) => v.phone == data.phone && v.msgDetail == data.msgDetail
                );
                //储存取消弹框的任务id,(留以后备用)
                _this.WxyhAlermId.push(list.alarmId);
                //过滤掉重复的警报
                const detelList = _this.dialogWxyhData.filter(
                  (v) => v.alarmId !== list[0].alarmId
                );
                //重新压入到要呈现弹框的数据列表中
                detelList.push(data);
                _this.hiddenAlarm(data);
                //清空暂存表
                _this.dialogWxyhData = [];
                //清空弹框，重新弹
                _this.dialogHiddenList = [];
                for (var i = 0; i < detelList.length; i++) {
                  const aj = detelList[i];
                  //将最新的数据更新到数据库暂存表里
                  _this.dialogWxyhData.push(aj);
                  _this.dialogHiddenList.push({
                    id: "id" + aj.id,
                    dialogHiddenIndex: true,
                    style: "margin-left:" + dialogSytleIndex_hb / 3 + "%",
                    popUpWay: aj.popUpWay,
                    phone: aj.phone,
                    msgDetail: aj.msgDetail,
                    HiddenTitle: "隐患举报",
                    num: aj.alarmNumber,
                  });
                }
              } else {
                //===判断第二次弹框并且暂存数据库无一致的
                _this.dialogWxyhData.push(data);
                _this.hiddenAlarm(data);
                _this.dialogHiddenList.push({
                  id: "id" + data.id,
                  dialogHiddenIndex: true,
                  style: "margin-left:" + dialogSytleIndex_hb / 3 + "%",
                  popUpWay: data.popUpWay,
                  phone: data.phone,
                  msgDetail: data.msgDetail,
                  HiddenTitle: "隐患举报",
                  num: data.alarmNumber,
                });
              }
            } else {
              //===判断第一次弹框
              _this.dialogWxyhData.push(data);
              _this.hiddenAlarm(data);
              _this.dialogHiddenList.push({
                id: "id" + data.id,
                dialogHiddenIndex: true,
                style: "margin-left:" + dialogSytleIndex_hb / 3 + "%",
                popUpWay: data.popUpWay,
                phone: data.phone,
                msgDetail: data.msgDetail,
                HiddenTitle: "隐患举报",
                num: data.alarmNumber,
              });
            }
          } else if (data.popUpWay == "1") {
            //列表
            _this.hiddenAlarm(data);
            _this.dialogHiddenListNew.push({
              id: "id" + data.id,
              dialogHiddenIndexList: true,
              style: "margin-left:0",
              popUpWay: data.popUpWay,
              phone: data.phone,
              msgDetail: data.msgDetail,
              HiddenTitle: "隐患举报",
            });
          }
        } else {
          //防火举报
          _this.wxfh_sign = data.popUpWay; //将标记储存
          if (data.popUpWay == "0") {
            _this.dialogWxfhData.push(data);
            _this.hiddenAlarm(data);
            _this.dialogfhHiddenList.push({
              id: "id" + data.id,
              dialogfhHiddenIndex: true,
              style: "margin-left:" + dialogSytleIndex_hb / 3 + "%",
              popUpWay: data.popUpWay,
              phone: data.phone,
              msgDetail: data.msgDetail,
              HiddenTitle: "防火巡查",
            });
          } else if (data.popUpWay == "1") {
            _this.hiddenAlarm(data);
            let filePath = data.filePath ? data.filePath.split(",")[1] : null;
            _this.dialogfhHiddenListNew.push({
              id: "id" + data.id,
              dialogfhHiddenIndexList: true,
              style: "margin-left:0",
              popUpWay: data.popUpWay,
              phone: data.phone,
              msgDetail: data.msgDetail,
              HiddenTitle: "防火巡查",
              filePath: filePath, // 图片
            });
          }
        }
      } else if (data.msgSource == 13) {
        //电瓶车
        _this.selectCjPersons = [];
        _this.dialog.probeAlarmDialog = true;
      } else if (
        data.msgSource == 14 ||
        data.msgSource == 40 ||
        data.msgSource == 16 ||
        data.msgSource == 17 ||
        data.msgSource == 18 ||
        data.msgSource == 33
      ) {
        //火眼报警
        this.q.id = data.alarmId;
        _this.q.msgDetail = data.msgDetail;
        _this.pinkTime = data.createdate;
        _this.msgUrl = data.msgUrl;
        _this.idStr = data.idStr;
        _this.qdialog = "q-dialog";
        _this.distort = true;

        if (data.msgSource == 14) {
          //电动车报警

          _this.pinkUrls.push(data.img);
          _this.isButt_ddc = false;
          _this.ddc_sign = data.popUpWay; //将标记储存
          if (data.popUpWay == "0") {
            dialogSytleIndex_ddc++;
            if (dialogSytleIndex_ddc > 50) {
              dialogSytleIndex_ddc = 0;
            }
            //===判断第一次弹框
            _this.dialogDdcData.push(data);
            _this.pinkVi(data);
            _this.dialogCameraDdcList.push({
              ref: data,
              alarmId: data.alarmId,
              id: "id" + data.id,
              msgSourceId: data.msgSource,
              dialogCameraIndexDdc: true,
              qdialog: "q-dialog",
              dialogTitle: "电动车报警派单",
              initPopUp: "电动车报警",
              style: "margin-left:" + dialogSytleIndex_ddc / 3 + "%",
              msgSource: false,
              popUpWay: data.popUpWay,
              msgDetail: data.msgDetail,
              equipId: data.equipId,
              num: data.alarmNumber,
              img: data.img,
              license: data.license,//车牌号
            });
          } else if (data.popUpWay == "1") {
            //列表
            _this.pinkVi(data);
            _this.dialogCameraDdcListNew = [];
            _this.dialogCameraDdcListNew.push({
              ref: data,
              alarmId: data.alarmId,
              id: "id" + data.id,
              msgSourceId: data.msgSource,
              dialogCameraIndexDdcList: true,
              qdialog: "q-dialog",
              dialogTitle: "电动车报警派单",
              initPopUp: "电动车报警",
              style: "margin-left:0",
              msgSource: false,
              popUpWay: data.popUpWay,
              msgDetail: data.msgDetail,
              equipId: data.equipId,
              img: data.img,
              license: data.license,//车牌号
            });
          }
        } else if (data.msgSource == 40) {
          //共享单车报警
          _this.pinkUrls.push(data.img);
          _this.isButt_gxche = false;
          _this.gxche_sign = data.popUpWay; //将标记储存
          if (data.popUpWay == "0") {
            dialogSytleIndex_gxche++;
            if (dialogSytleIndex_gxche > 50) {
              dialogSytleIndex_gxche = 0;
            }
            //===判断第一次弹框
            _this.dialogGxcheData.push(data);
            _this.pinkVi(data);
            _this.dialogCameraGxcheList.push({
              ref: data,
              id: "id" + data.id,
              msgSourceId: data.msgSource,
              dialogCameraIndexGxche: true,
              qdialog: "q-dialog",
              dialogTitle: "共享单车报警派单",
              initPopUp: "共享单车报警",
              style: "margin-left:" + dialogSytleIndex_gxche / 3 + "%",
              msgSource: false,
              popUpWay: data.popUpWay,
              msgDetail: data.msgDetail,
              equipId: data.equipId,
              num: data.alarmNumber,
              img: data.img,
              license: data.license,//车牌号
            });
          } else if (data.popUpWay == "1") {
            //列表
            _this.pinkVi(data);
            _this.dialogCameraGxcheListNew = [];
            _this.dialogCameraGxcheListNew.push({
              ref: data,
              id: "id" + data.id,
              msgSourceId: data.msgSource,
              dialogCameraIndexGxcheList: true,
              qdialog: "q-dialog",
              dialogTitle: "共享单车报警派单",
              initPopUp: "共享单车报警",
              style: "margin-left:0",
              msgSource: false,
              popUpWay: data.popUpWay,
              msgDetail: data.msgDetail,
              equipId: data.equipId,
              img: data.img,
              license: data.license,//车牌号
            });
          }
        } else if (data.msgSource == 16) {
          //消防车道
          _this.pinkUrls.push(data.img);
          _this.isButt_xftd = false;
          _this.xftd_sign = data.popUpWay; //将标记储存
          if (data.popUpWay == "0") {
            dialogSytleIndex_xftd++;
            if (dialogSytleIndex_xftd > 50) {
              dialogSytleIndex_xftd = 0;
            }
            //===判断第一次弹框
            _this.dialogXftdData.push(data);
            _this.pinkVi(data);
            _this.dialogCameraXftdList.push({
              ref: data,
              id: "id" + data.id,
              dialogTitle: "消防车道报警派单",
              initPopUp: "消防车道占用报警",
              qdialog: "q-dialog",
              msgSourceId: data.msgSource,
              dialogCameraIndexXftd: true,
              style: "margin-left:" + dialogSytleIndex_xftd / 3 + "%",
              msgSource: false,
              popUpWay: data.popUpWay,
              msgDetail: data.msgDetail,
              equipId: data.equipId,
              num: data.alarmNumber,
              img: data.img,
            });
          } else if (data.popUpWay == "1") {
            //列表
            _this.pinkVi(data);
            _this.dialogCameraXftdListNew = [];
            _this.dialogCameraXftdListNew.push({
              ref: data,
              id: "id" + data.id,
              dialogTitle: "消防车道报警派单",
              initPopUp: "消防车道占用报警",
              qdialog: "q-dialog",
              msgSourceId: data.msgSource,
              dialogCameraIndexXftdList: true,
              style: "margin-left:0",
              msgSource: false,
              popUpWay: data.popUpWay,
              msgDetail: data.msgDetail,
              equipId: data.equipId,
              img: data.img,
            });
          }
        } else if (data.msgSource == 17) {
          //堆物堆料

          _this.pinkUrls.push(data.img);
          _this.dwdl_sign = data.popUpWay; //将标记储存
          if (data.popUpWay == "0") {
            dialogSytleIndex_dwdl++;
            if (dialogSytleIndex_dwdl > 50) {
              dialogSytleIndex_dwdl = 0;
            }
            //===判断第一次弹框
            _this.dialogDwdlData.push(data);
            _this.pinkVi(data);
            _this.dialogCameraDwdlList.push({
              ref: data,
              id: "id" + data.id,
              dialogTitle: "堆物堆料报警派单",
              initPopUp: "楼道堆物堆料报警",
              msgSourceId: data.msgSource,
              dialogCameraIndexDwdl: true,
              style: "margin-left:" + dialogSytleIndex_dwdl / 3 + "%",
              msgSource: false,
              popUpWay: data.popUpWay,
              msgDetail: data.msgDetail,
              equipId: data.equipId,
              num: data.alarmNumber,
              img: data.img,
            });
          } else if (data.popUpWay == "1") {
            //列表
            _this.pinkVi(data);
            _this.dialogCameraDwdlListNew = [];
            _this.dialogCameraDwdlListNew.push({
              ref: data,
              id: "id" + data.id,
              dialogTitle: "堆物堆料报警派单",
              initPopUp: "楼道堆物堆料报警",
              msgSourceId: data.msgSource,
              dialogCameraIndexDwdlList: true,
              style: "margin-left:0",
              msgSource: false,
              popUpWay: data.popUpWay,
              msgDetail: data.msgDetail,
              equipId: data.equipId,
              img: data.img,
            });
          }
        } else if (data.msgSource == 33) {
          //垃圾溢满
          _this.pinkUrls.push(data.img);
          _this.ljsb_sign = data.popUpWay; //将标记储存
          if (data.popUpWay == "0") {
            dialogSytleIndex_dwdl++;
            if (dialogSytleIndex_dwdl > 50) {
              dialogSytleIndex_dwdl = 0;
            }
            //===判断第一次弹框
            _this.dialogLjsbData.push(data);
            _this.pinkVi(data);
            _this.dialogCameraLjsbList.push({
              ref: data,
              id: "id" + data.id,
              dialogTitle: "垃圾分类问题抓拍派单",
              initPopUp: "垃圾分类问题抓拍",
              msgSourceId: data.msgSource,
              dialogCameraIndexLjsb: true,
              style: "margin-left:" + dialogSytleIndex_dwdl / 3 + "%",
              msgSource: false,
              popUpWay: data.popUpWay,
              msgDetail: data.msgDetail,
              equipId: data.equipId,
              num: data.alarmNumber,
              img: data.img,
            });
          } else if (data.popUpWay == "1") {
            //列表
            _this.pinkVi(data);
            _this.dialogCameraLjsbListNew = [];
            _this.dialogCameraLjsbListNew.push({
              ref: data,
              id: "id" + data.id,
              dialogTitle: "垃圾分类问题抓拍派单",
              initPopUp: "垃圾分类问题抓拍",
              msgSourceId: data.msgSource,
              dialogCameraIndexLjsbList: true,
              style: "margin-left:0",
              msgSource: false,
              popUpWay: data.popUpWay,
              msgDetail: data.msgDetail,
              equipId: data.equipId,
              img: data.img,
            });
          }
        } else if (data.msgSource == 18) {
          //防火门
          _this.pinkUrls.push(data.img);
          _this.isButt_fhm = false;
          _this.fhm_sign = data.popUpWay; //将标记储存

          if (data.popUpWay == "0") {
            dialogSytleIndex_fhm++;
            if (dialogSytleIndex_fhm > 50) {
              dialogSytleIndex_fhm = 0;
            }
            //===判断第一次弹框
            _this.dialogFhmData.push(data);
            _this.pinkVi(data);
            _this.dialogCameraFhmList.push({
              ref: data,
              id: "id" + data.id,
              msgSourceId: data.msgSource,
              dialogTitle: "防火门报警派单",
              initPopUp: "防火门报警",
              qdialog: "q-dialog",
              dialogCameraIndexFhm: true,
              style: "margin-left:" + dialogSytleIndex_fhm / 3 + "%",
              msgSource: false,
              popUpWay: data.popUpWay,
              msgDetail: data.msgDetail,
              equipId: data.equipId,
              num: data.alarmNumber,
              img: data.img,
            });
          } else if (data.popUpWay == "1") {
            //列表
            _this.pinkVi(data);
            _this.dialogCameraFhmListNew = [];
            _this.dialogCameraFhmListNew.push({
              ref: data,
              id: "id" + data.id,
              msgSourceId: data.msgSource,
              dialogTitle: "防火门报警派单",
              initPopUp: "防火门报警",
              qdialog: "q-dialog",
              dialogCameraIndexFhmList: true,
              style: "margin-left:0",
              msgSource: false,
              popUpWay: data.popUpWay,
              msgDetail: data.msgDetail,
              equipId: data.equipId,
              img: data.img,
            });
          }
        }
      } else if (data.msgSource == 19) {
        if (data.readState === "1") {
          //结束收队
          _this.dialog.policeEndVisible = true;
          _this.jssd.jssdLs = data;
        }
      } else if (data.msgSource == 20) {
        _this.dialog.hiddenAlarm = false;
        _this.dialog.smokeAutoAlarmDialog = false;
        _this.stopBellRing();
      } else if (data.msgSource == 22) {
        //手报报警
        _this.pinkUrls.push(data.img);
        this.q.id = data.alarmId;
        _this.msgUrl = data.msgUrl;
        _this.idStr = data.idStr;
        this.newId = data.alarmId;
        _this.alarmId = data.alarmId;
        _this.distort = true;

        if (data.lng && data.lat) {
          lnglatAlarm(
            "alarm",
            {id: `lnglatAlarmid${data.id}`},
            {lng: data.lng, lat: data.lat, name: data.msgDetail}
          );
          data.alarmMap = true;
        } else {
          data.alarmMap = false;
        }

        // _this.dialog.smokeAutoAlarmDialog = true;  // 需要确认是否有

        _this.sb_sign = data.popUpWay; //将标记储存
        if (data.popUpWay == "0") {
          dialogSytleIndex_sb++;
          if (dialogSytleIndex_sb > 50) {
            dialogSytleIndex_sb = 0;
          }
          //===判断第一次弹框
          _this.dialogSbData.push(data);
          _this.handleMachineCall(data);
          _this.dialogList.push({
            ref: data,
            id: "id" + data.id,
            dialogIndex: true,
            dialogTitle: "手报报警派单",
            qdialog: "q-dialog",
            style: "margin-left:" + dialogSytleIndex_sb / 3 + "%",
            msgSourceId: data.msgSource,
            msgSource: true,
            popUpWay: data.popUpWay,
            msgDetail: data.msgDetail,
            HiddenTitle: "手报报警",
            equipId: data.equipId,
            num: data.alarmNumber,
          });
          // }
        } else if (data.popUpWay == "1") {
          _this.handleMachineCall(data);
          _this.dialogListNew = [];
          _this.dialogListNew.push({
            ref: data,
            id: "id" + data.id,
            dialogIndexList: true,
            dialogTitle: "手报报警派单",
            qdialog: "q-dialog",
            style: "margin-left:0",
            msgSourceId: data.msgSource,
            msgSource: true,
            popUpWay: data.popUpWay,
            msgDetail: data.msgDetail,
            HiddenTitle: "手报报警",
            equipId: data.equipId,
          });
        }
      } else if (data.msgSource == 23) {
        //通知催告
        _this.dialogSummonList.push({
          ref: data,
          id: "id" + data.id,
          dialogSummonIndex: true,
          style: "margin-left:0",
          popUpWay: data.popUpWay,
          msgDetail: data.msgDetail,
          HiddenTitle: data.msgIframeTitle,
        });
      } else if (data.msgSource == 24) {
        //水压报警

        _this.qdialog_smoke = "smoke-dialog";
        //判断是首页警报还是从列表页过来的
        _this.sy_sign = data.popUpWay; //将标记储存
        if (data.popUpWay == "0") {
          //警报
          dialogSytleIndex_sy++;
          if (dialogSytleIndex_sy > 50) {
            dialogSytleIndex_sy = 0;
          }
          //===判断第一次弹框
          _this.waterCall(data);
          _this.dialogSyData.push(data);
          _this.dialogWaterList.push({
            id: "id" + data.id,
            dialogWaterIndex: true,
            style: "margin-left:" + dialogSytleIndex_sy / 3 + "%",
            popUpWay: data.popUpWay,
            msgDetail: data.msgDetail,
            HiddenTitle: "高层水压预警",
            equipId: data.equipId,
            num: data.alarmNumber,
          });
        } else if (data.popUpWay == "1") {
          //列表
          _this.waterCall(data);
          _this.dialogWaterListNew = [];
          _this.dialogWaterListNew.push({
            id: "id" + data.id,
            dialogWaterIndexList: true,
            style: "margin-left:0",
            popUpWay: data.popUpWay,
            msgDetail: data.msgDetail,
            HiddenTitle: "高层水压预警",
            equipId: data.equipId,
          });
        }
      } else if (data.msgSource == 25) {
        //后厨
        if (data.popUpWay == "0") {
          dialogSytleIndex_cf++;
          if (dialogSytleIndex_cf > 50) {
            dialogSytleIndex_cf = 0;
          }
          //===判断第一次弹框
          _this.dialogCfData.push(data);
          _this.pinkVi(data);
          _this.dialogCameraCfList.push({
            ref: data,
            id: "id" + data.id,
            dialogTitle: "后厨报警派单",
            initPopUp: "后厨报警",
            msgSourceId: data.msgSource,
            dialogCameraIndexCf: true,
            style: "margin-left:" + dialogSytleIndex_cf / 3 + "%",
            msgSource: true,
            popUpWay: data.popUpWay,
            msgDetail: data.msgDetail,
            equipId: data.equipId,
            num: data.alarmNumber,
            img: data.img,
          });
        } else if (data.popUpWay == "1") {
          //列表
          _this.pinkVi(data);
          _this.dialogCameraCfListNew = [];
          _this.dialogCameraCfListNew.push({
            ref: data,
            id: "id" + data.id,
            dialogTitle: "后厨报警派单",
            initPopUp: "后厨报警",
            msgSourceId: data.msgSource,
            dialogCameraIndexCfList: true,
            style: "margin-left:0",
            msgSource: true,
            popUpWay: data.popUpWay,
            msgDetail: data.msgDetail,
            equipId: data.equipId,
            img: data.img,
          });
        }
      } else if (data.msgSource == 26) {
        //电池
        _this.pinkUrls.push(data.img);
        _this.isButt_dc = false;
        _this.dc_sign = data.popUpWay; //将标记储存
        if (data.popUpWay == "0") {
          dialogSytleIndex_dc++;
          if (dialogSytleIndex_dc > 50) {
            dialogSytleIndex_dc = 0;
          }
          //===判断第一次弹框
          _this.dialogDcData.push(data);
          _this.pinkVi(data);
          _this.dialogCameraDcList.push({
            ref: data,
            alarmId: data.alarmId,
            id: "id" + data.id,
            msgSourceId: data.msgSource,
            dialogCameraIndexDc: true,
            qdialog: "q-dialog",
            dialogTitle: "电池报警派单",
            initPopUp: "电池报警",
            style: "margin-left:" + dialogSytleIndex_ddc / 3 + "%",
            msgSource: false,
            popUpWay: data.popUpWay,
            msgDetail: data.msgDetail,
            equipId: data.equipId,
            num: data.alarmNumber,
            img: data.img,
          });
        } else if (data.popUpWay == "1") {
          //列表
          _this.pinkVi(data);
          _this.dialogCameraDcListNew = [];
          _this.dialogCameraDcListNew.push({
            ref: data,
            alarmId: data.alarmId,
            id: "id" + data.id,
            msgSourceId: data.msgSource,
            dialogCameraIndexDcList: true,
            qdialog: "q-dialog",
            dialogTitle: "电池报警派单",
            initPopUp: "电池报警",
            style: "margin-left:0",
            msgSource: false,
            popUpWay: data.popUpWay,
            msgDetail: data.msgDetail,
            equipId: data.equipId,
            img: data.img,
          });
        }
      } else if (data.msgSource == 27) {
        //RFID
        _this.pinkUrls.push(data.img);
        _this.isButt_rfid = false;
        _this.rfid_sign = data.popUpWay; //将标记储存
        if (data.popUpWay == "0") {
          dialogSytleIndex_rfid++;
          if (dialogSytleIndex_rfid > 50) {
            dialogSytleIndex_rfid = 0;
          }
          //===判断第一次弹框
          _this.dialogRfidData.push(data);
          _this.pinkVi(data);
          _this.dialogCameraRfidList.push({
            ref: data,
            id: "id" + data.id,
            msgSourceId: data.msgSource,
            dialogCameraIndexRfid: true,
            qdialog: "q-dialog",
            dialogTitle: "RFID报警派单",
            initPopUp: "RFID报警",
            style: "margin-left:" + dialogSytleIndex_rfid / 3 + "%",
            msgSource: false,
            popUpWay: data.popUpWay,
            msgDetail: data.msgDetail,
            equipId: data.equipId,
            num: data.alarmNumber,
            img: data.img,
          });
        } else if (data.popUpWay == "1") {
          //列表
          _this.pinkVi(data);
          _this.dialogCameraRfidListNew = [];
          _this.dialogCameraRfidListNew.push({
            ref: data,
            id: "id" + data.id,
            msgSourceId: data.msgSource,
            dialogCameraIndexRfidList: true,
            qdialog: "q-dialog",
            dialogTitle: "RFID报警派单",
            initPopUp: "RFID报警",
            style: "margin-left:0",
            msgSource: false,
            popUpWay: data.popUpWay,
            msgDetail: data.msgDetail,
            equipId: data.equipId,
            img: data.img,
          });
        }
      } else if (data.msgSource == 28) {
        // ==光感报警
        //判断是首页警报还是从列表页过来的
        _this.ghy_sign = data.popUpWay; //将标记储存

        if (data.popUpWay == "0") {
          dialogSytleIndex_ghy++;
          if (dialogSytleIndex_ghy > 50) {
            dialogSytleIndex_ghy = 0;
          }
          //===判断第一次弹框
          _this.dialogGhyData.push(data);
          _this.pinkVi(data);
          _this.dialogCameraGhyList.push({
            ref: data,
            id: "id" + data.id,
            dialogTitle: "紫外火灾探测器报警派单",
            initPopUp: "紫外火灾探测器报警",
            qdialog: "q-dialog",
            msgSourceId: data.msgSource,
            dialogCameraIndexGhy: true,
            style: "margin-left:" + dialogSytleIndex_ghy / 3 + "%",
            msgSource: false,
            popUpWay: data.popUpWay,
            msgDetail: data.msgDetail,
            equipId: data.equipId,
            num: data.alarmNumber,
            img: data.img,
          });
        } else if (data.popUpWay == "1") {
          //列表
          _this.pinkVi(data);
          _this.dialogCameraGhyListNew = [];
          _this.dialogCameraGhyListNew.push({
            ref: data,
            id: "id" + data.id,
            dialogTitle: "紫外火灾探测器报警派单",
            initPopUp: "紫外火灾探测器报警",
            qdialog: "q-dialog",
            msgSourceId: data.msgSource,
            dialogCameraIndexGhyList: true,
            style: "margin-left:0",
            msgSource: false,
            popUpWay: data.popUpWay,
            msgDetail: data.msgDetail,
            equipId: data.equipId,
            img: data.img,
          });
        }
      } else if (data.msgSource == 29) {
        // ==语音报警
      } else if (data.msgSource == 30) {
        // ==视频报警 应急呼叫弹窗&&呼叫火眼
        //判断是否sdk存在，存在即开启,开启即停止报警弹框
        if (_this.sdkSign) {
          return;
        }
        // return;
        // //先启动sdk
        let sdk = new SOS.SDK({
          AppId: "766dbc1d146011ec95751831bf6d8bd5",
          AppCode: "7dae391a146011eca48f1831bf6d8bd5",
          Account: _this.$store.state.sdkUserName,
          LogLevel: "debug", // 日志级别，默认error
          Test: false, // 对接到测试服务器，默认正式服务器
          ServerAddr: "h8.00e.com",
        });
        sdk
          .init()
          .then((resp) => {
            console.log("sdk开启成功！");
          })
          .catch((err) => {
            console.log("sdk开启失败！");
          });

        // _this.sdkSign = _this.$store.state.sdkObj;
        _this.sdkSign = sdk;

        setTimeout(function () {
          // dialogYgData:[], 烟感的弹框数据临时存储  YgAlermId:[], 取消弹框的任务id  popUpWay 1 列表 0 警报
          //判断是首页警报还是从列表页过来的
          _this.spbj_sign = data.popUpWay; //将标记储存

          if (
            data.msgUrl &&
            JSON.parse(data.msgUrl).lng &&
            JSON.parse(data.msgUrl).lat
          ) {
            lnglatAlarm(
              "alarm",
              {id: `lnglatAlarmid${data.id}`},
              {
                lng: JSON.parse(data.msgUrl).lng,
                lat: JSON.parse(data.msgUrl).lat,
                name: data.msgDetail,
              }
            );
            data.alarmMap = true;
          } else {
            data.alarmMap = false;
          }


          if (data.popUpWay == "0") {
            dialogSytleIndex_spbj++;
            if (dialogSytleIndex_spbj > 50) {
              dialogSytleIndex_spbj = 0;
            }
            //===判断第一次弹框
            _this.dialogSpbjData.push(data);
            _this.pinkVi(data);
            _this.dialogCameraSpbjList.push({
              ref: data,
              id: "id" + data.id,
              alarmMap: data.alarmMap,
              dialogTitle: "视频警报报警派单",
              initPopUp: "呼叫报警",
              qdialog: "q-dialog",
              typeSp: data.type,
              msgSourceId: data.msgSource,
              dialogCameraIndexSpbj: true,
              style: "margin-left:" + dialogSytleIndex_spbj / 3 + "%",
              msgSource: false,
              popUpWay: data.popUpWay,
              msgDetail: data.msgDetail,
              equipId: data.equipId,
              num: data.alarmNumber,
              img: data.img,
              createTime,
            });
            // }
          } else if (data.popUpWay == "1") {
            //列表
            _this.pinkVi(data);
            _this.dialogCameraSpbjListNew = [];
            _this.dialogCameraSpbjListNew.push({
              ref: data,
              id: "id" + data.id,
              alarmMap: data.alarmMap,
              dialogTitle: "视频警报报警派单",
              initPopUp: "呼叫报警",
              qdialog: "q-dialog",
              typeSp: data.type,
              msgSourceId: data.msgSource,
              dialogCameraIndexSpbjList: true,
              style: "margin-left:0",
              msgSource: false,
              popUpWay: data.popUpWay,
              msgDetail: data.msgDetail,
              equipId: data.equipId,
              img: data.img,
              createTime,
            });
          }
        }, 1000);
      } else if (data.msgSource == 34) {
        // ==呼叫火眼弹窗
        //判断是否sdk存在，存在即开启,开启即停止报警弹框
        if (_this.sdkSign) {
          return;
        }
        //先启动sdk
        let sdk = new SOS.SDK({
          AppId: "766dbc1d146011ec95751831bf6d8bd5",
          AppCode: "7dae391a146011eca48f1831bf6d8bd5",
          Account: _this.$store.state.sdkUserName,
          LogLevel: "debug", // 日志级别，默认error
          Test: false, // 对接到测试服务器，默认正式服务器
          ServerAddr: "h8.00e.com",
        });
        sdk
          .init()
          .then((resp) => {
            console.log("sdk开启成功！");
          })
          .catch((err) => {
            console.log("sdk开启失败！");
          });

        _this.sdkSign = sdk;

        setTimeout(function () {
          // dialogYgData:[], 烟感的弹框数据临时存储  YgAlermId:[], 取消弹框的任务id  popUpWay 1 列表 0 警报
          //判断是首页警报还是从列表页过来的
          _this.hjhy_sign = data.popUpWay; //将标记储存

          if (
            data.msgUrl &&
            JSON.parse(data.msgUrl).lng &&
            JSON.parse(data.msgUrl).lat
          ) {
            lnglatAlarm(
              "alarm",
              {id: `lnglatAlarmid${data.id}`},
              {
                lng: JSON.parse(data.msgUrl).lng,
                lat: JSON.parse(data.msgUrl).lat,
                name: data.msgDetail,
              }
            );
            data.alarmMap = true;
          } else {
            data.alarmMap = false;
          }

          if (data.popUpWay == "0") {
            dialogSytleIndex_hjhy++;
            if (dialogSytleIndex_hjhy > 50) {
              dialogSytleIndex_hjhy = 0;
            }
            //===判断第一次弹框
            _this.dialogHjhyData.push(data);
            _this.pinkVi(data);
            _this.dialogCameraHjhyList.push({
              ref: data,
              id: "id" + data.id,
              alarmMap: data.alarmMap,
              dialogTitle: "视频警报报警派单",
              initPopUp: "紫外火灾探测器报警",
              qdialog: "q-dialog",
              typeSp: data.type,
              msgSourceId: data.msgSource,
              dialogCameraIndexHjhy: true,
              style: "margin-left:" + dialogSytleIndex_hjhy / 3 + "%",
              msgSource: false,
              popUpWay: data.popUpWay,
              msgDetail: data.msgDetail,
              equipId: data.equipId,
              num: data.alarmNumber,
              img: data.img,
              createTime,
            });
            // }
          } else if (data.popUpWay == "1") {
            //列表
            _this.pinkVi(data);
            _this.dialogCameraHjhyListNew = [];
            _this.dialogCameraHjhyListNew.push({
              ref: data,
              id: "id" + data.id,
              alarmMap: data.alarmMap,
              dialogTitle: "视频警报报警派单",
              initPopUp: "紫外火灾探测器报警",
              qdialog: "q-dialog",
              typeSp: data.type,
              msgSourceId: data.msgSource,
              dialogCameraIndexHjhyList: true,
              style: "margin-left:0",
              msgSource: false,
              popUpWay: data.popUpWay,
              msgDetail: data.msgDetail,
              equipId: data.equipId,
              img: data.img,
              createTime,
            });
          }
        }, 1000);
      } else if (data.msgSource == 31) {
        // == 电梯报警
        data.popUpWay = "0";
        _this.isButt_dianti = true;
        if (data.popUpWay == "0") {
          dialogSytleIndex_dianti++;
          if (dialogSytleIndex_dianti > 50) {
            dialogSytleIndex_dianti = 0;
          }
          _this.dialogDiantiData.push(data);
          _this.pinkVi(data);
          _this.dialogCameraDiantiList.push({
            ref: data,
            id: "id" + data.id,
            dialogTitle: "电梯警报报警派单",
            initPopUp: "电梯报警",
            qdialog: "q-dialog",
            msgSourceId: data.msgSource,
            dialogCameraIndexDianti: true,
            msgSource: false,
            popUpWay: data.popUpWay,
            msgDetail: data.msgDetail,
            equipId: data.equipId,
            num: data.alarmNumber,
            img: data.img,
          });
        } else if (data.popUpWay == "1") {
          //列表
          _this.pinkVi(data);
          _this.dialogCameraDiantiListNew = [];
          _this.dialogCameraDiantiListNew.push({
            ref: data,
            id: "id" + data.id,
            dialogTitle: "电梯警报报警派单",
            initPopUp: "电梯报警",
            qdialog: "q-dialog",
            msgSourceId: data.msgSource,
            dialogCameraIndexDiantiList: true,
            msgSource: false,
            popUpWay: data.popUpWay,
            msgDetail: data.msgDetail,
            equipId: data.equipId,
            img: data.img,
          });
        }
        // }else if(data.msgSource == 32){// == 电动车违规预警
      } else if (data.msgSource == 32) {
        // == 电动车违规预警  钱磊磊2
        _this.qdialog_smoke = "smoke-dialog";
        _this.ddcwgyj_sign = data.popUpWay; //将标记储存

        // dialogDdcwgyjData:[], 烟感的弹框数据临时存储  DdcwgyjAlermId:[], 取消弹框的任务id  popUpWay 1 列表 0 警报

        if (data.popUpWay == "0") {
          //警报
          dialogSytleIndex_ddcwgyj++;
          if (dialogSytleIndex_ddcwgyj > 50) {
            dialogSytleIndex_ddcwgyj = 0;
          }

          //===判断第一次弹框
          _this.dialogDdcwgyjData.push(data);
          _this.smokingCall(data);
          _this.dialogDdcwgyjDataList.push({
            alarmId: data.alarmId,
            id: "id" + data.id,
            dialogCameraIndexDdcwgyj: true,
            style: "margin-left:" + dialogSytleIndex_ddcwgyj / 3 + "%",
            popUpWay: data.popUpWay,
            msgDetail: data.msgDetail,
            HiddenTitle: "电动车违规预警",
            dialogTitle: "电动车违规预警派单",
            equipId: data.equipId,
            num: data.alarmNumber,
          });
        } else if (data.popUpWay == "1") {
          //列表
          _this.smokingCall(data);
          _this.dialogDdcwgyjDataListNew = [];
          _this.dialogDdcwgyjDataListNew.push({
            alarmId: data.alarmId,
            id: "id" + data.id,
            dialogCameraIndexDdcwgyjList: true,
            style: "margin-left:0",
            popUpWay: data.popUpWay,
            msgDetail: data.msgDetail,
            HiddenTitle: "电动车违规预警",
            dialogTitle: "电动车违规预警派单",
            equipId: data.equipId,
          });
        }
      } else if (data.msgSource == 35) {
        // == 电气隐患
        _this.qdialog_smoke = "smoke-dialog";
        _this.dqyh_sign = data.popUpWay; //将标记储存

        if (data.popUpWay == "0") {
          //警报
          dialogSytleIndex_ddcwgyj++;
          if (dialogSytleIndex_ddcwgyj > 50) {
            dialogSytleIndex_ddcwgyj = 0;
          }

          //===判断第一次弹框
          _this.dialogDqyhData.push(data);
          // _this.smokingCall(data);
          _this.dialogDqyhDataList.push({
            alarmId: data.alarmId,
            id: "id" + data.id,
            dialogCameraIndexDqyh: true,
            style: "margin-left:" + dialogSytleIndex_ddcwgyj / 3 + "%",
            popUpWay: data.popUpWay,
            msgDetail: data.msgDetail,
            msgTitle: data.msgTitle,
            HiddenTitle: "电气隐患预警",
            dialogTitle: "电气隐患预警派单",
            equipId: data.equipId,
            num: data.alarmNumber,
            createTime,
          });
        } else if (data.popUpWay == "1") {
          //列表
          // _this.smokingCall(data);
          _this.dialogDqyhDataListNew = [];
          _this.dialogDqyhDataListNew.push({
            alarmId: data.alarmId,
            id: "id" + data.id,
            dialogCameraIndexDqyh: true,
            style: "margin-left:0",
            popUpWay: data.popUpWay,
            msgDetail: data.msgDetail,
            msgTitle: data.msgTitle,
            HiddenTitle: "电气隐患预警",
            dialogTitle: "电气隐患预警派单",
            equipId: data.equipId,
            num: data.alarmNumber,
            createTime,
          });
        }

      } else if (data.msgSource == 36) {
        _this.qdialog_smoke = "smoke-dialog";

        // dialogYgData:[], 烟感的弹框数据临时存储  YgAlermId:[], 取消弹框的任务id  popUpWay 1 列表 0 警报
        //判断是首页警报还是从列表页过来的
        _this.wg_sign = data.popUpWay; //将标记储存 %需要修改%

        if (data.lng && data.lat) {
          lnglatAlarm(
            "alarm",
            {id: `lnglatAlarmid${data.id}`},
            {lng: data.lng, lat: data.lat, name: data.msgDetail}
          );
          data.alarmMap = true;
        } else {
          data.alarmMap = false;
        }

        if (data.popUpWay == "0") {
          //警报
          dialogSytleIndex_wg++;
          if (dialogSytleIndex_wg > 50) {
            dialogSytleIndex_wg = 0;
          }
          //弹框警报信息列表的数据暂存库  _this.dialogWgData  新报警信息 data
          //获取数据库暂存表中与该信息相同的数据(判断依据： 设备id)
          var a = _this.dialogWgData.filter((v) => v.equipId == data.equipId);
          //首次警报判断
          if (_this.dialogWgData.length > 0) {
            //判断重复举报
            if (a.length > 0) {
              //===有重复的
              //匹配到数据库暂存表找到该数据;  _this.dialogWgData
              const list = _this.dialogWgData.filter(
                (v) => v.equipId == data.equipId
              );
              //储存取消弹框的任务id,(留以后备用)
              _this.YgAlermId.push(list.equipId);
              //过滤掉重复的警报
              const detelList = _this.dialogWgData.filter(
                (v) => v.equipId !== list[0].equipId
              );
              //重新压入到要呈现弹框的数据列表中
              detelList.push(data);
              _this.smokingCall(data);
              //清空暂存表
              _this.dialogWgData = [];
              //清空弹框，重新弹
              _this.dialogWgList = [];
              for (var i = 0; i < detelList.length; i++) {
                const aj = detelList[i];
                //将最新的数据更新到数据库暂存表里
                _this.dialogWgData.push(aj);
                _this.dialogWgList.push({
                  id: "id" + aj.id,
                  dialogSmokeIndex: true,
                  style: "margin-left:" + dialogSytleIndex_wg / 3 + "%",
                  popUpWay: aj.popUpWay,
                  msgDetail: aj.msgDetail,
                  HiddenTitle: "温感警报",
                  equipId: aj.equipId,
                  num: aj.alarmNumber,
                });
              }
            } else {
              //===判断第二次弹框并且暂存数据库无一致的
              _this.dialogWgData.push(data);
              _this.smokingCall(data);
              _this.dialogWgList.push({
                id: "id" + data.id,
                dialogSmokeIndex: true,
                style: "margin-left:" + dialogSytleIndex_wg / 3 + "%",
                popUpWay: data.popUpWay,
                msgDetail: data.msgDetail,
                HiddenTitle: "温感警报",
                equipId: data.equipId,
                num: data.alarmNumber,
              });
            }
          } else {
            //===判断第一次弹框
            _this.dialogWgData.push(data);
            _this.smokingCall(data);
            _this.dialogWgList.push({
              id: "id" + data.id,
              dialogSmokeIndex: true,
              style: "margin-left:" + dialogSytleIndex_wg / 3 + "%",
              popUpWay: data.popUpWay,
              msgDetail: data.msgDetail,
              HiddenTitle: "温感警报",
              equipId: data.equipId,
              num: data.alarmNumber,
            });
          }
        } else if (data.popUpWay == "1") {
          //列表
          _this.smokingCall(data);
          _this.dialogWgListNew.push({
            id: "id" + data.id,
            dialogSmokeIndexList: true,
            style: "margin-left:0",
            popUpWay: data.popUpWay,
            msgDetail: data.msgDetail,
            HiddenTitle: "温感警报",
            equipId: data.equipId,
          });
        }
      } else if (data.msgSource == 37) {
        // == 低电量
        _this.qdialog_smoke = "smoke-dialog";
        _this.ddl_sign = data.popUpWay; //将标记储存

        if (data.popUpWay == "0") {
          //警报
          dialogSytleIndex_ddcwgyj++;
          if (dialogSytleIndex_ddcwgyj > 50) {
            dialogSytleIndex_ddcwgyj = 0;
          }

          //===判断第一次弹框
          _this.dialogDqyhData.push(data);
          // _this.smokingCall(data);
          _this.dialogDdlDataList.push({
            alarmId: data.alarmId,
            id: "id" + data.id,
            dialogCameraIndexDdl: true,
            style: "margin-left:" + dialogSytleIndex_ddcwgyj / 3 + "%",
            popUpWay: data.popUpWay,
            msgDetail: data.msgDetail,
            msgTitle: data.msgTitle,
            HiddenTitle: "低电量预警",
            dialogTitle: "低电量预警派单",
            equipId: data.equipId,
            num: data.alarmNumber,
            createTime,
          });
        } else if (data.popUpWay == "1") {
          //列表
          // _this.smokingCall(data);
          _this.dialogDdlDataListNew = [];
          _this.dialogDdlDataListNew.push({
            alarmId: data.alarmId,
            id: "id" + data.id,
            dialogCameraIndexDdlList: true,
            style: "margin-left:0",
            popUpWay: data.popUpWay,
            msgDetail: data.msgDetail,
            HiddenTitle: "低电量预警",
            dialogTitle: "低电量预警派单",
            equipId: data.equipId,
            createTime,
          });
        }
      } else if (data.msgSource == 38) {
        // == 积水监测报警
        _this.qdialog_smoke = "smoke-dialog";
        //判断是首页警报还是从列表页过来的
        _this.jishui_sign = data.popUpWay; //将标记储存
        if (data.popUpWay == "0") {
          //警报
          dialogSytleIndex_jishui++;
          if (dialogSytleIndex_jishui > 50) {
            dialogSytleIndex_jishui = 0;
          }
          //===判断第一次弹框
          _this.jishuiCall(data);
          _this.dialogJishuiData.push(data);
          _this.dialogJishuiList.push({
            id: "id" + data.id,
            dialogJishuiIndex: true,
            style: "margin-left:" + dialogSytleIndex_jishui / 3 + "%",
            popUpWay: data.popUpWay,
            msgTitle: data.msgTitle,
            msgDetail: data.msgDetail,
            HiddenTitle: "积水监测预警",
            equipId: data.equipId,
            img: data.img,
          });
        } else if (data.popUpWay == "1") {
          //列表
          _this.jishuiCall(data);
          _this.dialogJishuiListNew = [];
          _this.dialogJishuiListNew.push({
            id: "id" + data.id,
            dialogJishuiIndexList: true,
            style: "margin-left:0",
            popUpWay: data.popUpWay,
            msgTitle: data.msgTitle,
            msgDetail: data.msgDetail,
            HiddenTitle: "积水监测预警",
            equipId: data.equipId,
            img: data.img,
          });
        }
      } else if (data.msgSource == 39) {
        // == 感温线缆报警
        _this.qdialog_smoke = "smoke-dialog";
        _this.gwxl_sign = data.popUpWay;
        const temperatureText = _this.getGwxlTemperatureText(data);
        const locationText = _this.getGwxlLocationText(data);
        const videoRow = _this.getGwxlVideoRow(data);
        const videoRows = _this.getGwxlVideoRows(data);

        if (data.popUpWay == "0") {
          dialogSytleIndex_gwxl++;
          if (dialogSytleIndex_gwxl > 50) {
            dialogSytleIndex_gwxl = 0;
          }
          _this.dialogGwxlData.push(data);
          const gwxlItem = {
            ref: data,
            id: "id" + data.id,
            msgSourceId: data.msgSource,
            dialogCameraIndexGwxl: false,
            style: "margin-left:" + dialogSytleIndex_gwxl / 3 + "%",
            popUpWay: data.popUpWay,
            msgDetail: data.msgDetail,
            HiddenTitle: "感温线缆报警",
            initPopUp: "感温线缆报警",
            equipId: data.equipId,
            num: data.alarmNumber,
            location: locationText,
            temperatureText,
            alarmTimeText: data.alarmTime || '',
            alarmContent: data.msgDetail || '感温线缆温度异常，请及时处理',
            videoRow,
            videoRows,
            activeCameraIndex: 0,
          };
          _this.dialogCameraGwxlList.push(gwxlItem);
          _this.$nextTick(() => {
            gwxlItem.dialogCameraIndexGwxl = true;
          });
        } else if (data.popUpWay == "1") {
          _this.dialogCameraGwxlListNew = [];
          const gwxlListItem = {
            ref: data,
            id: "id" + data.id,
            msgSourceId: data.msgSource,
            dialogCameraIndexGwxlList: false,
            style: "margin-left:0",
            popUpWay: data.popUpWay,
            msgDetail: data.msgDetail,
            HiddenTitle: "感温线缆报警",
            initPopUp: "感温线缆报警",
            equipId: data.equipId,
            location: locationText,
            temperatureText,
            alarmTimeText: data.alarmTime || '',
            alarmContent: data.msgDetail || '感温线缆温度异常，请及时处理',
            videoRow,
            videoRows,
            activeCameraIndex: 0,
          };
          _this.dialogCameraGwxlListNew.push(gwxlListItem);
          _this.$nextTick(() => {
            gwxlListItem.dialogCameraIndexGwxlList = true;
          });
        }
      }
    },
    //声音播报
    setElectron(data) {
      let {msgSource} = data;
      _this.videoSrcNum = msgSource;
      _this.$nextTick(() => {
        var music = document.getElementById("audioJb"); //获取ID
        if (!music) {
          return;
        }
        // 重新加载对应类型的报警音乐
        music.load();
        // 显式播放，确保各类报警（含感温线缆 msgSource=39）都能响起
        var playPromise = music.play();
        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(() => {
            // 浏览器/Electron 自动播放限制时静默忽略
          });
        }
      });
    },
    returnCall(data) {
      //回拨
      _this.callBackUrl = data.msgUrl;
      _this.callBackInfo.msgTitle = data.msgTitle;
      _this.callBackInfo.msgIframeTitle = data.msgIframeTitle;
      _this.callBackInfo.msgDetail = data.msgDetail;
      _this.callBackInfo.createTime = data.createTime;
      _this.callBackInfo.createdate = data.createdate;
      _this.dialog.sureVideoVisible = false;
      _this.dialog.callbackVisible = true;
    },

    //烟感报警
    smokingCall(data) {
      if (data.readState === "1") {
        //结束收队
        _this.dialog.policeEndVisible = true;
        return;
      }
      if (data.readState === "2") {
        //电动车结束
        _this.dialog.policeEndVisible = true;
        return;
      }
      _this.q.smokeName = "烟感报警调度派单";
      _this.alarmtIdwo = data.alarmId;
      _this.alarmId = data.alarmId;
      _this.dialog.smokeAutoAlarmDialog = true; //触发烟感
      _this.smoke = 0;
      // _this.handleSearch();
    },

    //水压报警
    waterCall(data) {
      _this.alarmId = data.alarmId;
      _this.q.smokeName = "水压报警调度派单";
    },

    handleMachineCall(data) {
      //手报报警
      this.cameraLocation(data);
    },

    //判断手报位置旁边是否有摄像头
    cameraLocation(data) {
      let _this = this;
      _this.alarmId = data.alarmId;
      var success = function (resp) {
        if (resp) {
          _this.camera_id = true;
        } else {
          _this.camera_id = false;
        }
      };
      _this.http.post(
        "/webapi/probeEquipment/seevideo",
        {id: _this.alarmId},
        success
      );
    },

    pull(data) {
      _this.dialog.pullAlarmDialog = true;
    },

    //结束收队
    pinkVi(data) {
      if (data.readState == "1") {
        //结束收队
        _this.$refs.firePink.closeFireProbe();
        _this.dialog.policeEndVisible = true;
        _this.alarmtIdwo = data.alarmId;
      }
    },

    //火警
    alarmfire(data) {
      _this.$refs.dialogBox.alarm119(data.alarmId);
    },
    isHandAlarmVisible() {
      this.dialog.handAlarmVisible = false;
      this.dialog.pinkAlarmDialog = true;
      _this.player1.pause();
    },
    phoneCall(data) {
      //语音呼叫
      if (data.readState === "0") {
        //呼叫中
        _this.dialog.phoneVisible = true;
        _this.phoneCallDialog.title = data.msgTitle;
        _this.phoneCallDialog.readStateCn = data.msgIframeTitle;
        _this.phoneCallDialog.time = data.msgDetail;
        _this.phoneCallDialog.msgDetail = data.msgDetail;
        _this.phoneCallDialog.onState = "呼叫中";
        _this.phoneCallDialog.calTime = 0;
        _this.phoneCallDialog.readState = data.readState;
        _this.second = 0;
        _this.minute = 0;
      } else if (data.readState === "1") {
        //接通中
        _this.phoneCallDialog.title = data.msgTitle;
        _this.phoneCallDialog.readStateCn = data.msgIframeTitle;
        _this.phoneCallDialog.time = data.msgDetail;
        _this.phoneCallDialog.onState = "接通中";
        _this.phoneCallDialog.msgDetail = data.msgDetail;
        _this.phoneCallDialog.calTime = 0;
        _this.phoneCallDialog.readState = data.readState;
        _this.second = 0;
        _this.minute = 0;
      } else if (data.readState === "2") {
        //挂断
        _this.phoneCallDialog.title = data.msgTitle;
        _this.phoneCallDialog.calTime = 1;
        _this.phoneCallDialog.readStateCn = "挂断";
        _this.phoneCallDialog.msgDetail = data.msgDetail + ":挂断！";
        _this.phoneCallDialog.readState = data.readState;
        _this.second = 0;
        _this.minute = 0;
        setTimeout(function () {
          _this.dialog.phoneVisible = false;
          if (_this.alarmId !== "" && _this.alarmId != undefined) {
            //烟感弹屏呼叫挂断
            _this.dialog.callBreakVisible = true;
          }
        }, 300);
      }
    },

    videoCall(data) {
      //视频呼叫
      _this.videoMsg = data;
      _this.dialog.sureVideoVisible = true;
    },
    queryVideoRight(sendVideoId) {
      var success = function (resp) {
        if (resp.state === "1") {
          //呼叫
          _this.videoRight = {};
          _this.videoRight.sendstartTime = resp.sendstartTime;
          _this.videoRight.senddeptname = resp.senddeptname[0];
          _this.videoRight.sendmobile = resp.sendmobile[0];
          _this.videoRight.sendname = resp.sendname[0];
          _this.videoRight.senddeptmobile = resp.senddeptmobile[0];
          _this.videoRight.reveiveList = [];
          for (var i = 0; i < resp.receivedeptname.length; i++) {
            var obj = {
              receivedeptname: resp.receivedeptname[i],
              receivedeptmobile: resp.receivedeptmobile[i],
              receivemobile: resp.receivemobile[i],
              receiveoname: resp.receiveoname[i],
            };
            _this.videoRight.reveiveList.push(obj);
          }
        }
      };
      _this.http.post(
        "/wxf/videoReceive/sendUserNews1",
        {videoSendId: sendVideoId},
        success
      );
    },
    probeFun() {
      let _this = this;
      let success = function (resp) {
        _this.probeList = resp;
        for (let i = 0; i < _this.probeList.length; i++) {
          _this.proId = _this.probeList[i].id;
          _this.proVillage = _this.probeList[i].villageName;
          _this.proTower = _this.probeList[i].towerNumber;
          _this.srcList.push(_this.probeList[i].pictureUrl);
        }
        if (_this.probeList.length > 0) {
          _this.open2(_this.probeList.length);
        }
      };
      _this.http.get("/webapi/probe/qureyClues", {}, success);
    },
    open2(count) {
      _this.alarmCount = count;
    },
    // 生成报警
    generateAlarm() {
      _this.stopBellRing();
      _this.probeListFun();
      _this.dialog.probeAlarmDialog = false;
      // this.dialog.pinkAlarmDialog = true
    },
    probeListFun() {
      let _this = this;
      let success = function (resp) {
      };
      _this.http.post(
        "/webapi/probe/sendOrders?ids[]=" + _this.selectCjPersons,
        {},
        success
      );
    },
    //手报接警 --当前
    handAutoReport(data, list, sb_sign) {
      if (sb_sign == "0") {
        _this.detelPopUpSbData(data, list);
      } else if (sb_sign == "1") {
        _this.dialogListNew = []; //手报--列表
        _this.detelPopUpSbData(data, list);
      }
    },

    //报警弹框接警后顾虑掉已经接警的数据 手报共同
    detelPopUpSbData(data, list) {
      const newListSj = list.filter((v) => v.equipId !== data);
      _this.dialogList = []; //清空数组
      for (var i = 0; i < newListSj.length; i++) {
        //循环再次压入
        let aj = newListSj[i];
        _this.dialogList.push(aj); //实际弹窗数据表
      }
      const newListZc = _this.dialogSbData.filter((v) => v.equipId !== data); // 过滤已经接警的数据（手报暂存数据表）
      _this.dialogSbData = []; //清空数组
      for (var i = 0; i < newListZc.length; i++) {
        let aj = newListZc[i];
        _this.dialogSbData.push(aj); //手报暂存数据表
      }
      // dialogWindow = false
      _this.stopBellRing();
      this.isVideoShow = false;
      // _this.player.pause();
      _this.dialog.handAlarmVisible = true;
      _this.dialog.smokeAutoAlarmDialog = false;

      setTimeout(() => {
        _this.$refs.handAlarm.handleSearch();
        _this.$refs.firePink.handleSearch();
      });
    },

    //烟感接警 --当前
    smokeAutoReport(data, list, sign) {
      //_this.dialogYgData  烟感暂存数据库表
      // _this.dialogSmokeList 实际弹窗数据表
      // data 当前点击接警的数据equipId(设备id)
      // list 当前正在弹框的所有数据
      // sign 判断是0首页弹框还是1列表弹框
      // 过滤已经接警的数据（实际弹窗数据暂存表）  根据==设备id==进行过滤
      if (sign == "0") {
        _this.detelPopUpYgData(data, list);
      } else if (sign == "1") {
        _this.dialogSmokeListNew = []; //烟感--列表
        _this.detelPopUpYgData(data, list);
      }
    },

    // 打开报警对应的事件接报详情
    openFireBookDetail(alarm) {
      const sourceAlarm = _this.dialogYgData.find((item) => item.equipId === alarm.equipId);
      _this.alarmId = alarm.alarmId || (sourceAlarm && sourceAlarm.alarmId) || "";
      _this.dataFinish = true;
      _this.dialogWidth = alarm.backTime ? "900px" : "1550px";
      _this.fireBookDialog = true;
      _this.dialogVisible = true;
    },

    closeFireBookDetail() {
      _this.dialogVisible = false;
      _this.fireBookDialog = false;
    },

    //报警弹框接警后det后 烟感共同
    detelPopUpYgData(data, list) {
      const newListSj = list.filter((v) => v.equipId !== data);
      _this.dialogSmokeList = []; //清空数组
      for (var i = 0; i < newListSj.length; i++) {
        //循环再次压入
        let aj = newListSj[i];
        _this.dialogSmokeList.push(aj); //实际弹窗数据表
      }
      const newListZc = _this.dialogYgData.filter((v) => v.equipId !== data); // 过滤已经接警的数据（烟感暂存数据表）
      _this.dialogYgData = []; //清空数组
      for (var i = 0; i < newListZc.length; i++) {
        let aj = newListZc[i];
        _this.dialogYgData.push(aj); //烟感暂存数据表
      }
      // dialogWindow = false
      _this.stopBellRing();
      //616标记
      this.isVideoShow = false;
      // _this.dialog.smokeAlarmVisible = true;
      _this.dialog.pinkAlarmDialog = true;
      _this.dialog.smokeAutoAlarmDialog = false;

      setTimeout(() => {
        _this.$refs.smokeAlarmAuto.handleSearch();
        // _this.$refs.firePink.handleSearch();
      });
    },

    //水压报警
    waterAutoReport(data, list, sy_sign) {
      if (sy_sign == "0") {
        _this.detelPopUpSyData(data, list);
      } else if (sy_sign == "1") {
        _this.dialogWaterListNew = []; //水压--列表
        _this.detelPopUpSyData(data, list);
      }
    },
    toWaterPage(id) {
      _this.$router.push(`/waterDangers?id=${id}`)
    },
    //报警弹框接警后det后 水压共同
    detelPopUpSyData(data, list) {
      const newListSj = list.filter((v) => v.equipId !== data);
      _this.dialogWaterList = []; //清空数组
      for (var i = 0; i < newListSj.length; i++) {
        //循环再次压入
        let aj = newListSj[i];
        _this.dialogWaterList.push(aj); //实际弹窗数据表
      }
      const newListZc = _this.dialogSyData.filter((v) => v.equipId !== data); // 过滤已经接警的数据（暂存数据表）
      _this.dialogSyData = []; //清空数组
      for (var i = 0; i < newListZc.length; i++) {
        let aj = newListZc[i];
        _this.dialogSyData.push(aj); //烟感暂存数据表
      }
      _this.stopBellRing();
      this.isVideoShow = false;
      _this.dialog.smokeAlarmVisible = true;
      _this.dialog.smokeAutoAlarmDialog = false; //暂时无用

      setTimeout(() => {
        _this.$refs.smokeAlarmAuto.handleSearch();
        // _this.$refs.firePink.handleSearch();
      });
    },

    //积水监测报警
    jishuiCall(data) {
      _this.alarmId = data.alarmId;
      _this.q.smokeName = "积水监测报警调度派单";
    },
    jishuiAutoReport(data, list, jishui_sign) {
      if (jishui_sign == "0") {
        _this.detelPopUpJishuiData(data, list);
      } else if (jishui_sign == "1") {
        _this.dialogJishuiListNew = []; //积水监测--列表
        _this.detelPopUpJishuiData(data, list);
      }
    },
    toWaterloggingPage(id) {
      _this.$router.push(`/waterlogging?id=${id}`)
    },
    //报警弹框接警后det后 积水监测共同
    detelPopUpJishuiData(data, list) {
      const newListSj = list.filter((v) => v.equipId !== data);
      _this.dialogJishuiList = []; //清空数组
      for (var i = 0; i < newListSj.length; i++) {
        //循环再次压入
        let aj = newListSj[i];
        _this.dialogJishuiList.push(aj); //实际弹窗数据表
      }
      const newListZc = _this.dialogJishuiData.filter((v) => v.equipId !== data); // 过滤已经接警的数据（暂存数据表）
      _this.dialogJishuiData = []; //清空数组
      for (var i = 0; i < newListZc.length; i++) {
        let aj = newListZc[i];
        _this.dialogJishuiData.push(aj); //积水监测暂存数据表
      }
      _this.stopBellRing();
      this.isVideoShow = false;
      _this.dialog.smokeAlarmVisible = true;
      _this.dialog.smokeAutoAlarmDialog = false; //暂时无用

      setTimeout(() => {
        _this.$refs.smokeAlarmAuto.handleSearch();
        // _this.$refs.firePink.handleSearch();
      });
    },

    //拉动弹框
    actionPull() {
      _this.dialog.pullAlarmDialog = false;
      _this.dialog.pinkAlarmDialog = true;
      _this.stopBellRing();
      setTimeout(() => {
        _this.$refs.firePink.handleSearch();
      });
    },

    sureVideoCommit() {
      //确认接视频
      _this.stopBellRing();
      let arr = _this.videoMsg.msgUrl.split("?")[1].split("&");
      let obj = {};
      for (let i of arr) {
        obj[i.split("=")[0]] = i.split("=")[1];
      }
      let success = function (resp) {
        if (resp.code === "0") {
          _this.dialog.sureVideoVisible = false;
          _this.dialog.visible = true;
          _this.minute = 0;
          _this.second = 0;
          _this.phoneCallDialog.calTime === 0;
          _this.dialogHref = resp.data;
        }
      };
      _this.http.get(
        "/webapi/videoReceive/receiveJump",
        {room: obj.room, videoSendId: obj.videoSendId},
        success
      );
      _this.queryVideoRight(obj.videoSendId);
    },
    closePoliceEnd() {
      _this.dialog.policeEndVisible = false;
      _this.$store.commit("updateSelectFireBookActive", "second");
    },
    callBack() {
      //回拨
      var success = function (resp) {
        if (resp.code === "0") {
          var data = JSON.parse(resp.data);
          var url = data.url;
          _this.queryVideoRight(data.sendVideoId);
          _this.dialogHref = url;
          _this.dialog.visible = true;
          _this.dialog.callbackVisible = false;
        }
      };
      _this.http.get(_this.callBackUrl, {}, success);
    },
    submitCallBreakContent() {
      //提交语音挂断后填入的信息
      var formData = new FormData();
      // formData.append("taskId", _this.alarmId);
      formData.append("msg", _this.callBreakContent);
      let success = function (resp) {
        if (resp.code === "0") {
          _this.$message.success(resp.msg);
          _this.dialog.callBreakVisible = false;
        } else {
          _this.$message.error(resp.msg);
        }
      };
      _this.http.postFile("/webapi/writ/taskReportSave", formData, success);
    },
    closeSmokeAlarm() {
      //关闭烟感处警
      _this.dialog.smokeAlarmVisible = false;
      _this.$store.state.selectFireBookActive = "first";
    },
    submitSend() {
      if (_this.dialog.arr === "") {
        _this.$message.warning("请输入标题");
        return;
      }
      if (Object.keys(_this.squadronStreet).length == 0) {
        _this.$message.warning("请选择街道或者中队");
        return;
      }
      _this.dialog.arrDialog = false;
      _this.send({
        arr: _this.dialog.arr,
        id: this.$store.state.userId,
        troopsType: _this.squadronStreet.troopsType,
      });
    },
    send: function (data) {
      // 向服务器端发送消息
      let url = "/webapi/batchConverse";
      if (data.troopsType === "1") {
        //中队
        url = "/webapi/converse";
      } else if (data.troopsType === "4") {
        //街道
        url = "/webapi/converse1";
      }
      var success = function (resp) {
        if (resp.code === "0") {
          var dataObj = JSON.parse(resp.data);
          _this.dialog.visible = true;
          _this.dialogHref = dataObj.url;
          _this.minute = 0;
          _this.second = 0;
          _this.queryVideoRight(dataObj.sendVideoId);
        }
      };
      _this.http.post(url, data, success);
    },
    init: function () {
      if (typeof WebSocket === "undefined") {
        console.log("您的浏览器不支持socket");
      } else {
        let userId = _this.$store.state.userId;
        // 实例化socket
        // _this.socket = new WebSocket("192.168.0.47:8080/websocket/" + userId);
        // _this.socket = new WebSocket("wss://192.168.0.47:8080/websocket/" + userId);
        _this.socket = new WebSocket("wss://wxf.00e.com/websocket/" + userId);
        // _this.socket = new WebSocket("ws://192.168.0.181/websocket/" + userId);
        // 监听socket连接
        _this.socket.onopen = _this.open;
        // 监听socket错误信息
        _this.socket.onerror = _this.error;
        // 监听socket消息
        _this.socket.onmessage = _this.getMessage;
        // _this.socket.onclose = _this.websocketclose;
      }
    },
    open: function () {
      console.log("WebSocket连接成功");
      // const res = ipcRenderer.invoke("msg", this.msg, 12, 23, 56);
      // 添加心跳检测，每30秒发一次数据，防止连接断开（这跟服务器的设置有关，如果服务器没有设置每隔多长时间不发消息断开，可以不进行心跳设置）
      _this.timer = setInterval(() => {
        if (_this.$store.state.ref !== "") {
          try {
            _this.socket.send(_this.$store.state.userId);
          } catch (err) {
            _this.init();
          }
        } else {
          _this.socket.close();
        }
      }, 30000);
    },
    error: function () {
      console.log("连接错误");
      if (_this.$store.state.ref !== "") {
        _this.init();
      }
    },
    websocketclose() {
      //关闭
      _this.socket.close();
      // console.log("连接关闭");
    },

    //通话计时器
    time() {
      if (_this.phoneCallDialog.calTime === 0) {
        _this.minute = 0;
        _this.second = 0;
        _this.phoneCallDialog.calTime = 1;
      }
      if (_this.second !== 0 && _this.second % 60 === 0) {
        _this.minute++;
        _this.second = 0;
      } else {
        _this.second++;
      }
    },

    queryEquipInfo() {
      let _this = this;
      let success = function (resp) {
        _this.alarmInfo = resp;
      };
      _this.http.get("/webapi/alarmSmoke/" + _this.alarmId, {}, success);
    },
    // 关闭探头调度派单
    happenClose() {
      let _this = this;
      _this.dialog.probeAlarmShow = false;
    },
    closeAlarmAuto() {
      let _this = this;
      _this.dialog.smokeAlarmVisible = false;
    },
    nowVideo() {
      let _this = this;
      _this.dialog.nowVideoDialog = true;
    },
    closeTab() {
      _this.dialog.probeAlarmDialog = false;
    },

    closepinkeye() {
      _this.stopBellRing();
    },
    //点击设备误报
    errReport(data) {
      let _this = this;
      _this.wbData = data;
      _this.dialog.errReportDialog = true;
    },
    //误报弹屏提交
    handleReport() {
      let _this = this;
      if (!_this.errForm.content) {
        _this.$message.warning("请输入审核内容");
        return;
      }
      _this.stopBellRing();
      _this.dialog.errReportDialog = false; //关闭误报弹屏

      let msgSourceId = _this.wbData.msgSourceId;
      let popUpWay = _this.wbData.popUpWay; //1列表  0警报

      let param = {
        content: _this.errForm.content,
        id: _this.q.id,
      };
      let success = function (resp) {
        if (resp.code === "0") {
          _this.$message.success("提交成功");
          _this.errForm.content = ""; //清空误报内容
          _this.dialog.errReportDialog = false; //关闭误报弹屏

          if (msgSourceId == 18 && popUpWay == 0) {
            //防火门
            _this.wbData.dialogCameraIndexFhm = false; //关闭当前警报弹屏
          } else if (msgSourceId == 18 && popUpWay == 1) {
            _this.wbData.dialogCameraIndexFhmList = false;
          } else if (msgSourceId == 22 && popUpWay == 0) {
            //手报
            _this.wbData.dialogIndex = false;
          } else if (msgSourceId == 22 && popUpWay == 1) {
            _this.wbData.dialogIndexList = false;
          } else if (msgSourceId == 14 && popUpWay == 0) {
            //电动车
            _this.wbData.dialogCameraIndexDdc = false;
          } else if (msgSourceId == 14 && popUpWay == 1) {
            _this.wbData.dialogCameraIndexDdcList = false;
          } else if (msgSourceId == 40 && popUpWay == 0) {
            //共享单车
            _this.wbData.dialogCameraIndexGxche = false;
          } else if (msgSourceId == 40 && popUpWay == 1) {
            _this.wbData.dialogCameraIndexGxcheList = false;
          } else if (msgSourceId == 14 && popUpWay == 0) {
            //电池
            _this.wbData.dialogCameraIndexDc = false;
          } else if (msgSourceId == 14 && popUpWay == 1) {
            _this.wbData.dialogCameraIndexDcList = false;
          } else if (msgSourceId == 27 && popUpWay == 0) {
            //rfid
            _this.wbData.dialogCameraIndexRfid = false;
          } else if (msgSourceId == 27 && popUpWay == 1) {
            _this.wbData.dialogCameraIndexRfidList = false;
          } else if (msgSourceId == 15 && popUpWay == 0) {
            //火眼
            _this.wbData.dialogCameraIndexHy = false;
          } else if (msgSourceId == 15 && popUpWay == 1) {
            _this.wbData.dialogCameraIndexHyList = false;
          } else if (msgSourceId == 25 && popUpWay == 0) {
            //后厨
            _this.wbData.dialogCameraIndexCf = false;
          } else if (msgSourceId == 25 && popUpWay == 1) {
            _this.wbData.dialogCameraIndexCfList = false;
          } else if (msgSourceId == 17 && popUpWay == 0) {
            //堆物堆料
            _this.wbData.dialogCameraIndexDwdl = false;
          } else if (msgSourceId == 17 && popUpWay == 1) {
            _this.wbData.dialogCameraIndexDwdlList = false;
          } else if (msgSourceId == 16 && popUpWay == 0) {
            //消防车道
            _this.wbData.dialogCameraIndexXftd = false;
          } else if (msgSourceId == 16 && popUpWay == 1) {
            _this.wbData.dialogCameraIndexXftdList = false;
          } else if (msgSourceId == 33 && popUpWay == 0) {
            //垃圾溢满
            _this.wbData.dialogCameraIndexLjsb = false;
          } else if (msgSourceId == 33 && popUpWay == 1) {
            _this.wbData.dialogCameraIndexLjsbList = false;
          }

          _this.module(); //刷新列表
        }
      };
      _this.http.post("/webapi/writ/yesMisdeclaration", param, success);
    },

    //根据误报信息查找相应的模块列表
    module() {
      //拿到当前误报的警报信息
      let _this = this;
      let msgSourceId = _this.wbData.msgSourceId;
      let routeName = _this.$route.name; //获取当前的路径；

      if (msgSourceId == 18) {
        //防火门
        if (routeName == "securityDoor") {
          location.reload();
        }
      } else if (msgSourceId == 22) {
        //手报
        if (routeName == "handNewspaperDangers") {
          location.reload();
        }
      } else if (msgSourceId == 14) {
        //电动车
        if (routeName == "monitorDangers") {
          location.reload();
        }
      } else if (msgSourceId == 26) {
        //电池
        if (routeName == "monitorDangers") {
          location.reload();
        }
      } else if (msgSourceId == 27) {
        //rfid
        if (routeName == "rfidDangers") {
          location.reload();
        }
      } else if (msgSourceId == 15) {
        //火眼
        if (routeName == "pinkeyeDangers") {
          location.reload();
        }
      } else if (msgSourceId == 25) {
        //后厨报警
        if (routeName == "kitchenDangers") {
          location.reload();
        }
      } else if (msgSourceId == 17) {
        //堆物堆料
        if (routeName == "pileThing") {
          location.reload();
        }
      } else if (msgSourceId == 16) {
        //消防车道
        if (routeName == "fireEngine") {
          location.reload();
        }
      }
    },

    // 微信隐患--原始
    // pinkAlarm() {
    //   _this.stopBellRing();
    //   _this.dialog.hiddenAlarm = false;
    //   _this.dialog.pinkAlarmDialog = true;
    // },

    // 火眼、堆物堆料、消防车道、防火门接警
    fourKindAlarm(data, type) {
      if (type == "ddc") {
        //dialogCameraDdcList   dialogCameraIndexDdc
        let arr = [];
        for (let i = 0; i < this.dialogCameraDdcList.length; i++) {
          if (this.dialogCameraDdcList[i].id == data.id) {
            this.dialogCameraDdcList[i].dialogCameraIndexDdc = false;
          }
          arr.push(this.dialogCameraDdcList[i]);
        }
        this.dialogCameraDdcList = arr;
      } else if (type == "ddcList") {
        //dialogCameraDcListNew   dialogCameraIndexDcList
        let arr = [];
        for (let i = 0; i < this.dialogCameraDdcListNew.length; i++) {
          if (this.dialogCameraDdcListNew[i].id == data.id) {
            this.dialogCameraDdcListNew[i].dialogCameraIndexDdcList = false;
          }
          arr.push(this.dialogCameraDdcListNew[i]);
        }
        this.dialogCameraDdcListNew = arr;
      } else if (type == "gxche") {
        //dialogCameraGxcheList   dialogCameraIndexGxche
        let arr = [];
        for (let i = 0; i < this.dialogCameraGxcheList.length; i++) {
          if (this.dialogCameraGxcheList[i].id == data.id) {
            this.dialogCameraGxcheList[i].dialogCameraIndexGxche = false;
          }
          arr.push(this.dialogCameraGxcheList[i]);
        }
        this.dialogCameraGxcheList = arr;
      } else if (type == "gxcheList") {
        //dialogCameraGxcheListNew   dialogCameraIndexGxcheList
        let arr = [];
        for (let i = 0; i < this.dialogCameraGxcheListNew.length; i++) {
          if (this.dialogCameraGxcheListNew[i].id == data.id) {
            this.dialogCameraGxcheListNew[i].dialogCameraIndexGxcheList = false;
          }
          arr.push(this.dialogCameraGxcheListNew[i]);
        }
        this.dialogCameraGxcheListNew = arr;
      } else if (type == "dc") {
        //dialogCameraDcList   dialogCameraIndexDc
        let arr = [];
        for (let i = 0; i < this.dialogCameraDcList.length; i++) {
          if (this.dialogCameraDcList[i].id == data.id) {
            this.dialogCameraDcList[i].dialogCameraIndexDc = false;
          }
          arr.push(this.dialogCameraDcList[i]);
        }
        this.dialogCameraDcList = arr;
      } else if (type == "dcList") {
        //dialogCameraDdcListNew   dialogCameraIndexDdcList
        let arr = [];
        for (let i = 0; i < this.dialogCameraDcListNew.length; i++) {
          if (this.dialogCameraDcListNew[i].id == data.id) {
            this.dialogCameraDcListNew[i].dialogCameraIndexDcList = false;
          }
          arr.push(this.dialogCameraDcListNew[i]);
        }
        this.dialogCameraDcListNew = arr;
      } else if (type == "rfid") {
        //dialogCameraDdcList   dialogCameraIndexDdc
        let arr = [];
        for (let i = 0; i < this.dialogCameraRfidList.length; i++) {
          if (this.dialogCameraRfidList[i].id == data.id) {
            this.dialogCameraRfidList[i].dialogCameraIndexRfid = false;
          }
          arr.push(this.dialogCameraRfidList[i]);
        }
        this.dialogCameraRfidList = arr;
      } else if (type == "rfidList") {
        //dialogCameraDdcListNew   dialogCameraIndexDdcList
        let arr = [];
        for (let i = 0; i < this.dialogCameraRfidListNew.length; i++) {
          if (this.dialogCameraRfidListNew[i].id == data.id) {
            this.dialogCameraRfidListNew[i].dialogCameraIndexRfidList = false;
          }
          arr.push(this.dialogCameraRfidListNew[i]);
        }
        this.dialogCameraRfidListNew = arr;
      } else if (type == "hy") {
        //dialogCameraList    dialogCameraIndexHy
        let arr = [];
        for (let i = 0; i < this.dialogCameraList.length; i++) {
          if (this.dialogCameraList[i].id == data.id) {
            this.dialogCameraList[i].dialogCameraIndexHy = false;
          }
          arr.push(this.dialogCameraList[i]);
        }
        this.dialogCameraList = arr;
      } else if (type == "hyList") {
        //dialogCameraListNew   dialogCameraIndexHyList
        let arr = [];
        for (let i = 0; i < this.dialogCameraListNew.length; i++) {
          if (this.dialogCameraListNew[i].id == data.id) {
            this.dialogCameraListNew[i].dialogCameraIndexHyList = false;
          }
          arr.push(this.dialogCameraListNew[i]);
        }
        this.dialogCameraListNew = arr;
      } else if (type == "cf") {
        //dialogCameraCfList   dialogCameraIndexCf
        let arr = [];
        for (let i = 0; i < this.dialogCameraCfList.length; i++) {
          if (this.dialogCameraCfList[i].id == data.id) {
            this.dialogCameraCfList[i].dialogCameraIndexCf = false;
          }
          arr.push(this.dialogCameraCfList[i]);
        }
        this.dialogCameraCfList = arr;
      } else if (type == "cfList") {
        //dialogCameraCfListNew   dialogCameraIndexCfList
        let arr = [];
        for (let i = 0; i < this.dialogCameraCfListNew.length; i++) {
          if (this.dialogCameraCfListNew[i].id == data.id) {
            this.dialogCameraCfListNew[i].dialogCameraIndexCfList = false;
          }
          arr.push(this.dialogCameraCfListNew[i]);
        }
        this.dialogCameraCfListNew = arr;
      } else if (type == "dwdl") {
        //dialogCameraDwdlList   dialogCameraIndexDwdl
        let arr = [];
        for (let i = 0; i < this.dialogCameraDwdlList.length; i++) {
          if (this.dialogCameraDwdlList[i].id == data.id) {
            this.dialogCameraDwdlList[i].dialogCameraIndexDwdl = false;
          }
          arr.push(this.dialogCameraDwdlList[i]);
        }
        this.dialogCameraDwdlList = arr;
      } else if (type == "dwdlList") {
        //dialogCameraDwdlListNew   dialogCameraIndexDwdlList
        let arr = [];
        for (let i = 0; i < this.dialogCameraDwdlListNew.length; i++) {
          if (this.dialogCameraDwdlListNew[i].id == data.id) {
            this.dialogCameraDwdlListNew[i].dialogCameraIndexDwdlList = false;
          }
          arr.push(this.dialogCameraDwdlListNew[i]);
        }
        this.dialogCameraDwdlListNew = arr;
      } else if (type == "xftd") {
        //dialogCameraXftdList   dialogCameraIndexXftd
        let arr = [];
        for (let i = 0; i < this.dialogCameraXftdList.length; i++) {
          if (this.dialogCameraXftdList[i].id == data.id) {
            this.dialogCameraXftdList[i].dialogCameraIndexXftd = false;
          }
          arr.push(this.dialogCameraXftdList[i]);
        }
        this.dialogCameraXftdList = arr;
      } else if (type == "xftdList") {
        //dialogCameraXftdListNew    dialogCameraIndexXftdList
        let arr = [];
        for (let i = 0; i < this.dialogCameraXftdListNew.length; i++) {
          if (this.dialogCameraXftdListNew[i].id == data.id) {
            this.dialogCameraXftdListNew[i].dialogCameraIndexXftdList = false;
          }
          arr.push(this.dialogCameraXftdListNew[i]);
        }
        this.dialogCameraXftdListNew = arr;
      } else if (type == "fhm") {
        //dialogCameraFhmList   dialogCameraIndexFhm
        let arr = [];
        for (let i = 0; i < this.dialogCameraFhmList.length; i++) {
          if (this.dialogCameraFhmList[i].id == data.id) {
            this.dialogCameraFhmList[i].dialogCameraIndexFhm = false;
          }
          arr.push(this.dialogCameraFhmList[i]);
        }
        this.dialogCameraFhmList = arr;
      } else if (type == "fhmList") {
        //dialogCameraFhmListNew    dialogCameraIndexFhmList
        let arr = [];
        for (let i = 0; i < this.dialogCameraFhmListNew.length; i++) {
          if (this.dialogCameraFhmListNew[i].id == data.id) {
            this.dialogCameraFhmListNew[i].dialogCameraIndexFhmList = false;
          }
          arr.push(this.dialogCameraFhmListNew[i]);
        }
        this.dialogCameraFhmListNew = arr;
      } else if (type == "ddcwg") {
        //dialogDdcwgyjDataList   dialogCameraIndexDdcwgyj
        let arr = [];
        for (let i = 0; i < this.dialogDdcwgyjDataList.length; i++) {
          if (this.dialogDdcwgyjDataList[i].id == data.id) {
            this.dialogDdcwgyjDataList[i].dialogCameraIndexDdcwgyj = false;
          }
          arr.push(this.dialogDdcwgyjDataList[i]);
        }
        this.dialogDdcwgyjDataList = arr;
      } else if (type == "ddcwgList") {
        let arr = [];
        for (let i = 0; i < this.dialogDdcwgyjDataListNew.length; i++) {
          if (this.dialogDdcwgyjDataListNew[i].id == data.id) {
            this.dialogDdcwgyjDataListNew[
              i
              ].dialogCameraIndexDdcwgyjList = false;
          }
          arr.push(this.dialogDdcwgyjDataListNew[i]);
        }
        this.dialogDdcwgyjDataListNew = arr;
      } else if (type == "dianti") {
        _this.dialogCameraDiantiList = _this.dialogCameraDiantiList.filter(
          (v) => v.id != data.id
        );
        _this.stopBellRing();
        _this.$router.push("/elevatorDangers");
        return;
      }
      //公共方法：去掉报警框，打开派警框
      _this.stopBellRing();

      _this.dialogTitle = data.dialogTitle;
      _this.dialog.hiddenAlarm = false;
      _this.dialog.pinkAlarmDialog = true;
      setTimeout(() => {
        _this.$refs.firePink.handleSearch();
      });
    },

    hiddenAlarm(data) {
      //隐患举报
      _this.HiddenmsgDetail = data.msgDetail;
      _this.dialog.hiddenAlarm = true;
    },

    //微信隐患报警 点击接警  --当前
    pinkAlarm(data, list, wx_sign) {
      // _this.dialogWxyhData 微信隐患数据暂存表
      // _this.dialogHiddenList 实际弹窗数据表
      // data 当前点击接警的数据alarmId(派警单id)
      // list 当前正在弹窗的所有的数据
      // 过滤已经接警的数据（实际弹窗数据暂存表）  根据==派警单id==进行过滤
      if (wx_sign == "0") {
        _this.detelPopUpWxyhData(data, list);
      } else if (wx_sign == "1") {
        _this.dialogHiddenListNew = []; //微信隐患--列表
        _this.detelPopUpWxyhData(data, list);
      }
    },

    //催告弹框
    summonAlarm(data) {
      this.$router.push("/announce");
    },

    //微信隐患弹框接警后det后 微信隐患共同
    detelPopUpWxyhData(data, list) {
      const newListSj = list.filter((v) => v.alarmId !== data);
      _this.dialogHiddenList = [];
      for (var i = 0; i < newListSj.length; i++) {
        let aj = newListSj[i];
        _this.dialogHiddenList.push(aj); //实际弹窗数据表
      }
      const newListZc = _this.dialogWxyhData.filter((v) => v.alarmId !== data); // 过滤已经接警的数据（微信隐患举报暂存数据表）
      _this.dialogWxyhData = [];
      for (var i = 0; i < newListZc.length; i++) {
        let aj = newListZc[i];
        _this.dialogWxyhData.push(aj); //微信隐患暂存数据表
      }
      _this.stopBellRing();
      _this.dialog.hiddenAlarm = false;
      _this.dialog.pinkAlarmDialog = true;
      setTimeout(() => {
        _this.$refs.firePink.handleSearch();
      });
    },

    //微信防火隐患报警 点击接警  --当前
    pinkAlarmFh(data, list, wxfh_sign) {
      //_this.dialogWxyhData 微信隐患数据暂存表
      // _this.dialogHiddenList 实际弹窗数据表
      // data 当前点击接警的数据alarmId(派警单id)
      // list 当前正在弹窗的所有的数据
      // 过滤已经接警的数据（实际弹窗数据暂存表）  根据==派警单id==进行过滤
      if (wxfh_sign == "0") {
        _this.detelPopUpWxfhData(data, list);
      } else if (wxfh_sign == "1") {
        _this.dialogWxfhData = []; //微信防火--列表
        _this.detelPopUpWxfhData(data, list);
      }
      setTimeout(() => {
        _this.$refs.firePink.handleSearch();
      });
    },

    //微信防火弹框接警后det后 微信隐患共同
    detelPopUpWxfhData(data, list) {
      const newListSj = list.filter((v) => v.alarmId !== data);
      _this.dialogfhHiddenList = [];
      for (var i = 0; i < newListSj.length; i++) {
        let aj = newListSj[i];
        _this.dialogfhHiddenList.push(aj); //实际弹窗数据表
      }
      const newListZc = _this.dialogWxfhData.filter((v) => v.alarmId !== data); // 过滤已经接警的数据（微信隐患举报暂存数据表）
      _this.dialogWxfhData = [];
      for (var i = 0; i < newListZc.length; i++) {
        let aj = newListZc[i];
        _this.dialogWxfhData.push(aj); //微信隐患暂存数据表
      }
      _this.stopBellRing();
      _this.dialog.hiddenAlarm = false;
      _this.dialog.pinkAlarmDialog = true;
      setTimeout(() => {
        _this.$refs.firePink.handleSearch();
      });
    },

    stopBellRing() {
      console.log("关闭警铃");
      let _this = this;
      let idStr = _this.videoMsg.idStr;
      var data = {
        msgId: idStr,
      };
      var success = function (resp) {
        _this.videoMsg = "";
      };
      this.http.post("/wxf/msg/readMsg", data, success);
    },

    closePinkAlarmDialog() {
      _this.dialog.pinkAlarmDialog = false;
    },

    jumpVideo1() {
      let _this = this;
      _this.isButt = !_this.isButt;
      var success = function (resp) {
        if (resp) {
          _this.player = new WasmPlayer(null, "Player", _this.callbackfun);
          _this.player.play(resp.url, 1);
          _this.isviwo = true;
        } else {
          _this.isviwo = false;
          _this.player.closeAudio();
        }
      };
      this.http.post(
        "/webapi/probeEquipment/seevideo",
        {id: _this.alarmId},
        success
      );
    },

    jumpVideo2() {
      let _this = this;
      _this.isButt = !_this.isButt;
      var success = function (resp) {
        if (resp.url) {
          _this.$message.success("实时视频获取成功！");
          _this.player = new WasmPlayer(null, "Player", _this.callbackfun);
          _this.player.play(resp.url, 1);
          if (_this.isButt) {
            if (
              resp.equipment.cvrDevice !== null &&
              resp.equipment.cvrChannel !== null
            ) {
              begin(resp.equipment.cvrDevice, resp.equipment.cvrChannel);
            }
          } else {
            end();
          }
        } else {
          _this.$message.error("实时视频加载失败！");
          _this.player.closeAudio();
        }
      };
      this.http.post(
        "/webapi/probeEquipment/viewTheVideo",
        {id: _this.alarmId},
        success
      );
    },

    //电动车治理   拨打电话按钮
    alarmPhoneClick(row) {
      if (_this.photoSign != 0) {
        _this.$message.warning(
          "您已拨打成功，避免重复接听，请您30S之后再次尝试！"
        );
        return;
      }
      let success = function (resp) {
        if (resp.code == "0") {
          _this.photoSign = 1;
          setTimeout(function () {
            _this.photoSign = 0;
          }, 30 * 1000);
          _this.$message.success("拨打成功，请注意接听！");
        } else {
          _this.$message.error(resp.msg);
        }
      };
      this.http.post(
        "/webapi/electricVehicle/telephoneDisposal",
        {id: row.alarmId},
        success
      );
      // this.http.post('/webapi/electricVehicle/testCall',{id:row.alarmId},success);
    },

    //视频呼叫关闭弹窗sdk
    closeSDK(v, type) {
      //关闭sdk方法
      _this.closeSDKPublic(v, type);
      //弹框关闭运行的方法
      _this.handle_close_dialog(v, type);
    },

    //视频呼叫接警，先关闭视频、音频、SDK,再接警
    fourKindVideoAlarm(v, type) {
      //运行接警方法
      _this.fourKindAlarm(v, type);

      let newType;
      if (type == "spbj") {
        newType = "zd";
        //关闭报警弹窗
        _this.dialogCameraSpbjList = _this.dialogCameraSpbjList.filter(
          (v) => v.id != v.id
        );
      } else if (type == "spbjList") {
        newType = "list";
        //关闭报警弹窗
        _this.dialogCameraSpbjListNew = _this.dialogCameraSpbjListNew.filter(
          (v) => v.id != v.id
        );
      }

      //关闭sdk
      _this.closeSDKPublic(v, newType);
    },
    //呼叫火眼接警，先关闭视频、音频、SDK,再接警
    fourKindVideoAlarm1(v, type) {
      //运行接警方法
      _this.fourKindAlarm(v, type);

      let newType;
      if (type == "hjhy") {
        newType = "zd";
        //关闭报警弹窗
        _this.dialogCameraHjhyList = _this.dialogCameraHjhyList.filter(
          (v) => v.id != v.id
        );
      } else if (type == "hjhyList") {
        newType = "list";
        //关闭报警弹窗
        _this.dialogCameraHjhyListNew = _this.dialogCameraHjhyListNew.filter(
          (v) => v.id != v.id
        );
      }

      //关闭sdk
      _this.closeSDKPublic(v, newType);
    },

    //关闭sdk公共方法
    closeSDKPublic(v, type) {
      if (_this.sdkSign) {
        //关闭音频视频
        if (_this.closeSDKSign) {
          _this.jumpVideo2_spbj(v, type);
        }
        setTimeout(function () {
          _this.sdkSign
            .destroy()
            .then(() => {
              _this.sdkSign = null;
              console.log("sdk关闭成功！");
            })
            .catch(() => {
              _this.sdkSign = null;
              console.log("sdk关闭失败！");
            });
        }, 1500);
      }
    },

    //视频报警视频开启与关闭按钮  -- 列表
    jumpVideo2_spbj(data, type) {
      let _this = this;
      if (_this.isButt_spbj) {
        //关闭逻辑：先关闭监控，再关闭sdk (在监听到监控已关闭得方法内，运行关闭sdk方法)
        //关闭右侧视频框
        _this.isButt_spbj = false;
        _this.player_voice.type = "";
        //开启语音-重置图标
        _this.player_voice.sign = true;
        //关闭视频-关闭语音-关闭sdk
        //关闭视频
        if (type == "zd") {
          closeAlarm("zd");
        } else if (type == "list") {
          closeVideo();
        }

        //关闭的标记
        _this.closeSDKSign = false;
      } else {
        //开启逻辑：先开启sdk,再连接监控  (在监听到sdk已开启的方法内，运行开启视频监控的方法)
        //打开右侧视频框
        _this.isButt_spbj = true;
        _this.player_voice.type = "player_spbj";
        // 拿到sdk账号
        let sdkUserName = _this.$store.state.sdkUserName;
        //拿到sdk
        let sdkObj = _this.sdkSign;
        //即将开启sdk视频
        _this.closeSDKSign = true;
        //开视频
        if (type == "zd") {
          let id = "img" + data.id;
          let dom = document.getElementById(id);
          dom.style.display = "none";
          //sdk已开启，开启视频音频
          openSDK(data.id, "zd", data.ref.msgUrl, sdkUserName, sdkObj);
        } else if (type == "list") {
          //sdk已开启，开启视频音频
          openSDK(data.id, "list", data.ref.msgUrl, sdkUserName, sdkObj);
        }
      }
    },

    // **********==========
    //堆物堆料视频开启与关闭按钮
    jumpVideo2_fhm_ot(data) {
      let _this = this;
      _this.jumpVideo2_all_ot(data);
    },

    //火眼视频开启与关闭按钮
    jumpVideo2_hy_ot(data) {
      let _this = this;
      _this.jumpVideo2_all_ot(data);
    },

    //消防车道视频开启与关闭按钮
    jumpVideo2_xftd_ot(data) {
      let _this = this;
      _this.jumpVideo2_all_ot(data);
    },

    //电动车视频开启与关闭按钮
    jumpVideo2_ddc_ot(data) {
      let _this = this;
      _this.jumpVideo2_all_ot(data);
    },

    //堆物堆料视频开启与关闭按钮
    jumpVideo2_dwdl_ot(data) {
      let _this = this;
      _this.jumpVideo2_all_ot(data);
    },

    //视频共同方法
    jumpVideo2_all_ot(data) {
      let _this = this;
      //设备信息
      let row = data.ref.probeInfo;

      //easycvr
      // let row = {
      // 	brand: null,
      // 	equipmentId: null,
      // 	gbCodeID: "34020000001320003083",
      // 	gbDeviceID: "34020000001320000083",
      // 	id: "62",
      // 	imei: "EF00000000852E44",
      // 	ipAddress: null,
      // 	label: "111楼-1单元-10层-楼梯右",
      // 	lat: "39.92561",
      // 	lifeCycle: "1",
      // 	lng: "116.438814",
      // 	password: null,
      // 	pid: "1338462971336065026",
      // 	platform: "Easycvr",
      // 	proxyPort: null,
      // 	rtspPort: null,
      // 	username: null
      // };

      //Linkcvr
      // let row = {
      // 	brand: null,
      // 	equipmentId: null,
      // 	gbCodeID: "34020000009990202277",
      // 	gbDeviceID: "34020000009990202277",
      // 	id: "249",
      // 	imei: "EF00000000852EDD",
      // 	ipAddress: null,
      // 	label: "12号楼-1单元-10层-北楼梯",
      // 	lat: "null",
      // 	lifeCycle: "1",
      // 	lng: "null",
      // 	password: null,
      // 	pid: "1565157148126691330",
      // 	platform: "Linkcvr",
      // 	proxyPort: null,
      // 	rtspPort: null,
      // 	username: null
      // };

      //LVC
      // let row = {
      // 	brand: "hik",
      // 	equipmentId: "1588107270791753729",
      // 	gbCodeID: null,
      // 	gbDeviceID: null,
      // 	id: "6",
      // 	imei: "DS-2CD3T46WD-L20200628AACHE54598834",
      // 	ipAddress: "192.168.1.214",
      // 	label:"1号楼东向西",
      // 	lat: "39.935538",
      // 	lifeCycle: "0",
      // 	lng: "116.464217",
      // 	password: "abc12345",
      // 	pid: "1600383647850958850",
      // 	platform: "LVC",
      // 	proxyPort: "2020",
      // 	rtspPort: "554",
      // 	username:"admin"
      // }

      if (row.platform == "Easycvr") {
        let submit = {id: row.pid, type: "HLS"};
        //打开视频外容器
        _this.alarmDialogVideo.visible = true;
        //打开loading
        _this.alarmDialogVideo.loading = true;
        let success = function (resp) {
          //关闭loading
          _this.alarmDialogVideo.loading = false;
          let plyerUrl = resp.url;
          if (plyerUrl) {
            let newPlayurl = plyerUrl;
            //创建video节点
            let videoDiv = document.createElement("div");
            videoDiv.style.width = "100%";
            videoDiv.style.height = "100%";
            videoDiv.style.textAlign = "center";
            videoDiv.innerHTML = `
							<video id='easycvr${row.imei}' typeSign='Easycvr' controls autoplay muted preload='metadata' class='video video-js vjs-big-play-centered' data-setup='{}' style='width:auto;height:100%;position:relative;margin: 0 auto'>autoplay width="1000px" controls>
								<source src='${newPlayurl}' type="application/x-mpegURL">
							</video>
						`;
            document
              .getElementById("videoContent")
              .appendChild(videoDiv.cloneNode(true));

            setTimeout(function () {
              let m3u8UrlObj = "";
              m3u8UrlObj = videojs(`easycvr${row.imei}`, {
                bigPlayButton: true,
                textTrackDisplay: false,
                posterImage: false,
                errorDisplay: false,
              });
              m3u8UrlObj.play();
              //更新已经打开的暂存视频流数
              let obj = {id: row.id, type: "Easycvr", m3u8Url: m3u8UrlObj};
              _this.alarmDialogVideo.videoObj = obj;
            });
          } else {
            _this.$message.error("视频流为空！");
            //关闭视频外容器
            setTimeout(function () {
              _this.alarmDialogVideo.visible = false;
            }, 2000);
          }
        };
        this.http.post("/webapi/probeEquipment/inLine", submit, success);
      } else if (row.platform == "Linkcvr") {
        let deviceId = row.gbDeviceID;
        let channelId = row.gbCodeID;
        if (!deviceId) {
          _this.$message.error("该设备的gbDeviceID为null");
          return;
        }
        if (!channelId) {
          _this.$message.error("该设备的gbCodeID为null");
          return;
        }

        //打开视频外容器
        _this.alarmDialogVideo.visible = true;
        //打开loading
        _this.alarmDialogVideo.loading = true;

        //获取视频流
        $.ajax({
          // url: 'http://link.00e.com/api/play/start/' + deviceId + '/' + channelId,
          url: `https://www.00e.com/apis/webapi/probeEquipment/play?deviceId=${deviceId}&channelId=${channelId}`,
          type: "get",
          dataType: "json",
          data: "",
        })
          .done(function (resp) {
            //关闭loading
            _this.alarmDialogVideo.loading = false;
            if (resp.code == "0") {
              if (!resp.data.wss_fmp4) {
                _this.$message.error("视频流为空！");
                return;
              }
              let plyerUrl = resp.data.wss_fmp4.replace(
                "wss://114.242.16.189:442",
                "https://qinwu.00e.com"
              );
              let newPlayurl = plyerUrl;

              //创建video节点
              let videoDiv = document.createElement("div");
              videoDiv.style.width = "100%";
              videoDiv.style.height = "100%";
              videoDiv.style.textAlign = "center";
              videoDiv.innerHTML = `
							<video id='${row.imei}' typeSign='Linkcvr' class='video' controls autoplay muted preload='metadata' style='width:auto;height:100%;position:relative;margin: 0 auto'>
								<source src='${newPlayurl}' type='video/mp4'>
							</video>
						`;
              document
                .getElementById("videoContent")
                .appendChild(videoDiv.cloneNode(true));

              let obj = {id: row.id, type: "Linkcvr"};
              _this.alarmDialogVideo.videoObj = obj;
            } else {
              _this.$message.error("视频流为空！");
              //关闭视频外容器
              setTimeout(function () {
                _this.alarmDialogVideo.visible = false;
              }, 2000);
            }
          })
          .fail(function (err) {
            _this.$message.error("视频获取失败！");
            //关闭视频外容器
            setTimeout(function () {
              _this.alarmDialogVideo.visible = false;
            }, 2000);
          });
      } else if (row.platform == "LVC") {
        if (!row.equipmentId) return;
        if (!row.imei) {
          _this.$message.error("该设备编码为空，获取视频流失败！");
          return;
        }

        //获取视频流
        let submit = {
          id: row.imei,
          ipAddress: row.ipAddress,
          username: row.username,
          password: row.password,
          rtspPort: row.rtspPort,
          brand: row.brand,
          port: row.proxyPort,
        };

        //打开视频外容器
        _this.alarmDialogVideo.visible = true;
        //打开loading
        _this.alarmDialogVideo.loading = true;

        let success = function (resp) {
          //关闭loading
          _this.alarmDialogVideo.loading = false;
          if (resp.mp4) {
            let plyerUrl = resp.mp4;
            let newPlayurl = plyerUrl;

            //创建video节点
            let videoDiv = document.createElement("div");
            videoDiv.style.width = "100%";
            videoDiv.style.height = "100%";
            videoDiv.style.textAlign = "center";
            videoDiv.innerHTML = `
							<video id='${row.imei}' typeSign='LVC' class='video' controls autoplay muted preload='metadata' style='width:auto;height:100%;position:relative;margin: 0 auto'>
								<source src='${newPlayurl}' type='video/mp4'>
							</video>
						`;
            document
              .getElementById("videoContent")
              .appendChild(videoDiv.cloneNode(true));

            let obj = {id: row.id, type: "LVC"};
            _this.alarmDialogVideo.videoObj = obj;
          } else {
            _this.$message.error("获取视频流失败！");
            //关闭视频外容器
            setTimeout(function () {
              _this.alarmDialogVideo.visible = false;
            }, 2000);
          }
        };

        this.http.get("/webapi/lvcProbe/trustPlay", submit, success);
      }
    },

    //报警视频弹框关闭弹框按钮
    iconClose_video_ot() {
      let _this = this;
      //停视频流
      let video = document
        .getElementById("videoContent")
        .querySelector("video");
      if (_this.alarmDialogVideo.videoObj.type) {
        if (_this.alarmDialogVideo.videoObj.type == "Easycvr") {
          // easycvr
          _this.alarmDialogVideo.videoObj.m3u8Url.pause();
          _this.alarmDialogVideo.videoObj.m3u8Url.dispose();
        } else {
          // linkcvr  lvc
          video.pause();
          video.load();
          video.removeAttribute("src");
        }
      }
      //清空暂存的视频
      _this.alarmDialogVideo.videoObj = {};
      //删除视频外容器内的元素
      document.getElementById("videoContent").innerHTML = "";
      //关闭视频容器
      _this.alarmDialogVideo.visible = false;
    },

    // **********==========

    //消防车道视频开启与关闭按钮
    jumpVideo2_xftd(data) {
      let _this = this;
      if (_this.isButt_xftd) {
        //关闭视频
        if (
          _this.player_voice.forbid &&
          _this.player_voice.type == "player_xftd"
        ) {
          _this.player_xftd.destroy();
          _this.player_xftd = "";
        }
        //清空语音
        _this.player_voice.type = "";
        _this.player_voice.forbid = false;
        //销毁定时器
        clearInterval(_this.setInterval.xftdvideo);
        _this.setInterval.xftdvideo = null;
        //关闭右侧视频框
        _this.isButt_xftd = false;
      } else {
        _this.isButt_xftd = true;
        let sign = 1;
        var success = function (resp) {
          if (resp.url) {
            sign++;
            if (sign - 2 < 1) {
              _this.$message.success("实时视频获取成功！");
              _this.player_voice.forbid = true;
              _this.player_voice.type = "player_xftd";
              _this.player_xftd = new WasmPlayer(
                null,
                data.id,
                _this.callbackfun
              );
              _this.player_xftd.play(resp.url, 1);
            }
          } else {
            _this.player_voice.forbid = false;
            _this.$message.error("实时视频加载失败！");
          }
        };
        this.http.post(
          "/webapi/probeEquipment/viewTheVideo",
          {id: data.ref.alarmId},
          success
        );
        _this.setInterval.xftdvideo = setInterval(function () {
          this.http.post(
            "/webapi/probeEquipment/viewTheVideo",
            {id: data.ref.alarmId},
            success
          );
        }, 15 * 1000);
      }
    },

    //防火门视频开启与关闭按钮
    jumpVideo2_fhm(data) {
      let _this = this;
      if (_this.isButt_fhm) {
        //关闭视频
        if (
          _this.player_voice.forbid &&
          _this.player_voice.type == "player_fhm"
        ) {
          _this.player_fhm.destroy();
          _this.player_fhm = "";
        }
        //清空语音
        _this.player_voice.type = "";
        _this.player_voice.forbid = false;

        //销毁定时器
        clearInterval(_this.setInterval.fhmvideo);
        _this.setInterval.fhmvideo = null;
        //关闭右侧视频框
        _this.isButt_fhm = false;
      } else {
        _this.isButt_fhm = true;
        let sign = 1;
        var success = function (resp) {
          if (resp.url) {
            sign++;
            if (sign - 2 < 1) {
              _this.$message.success("实时视频获取成功！");
              _this.player_voice.forbid = true;
              _this.player_voice.type == "player_fhm";
              _this.player_fhm = new WasmPlayer(
                null,
                data.id,
                _this.callbackfun
              );
              _this.player_fhm.play(resp.url, 1);
            }
          } else {
            _this.player_voice.forbid = false;
            _this.$message.error("实时视频加载失败！");
          }
        };
        this.http.post(
          "/webapi/probeEquipment/viewTheVideo",
          {id: data.ref.alarmId},
          success
        );
        _this.setInterval.fhmvideo = setInterval(function () {
          this.http.post(
            "/webapi/probeEquipment/viewTheVideo",
            {id: data.ref.alarmId},
            success
          );
        }, 15 * 1000);
      }
    },

    //电动车视频开启与关闭按钮
    jumpVideo2_ddc(data) {
      let _this = this;
      if (_this.isButt_ddc) {
        //关闭语音
        if (
          !_this.player_voice.sign &&
          _this.player_voice.type == "player_ddc"
        ) {
          _this.player_ddc.closeAudio();
          end(_this.player_voice.cvrDevice, _this.player_voice.cvrChannel);
        }
        //关闭视频
        if (
          _this.player_voice.forbid &&
          _this.player_voice.type == "player_ddc"
        ) {
          _this.player_ddc.destroy();
          _this.player_ddc = "";
        }
        //清空语音
        _this.player_voice.sign = true;
        _this.player_voice.forbid = false;
        _this.player_voice.type = "";
        _this.player_voice.cvrDevice = "";
        _this.player_voice.cvrChannel = "";
        //销毁定时器
        clearInterval(_this.setInterval.ddcvideo);
        _this.setInterval.ddcvideo = null;
        //关闭右侧视频框
        _this.isButt_ddc = false;
      } else {
        //打开右侧视频框
        _this.isButt_ddc = true;
        let sign = 1;
        var success = function (resp) {
          if (resp.url) {
            sign++;
            if (sign - 2 < 1) {
              this.$message.success("实时视频获取成功！");
              _this.player_voice.forbid = true;
              _this.player_ddc = new WasmPlayer(
                null,
                data.id,
                _this.callbackfun
              );
              _this.player_ddc.play(resp.url, 1);
              if (resp.equipment) {
                if (
                  resp.equipment.cvrDevice !== null &&
                  resp.equipment.cvrChannel !== null
                ) {
                  _this.player_voice.type = "player_ddc";
                  _this.player_voice.cvrDevice = resp.equipment.cvrDevice;
                  _this.player_voice.cvrChannel = resp.equipment.cvrChannel;
                }
              } else {
                // "https://gbs.guanjia360.com/api/v1/devices/channelstream?device=286&channel=362"
                let device = resp.keepUrl.match(/device=(\S*)&channel/)[1];
                let channel = resp.keepUrl.match(/&channel=(\S*)/)[1];
                _this.player_voice.type = "player_ddc";
                _this.player_voice.cvrDevice = device;
                _this.player_voice.cvrChannel = channel;
              }
            }
          } else {
            _this.player_voice.forbid = false;
            this.$message.error("实时视频加载失败！");
          }
        };
        this.http.post(
          "/webapi/probeEquipment/viewTheVideo",
          {id: data.ref.alarmId},
          success
        );
        _this.setInterval.ddcvideo = setInterval(function () {
          this.http.post(
            "/webapi/probeEquipment/viewTheVideo",
            {id: data.ref.alarmId},
            success
          );
        }, 15 * 1000);
      }
    },

    //共享单车视频开启与关闭按钮
    jumpVideo2_gxche_ot(data) {
      let _this = this;
      _this.jumpVideo2_all_ot(data);
    },

    //共享单车视频开启与关闭按钮
    jumpVideo2_gxche(data) {
      let _this = this;
      if (_this.isButt_gxche) {
        //关闭语音
        if (
          !_this.player_voice.sign &&
          _this.player_voice.type == "player_gxche"
        ) {
          _this.player_gxche.closeAudio();
          end(_this.player_voice.cvrDevice, _this.player_voice.cvrChannel);
        }
        //关闭视频
        if (
          _this.player_voice.forbid &&
          _this.player_voice.type == "player_gxche"
        ) {
          _this.player_gxche.destroy();
          _this.player_gxche = "";
        }
        //清空语音
        _this.player_voice.sign = true;
        _this.player_voice.forbid = false;
        _this.player_voice.type = "";
        _this.player_voice.cvrDevice = "";
        _this.player_voice.cvrChannel = "";
        //销毁定时器
        clearInterval(_this.setInterval.gxchevideo);
        _this.setInterval.gxchevideo = null;
        //关闭右侧视频框
        _this.isButt_gxche = false;
      } else {
        //打开右侧视频框
        _this.isButt_gxche = true;
        let sign = 1;
        var success = function (resp) {
          if (resp.url) {
            sign++;
            if (sign - 2 < 1) {
              this.$message.success("实时视频获取成功！");
              _this.player_voice.forbid = true;
              _this.player_gxche = new WasmPlayer(
                null,
                data.id,
                _this.callbackfun
              );
              _this.player_gxche.play(resp.url, 1);
              if (resp.equipment) {
                if (
                  resp.equipment.cvrDevice !== null &&
                  resp.equipment.cvrChannel !== null
                ) {
                  _this.player_voice.type = "player_gxche";
                  _this.player_voice.cvrDevice = resp.equipment.cvrDevice;
                  _this.player_voice.cvrChannel = resp.equipment.cvrChannel;
                }
              } else {
                // "https://gbs.guanjia360.com/api/v1/devices/channelstream?device=286&channel=362"
                let device = resp.keepUrl.match(/device=(\S*)&channel/)[1];
                let channel = resp.keepUrl.match(/&channel=(\S*)/)[1];
                _this.player_voice.type = "player_gxche";
                _this.player_voice.cvrDevice = device;
                _this.player_voice.cvrChannel = channel;
              }
            }
          } else {
            _this.player_voice.forbid = false;
            this.$message.error("实时视频加载失败！");
          }
        };
        this.http.post(
          "/webapi/probeEquipment/viewTheVideo",
          {id: data.ref.alarmId},
          success
        );
        _this.setInterval.gxchevideo = setInterval(function () {
          this.http.post(
            "/webapi/probeEquipment/viewTheVideo",
            {id: data.ref.alarmId},
            success
          );
        }, 15 * 1000);
      }
    },

    //电池视频开启与关闭按钮
    jumpVideo2_dc(data) {
      let _this = this;
      if (_this.isButt_dc) {
        //关闭语音
        if (
          !_this.player_voice.sign &&
          _this.player_voice.type == "player_dc"
        ) {
          _this.player_dc.closeAudio();
          end(_this.player_voice.cvrDevice, _this.player_voice.cvrChannel);
        }
        //关闭视频
        if (
          _this.player_voice.forbid &&
          _this.player_voice.type == "player_dc"
        ) {
          _this.player_dc.destroy();
          _this.player_dc = "";
        }
        //清空语音
        _this.player_voice.sign = true;
        _this.player_voice.forbid = false;
        _this.player_voice.type = "";
        _this.player_voice.cvrDevice = "";
        _this.player_voice.cvrChannel = "";
        //销毁定时器
        clearInterval(_this.setInterval.dcvideo);
        _this.setInterval.dcvideo = null;
        //关闭右侧视频框
        _this.isButt_dc = false;
      } else {
        //打开右侧视频框
        _this.isButt_dc = true;
        let sign = 1;
        var success = function (resp) {
          if (resp.url) {
            sign++;
            if (sign - 2 < 1) {
              this.$message.success("实时视频获取成功！");
              _this.player_voice.forbid = true;
              _this.player_dc = new WasmPlayer(
                null,
                data.id,
                _this.callbackfun
              );
              _this.player_dc.play(resp.url, 1);
              if (resp.equipment) {
                if (
                  resp.equipment.cvrDevice !== null &&
                  resp.equipment.cvrChannel !== null
                ) {
                  _this.player_voice.type = "player_dc";
                  _this.player_voice.cvrDevice = resp.equipment.cvrDevice;
                  _this.player_voice.cvrChannel = resp.equipment.cvrChannel;
                }
              } else {
                // "https://gbs.guanjia360.com/api/v1/devices/channelstream?device=286&channel=362"
                let device = resp.keepUrl.match(/device=(\S*)&channel/)[1];
                let channel = resp.keepUrl.match(/&channel=(\S*)/)[1];
                _this.player_voice.type = "player_dc";
                _this.player_voice.cvrDevice = device;
                _this.player_voice.cvrChannel = channel;
              }
            }
          } else {
            _this.player_voice.forbid = false;
            _this.$message.error("实时视频加载失败！");
          }
        };
        this.http.post(
          "/webapi/probeEquipment/viewTheVideo",
          {id: data.ref.alarmId},
          success
        );
        _this.setInterval.dcvideo = setInterval(function () {
          this.http.post(
            "/webapi/probeEquipment/viewTheVideo",
            {id: data.ref.alarmId},
            success
          );
        }, 15 * 1000);
      }
    },

    //后厨视频开启与关闭按钮
    jumpVideo2_cf(data) {
      let _this = this;
      if (_this.isButt_cf) {
        _this.isButt_cf = false;
        if (_this.player_voice.forbid) {
          _this.player_cf.destroy();
        }
        _this.player_cf = "";
        //清空语音
        _this.player_voice.sign = true;
        _this.player_voice.forbid = true;
        _this.player_voice.type = "";
        _this.player_voice.cvrDevice = "";
        _this.player_voice.cvrChannel = "";

        //关闭语音
        if (
          !_this.player_voice.sign &&
          _this.player_voice.type == "player_cf"
        ) {
          _this.player_cf.closeAudio();
          end(_this.player_voice.cvrDevice, _this.player_voice.cvrChannel);
        }
        //关闭视频
        if (
          _this.player_voice.forbid &&
          _this.player_voice.type == "player_cf"
        ) {
          _this.player_cf.destroy();
          _this.player_cf = "";
        }
        //清空语音
        _this.player_voice.sign = true;
        _this.player_voice.forbid = false;
        _this.player_voice.type = "";
        _this.player_voice.cvrDevice = "";
        _this.player_voice.cvrChannel = "";
        //销毁定时器
        clearInterval(_this.setInterval.cfvideo);
        _this.setInterval.cfvideo = null;
        //关闭右侧视频框
        _this.isButt_cf = false;
      } else {
        _this.isButt_cf = true;
        let sign = 1;
        var success = function (resp) {
          if (resp.url) {
            sign++;
            if (sign - 2 < 1) {
              _this.$message.success("实时视频获取成功！");
              _this.player_voice.forbid = true;
              _this.player_cf = new WasmPlayer(
                null,
                data.id,
                _this.callbackfun
              );
              _this.player_cf.play(resp.url, 1);

              if (resp.equipment) {
                if (
                  resp.equipment.cvrDevice !== null &&
                  resp.equipment.cvrChannel !== null
                ) {
                  _this.player_voice.type = "player_cf";
                  _this.player_voice.cvrDevice = resp.equipment.cvrDevice;
                  _this.player_voice.cvrChannel = resp.equipment.cvrChannel;
                }
              } else {
                let device = resp.keepUrl.match(/device=(\S*)&channel/)[1];
                let channel = resp.keepUrl.match(/&channel=(\S*)/)[1];
                _this.player_voice.type = "player_cf";
                _this.player_voice.cvrDevice = device;
                _this.player_voice.cvrChannel = channel;
              }
            }
          } else {
            _this.player_voice.forbid = false;
            _this.$message.error("实时视频加载失败！");
          }
        };
        this.http.post(
          "/webapi/probeEquipment/viewTheVideo",
          {id: data.ref.alarmId},
          success
        );
        _this.setInterval.cfvideo = setInterval(function () {
          _this.http.post(
            "/webapi/probeEquipment/viewTheVideo",
            {id: data.ref.alarmId},
            success
          );
        }, 15 * 1000);
      }
    },

    //rfid视频开启与关闭按钮
    jumpVideo2_rfid(data) {
      let _this = this;
      if (_this.isButt_rfid) {
        //关闭语音
        if (
          !_this.player_voice.sign &&
          _this.player_voice.type == "player_rfid"
        ) {
          _this.player_rfid.closeAudio();
          end(_this.player_voice.cvrDevice, _this.player_voice.cvrChannel);
        }
        //关闭视频
        if (
          _this.player_voice.forbid &&
          _this.player_voice.type == "player_rfid"
        ) {
          _this.player_rfid.destroy();
          _this.player_rfid = "";
        }
        //清空语音
        _this.player_voice.sign = true;
        _this.player_voice.forbid = false;
        _this.player_voice.type = "";
        _this.player_voice.cvrDevice = "";
        _this.player_voice.cvrChannel = "";
        //销毁定时器
        clearInterval(_this.setInterval.rfidvideo);
        _this.setInterval.rfidvideo = null;
        //关闭右侧视频框
        _this.isButt_rfid = false;
      } else {
        _this.isButt_rfid = true;
        let sign = 1;
        var success = function (resp) {
          if (resp.url) {
            sign++;
            if (sign - 2 < 1) {
              _this.$message.success("实时视频获取成功！");
              _this.player_voice.forbid = true;
              _this.player_rfid = new WasmPlayer(
                null,
                data.id,
                _this.callbackfun
              );
              _this.player_rfid.play(resp.url, 1);
              if (resp.equipment) {
                if (
                  resp.equipment.cvrDevice !== null &&
                  resp.equipment.cvrChannel !== null
                ) {
                  _this.player_voice.type = "player_rfid";
                  _this.player_voice.cvrDevice = resp.equipment.cvrDevice;
                  _this.player_voice.cvrChannel = resp.equipment.cvrChannel;
                }
              } else {
                // "https://gbs.guanjia360.com/api/v1/devices/channelstream?device=286&channel=362"
                let device = resp.keepUrl.match(/device=(\S*)&channel/)[1];
                let channel = resp.keepUrl.match(/&channel=(\S*)/)[1];
                _this.player_voice.type = "player_rfid";
                _this.player_voice.cvrDevice = device;
                _this.player_voice.cvrChannel = channel;
              }
            }
          } else {
            _this.player_voice.forbid = false;
            _this.$message.error("实时视频加载失败！");
          }
        };
        this.http.post(
          "/webapi/probeEquipment/viewTheVideo",
          {id: data.ref.alarmId},
          success
        );
        _this.setInterval.rfidvideo = setInterval(function () {
          this.http.post(
            "/webapi/probeEquipment/viewTheVideo",
            {id: data.ref.alarmId},
            success
          );
        }, 15 * 1000);
      }
    },

    //手报视频开启与关闭按钮
    jumpVideo2_sb(data) {
      let _this = this;
      if (_this.isButt_sb) {
        //关闭语音
        if (
          !_this.player_voice.sign &&
          _this.player_voice.type == "player_sb"
        ) {
          _this.player_sb.closeAudio();
          end(_this.player_voice.cvrDevice, _this.player_voice.cvrChannel);
        }
        //关闭视频
        if (
          _this.player_voice.forbid &&
          _this.player_voice.type == "player_sb"
        ) {
          _this.player_sb.destroy();
          _this.player_sb = "";
        }
        //清空语音
        _this.player_voice.sign = true;
        _this.player_voice.forbid = false;
        _this.player_voice.type = "";
        _this.player_voice.cvrDevice = "";
        _this.player_voice.cvrChannel = "";
        //销毁定时器
        clearInterval(_this.setInterval.sbvideo);
        _this.setInterval.sbvideo = null;
        //关闭右侧视频框
        _this.isButt_sb = false;
      } else {
        //打开右侧视频框
        _this.isButt_sb = true;
        let sign = 1;
        var success = function (resp) {
          if (resp.url) {
            sign++;
            if (sign - 2 < 1) {
              _this.$message.success("实时视频获取成功！");
              _this.player_voice.forbid = true;
              _this.player_sb = new WasmPlayer(
                null,
                data.id,
                _this.callbackfun
              );
              _this.player_sb.play(resp.url, 1);
              if (resp.equipment) {
                if (
                  resp.equipment.cvrDevice !== null &&
                  resp.equipment.cvrChannel !== null
                ) {
                  _this.player_voice.type = "player_sb";
                  _this.player_voice.cvrDevice = resp.equipment.cvrDevice;
                  _this.player_voice.cvrChannel = resp.equipment.cvrChannel;
                }
              } else {
                // "https://gbs.guanjia360.com/api/v1/devices/channelstream?device=286&channel=362"
                let device = resp.keepUrl.match(/device=(\S*)&channel/)[1];
                let channel = resp.keepUrl.match(/&channel=(\S*)/)[1];
                _this.player_voice.type = "player_sb";
                _this.player_voice.cvrDevice = device;
                _this.player_voice.cvrChannel = channel;
              }
            }
          } else {
            _this.player_voice.forbid = false;
            _this.$message.error("实时视频加载失败！");
          }
        };
        _this.http.post(
          "/webapi/probeEquipment/seevideo",
          {id: data.ref.alarmId},
          success
        );
        _this.setInterval.sbvideo = setInterval(function () {
          _this.http.post(
            "/webapi/probeEquipment/seevideo",
            {id: data.ref.alarmId},
            success
          );
        }, 15 * 1000);
      }
    },

    //火眼视频开启与关闭按钮
    jumpVideo2_hy(data) {
      let _this = this;
      if (_this.isButt_hy) {
        //关闭视频
        if (
          _this.player_voice.forbid &&
          _this.player_voice.type == "player_hy"
        ) {
          _this.player_hy.destroy();
          _this.player_hy = "";
        }
        //清空语音
        _this.player_voice.type = "";
        _this.player_voice.forbid = false;

        //销毁定时器
        clearInterval(_this.setInterval.hyvideo);
        _this.setInterval.hyvideo = null;
        //关闭右侧视频框
        _this.isButt_hy = false;
      } else {
        _this.isButt_hy = true;
        let sign = 1;
        var success = function (resp) {
          if (resp.url) {
            sign++;
            if (sign - 2 < 1) {
              _this.$message.success("实时视频获取成功！");
              _this.player_voice.forbid = true;
              _this.player_voice.type == "player_hy";
              _this.player_hy = new WasmPlayer(
                null,
                data.id,
                _this.callbackfun
              );
              _this.player_hy.play(resp.url, 1);
            }
          } else {
            _this.player_voice.forbid = false;
            _this.$message.error("实时视频加载失败！");
          }
        };
        _this.http.post(
          "/webapi/probeEquipment/viewTheVideo",
          {id: data.ref.alarmId},
          success
        );
        _this.setInterval.hyvideo = setInterval(function () {
          _this.http.post(
            "/webapi/probeEquipment/viewTheVideo",
            {id: data.ref.alarmId},
            success
          );
        }, 15 * 1000);
      }
    },

    //视频视频语音对讲
    voice_open(v) {
      let _this = this;
      let msgSource = _this.player_voice.type;
      if (msgSource == "player_sb") {
        _this.player_sb.openAudio();
      } else if (msgSource == "player_ddc") {
        _this.player_ddc.openAudio();
      } else if (msgSource == "player_dc") {
        _this.player_dc.openAudio();
      } else if (msgSource == "player_cf") {
        _this.player_cf.openAudio();
      } else if (msgSource == "player_rfid") {
        _this.player_rfid.openAudio();
      } else if (msgSource == "player_spbj") {
        _this.openAudioSpbj(v);
      }
      _this.player_voice.sign = false;
      begin(_this.player_voice.cvrDevice, _this.player_voice.cvrChannel);
    },

    // 关闭视频语音对讲
    voice_close() {
      let _this = this;
      let msgSource = _this.player_voice.type;
      if (msgSource == "player_sb") {
        _this.player_sb.closeAudio();
      } else if (msgSource == "player_ddc") {
        _this.player_ddc.closeAudio();
      } else if (msgSource == "player_dc") {
        _this.player_dc.closeAudio();
      } else if (msgSource == "player_cf") {
        _this.player_cf.closeAudio();
      } else if (msgSource == "player_rfid") {
        _this.player_rfid.closeAudio();
      } else if (msgSource == "player_spbj") {
        _this.closeAudioSpbj();
      }
      _this.player_voice.sign = true;
      end(_this.player_voice.cvrDevice, _this.player_voice.cvrChannel);
    },

    //视频报警-开启语音
    openAudioSpbj(data) {
      openAudio();
    },

    //视频报警-关闭语音
    closeAudioSpbj() {
      closeAudio("1");
    },

    //关闭视频
    iconClose() {
      _this.isButt = false;
      _this.Player.closeAudio();
    },

    // 视频关闭按钮
    iconClose_video(data, type) {
      let _this = this;
      if (type) {
        _this.close_dialong(data.msgSourceId, type);
      } else {
        _this.close_dialong(data.msgSourceId);
      }
    },

    //弹框关闭按钮-主按钮
    handle_close_dialog(data, type) {
      //type 视频对讲
      let _this = this;

      if (type) {
        _this.close_dialong(data.msgSourceId, type);
      } else {
        _this.close_dialong(data.msgSourceId);
      }
    },

    //防火门视频 关闭按钮
    iconClose_fhm() {
      _this.isButt_fhm = false;
      _this.Player_fhm.closeAudio();
    },
    //消防车道视频 关闭按钮
    iconClose_xftd() {
      _this.isButt_xftd = false;
      _this.Player_xftd.closeAudio();
    },

    getGwxlTemperatureText(data) {
      const temperatureCandidates = [
        data.temperature,
        data.temp,
        data.tempValue,
        data.temperatureValue,
        data.currentTemp,
        data.ltemp,
        data.ntemp,
        data.alarmValue,
      ];
      let temperatureValue = "";
      for (let i = 0; i < temperatureCandidates.length; i++) {
        const currentValue = temperatureCandidates[i];
        if (
          currentValue !== null &&
          currentValue !== undefined &&
          currentValue !== ""
        ) {
          temperatureValue = currentValue;
          break;
        }
      }

      if (temperatureValue === 0 || temperatureValue === "0") {
        return "0℃";
      }
      if (
        temperatureValue === null ||
        temperatureValue === undefined ||
        temperatureValue === ""
      ) {
        return "78℃";
      }
      return String(temperatureValue).includes("℃")
        ? String(temperatureValue)
        : `${temperatureValue}℃`;
    },

    getGwxlPoint(item) {
      if (!item) {
        return "";
      }
      const source = item.alarmContent || item.msgDetail || "";
      if (!source) {
        return "";
      }
      const match = String(source).match(/第[一-龥\d]+号点位/);
      return match ? match[0] : "";
    },

    formatGwxlTime(value) {
      if (!value) {
        return "";
      }
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) {
        return String(value);
      }
      const pad = (num) => String(num).padStart(2, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
        date.getDate()
      )} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
        date.getSeconds()
      )}`;
    },

    getGwxlLocationText(data) {
      const probeEquipment = this.getGwxlProbeEquipment(data);
      if (probeEquipment && probeEquipment.address1) {
        return probeEquipment.address1;
      }
      return (
        data.location ||
        data.address1 ||
        data.address ||
        data.disasterAddress ||
        data.msgDetail ||
        "西侧变电站"
      );
    },

    getGwxlVideoRow(data) {
      const probeEquipmentDO = this.getGwxlProbeEquipment(data) ||
        data.probeInfo ||
        data.equipment ||
        data.probeEquipment ||
        data.videoEquipment;

      if (probeEquipmentDO) {
        return Object.assign({}, probeEquipmentDO, {
          address1: probeEquipmentDO.address1 || this.getGwxlLocationText(data),
        });
      }

      return Object.assign({}, data || {}, {
        address1: this.getGwxlLocationText(data),
      });
    },

    // 获取所有摄像头设备列表（用于弹窗切换）
    getGwxlVideoRows(data) {
      if (!data || !data.probeEquipmentDO) {
        return [];
      }
      const list = Array.isArray(data.probeEquipmentDO)
        ? data.probeEquipmentDO
        : [data.probeEquipmentDO];
      return list.map((item) =>
        Object.assign({}, item, {
          address1: item.address1 || this.getGwxlLocationText(data),
        })
      );
    },

    getGwxlProbeEquipment(data) {
      if (!data || !data.probeEquipmentDO) {
        return null;
      }
      if (Array.isArray(data.probeEquipmentDO)) {
        if (!data.probeEquipmentDO.length) {
          return null;
        }
        // 优先返回 platform 可播放的设备（LIS/Linkcvr/Easycvr/LVC/LVS），
        // 否则回退到第一个，避免 platform 为空导致 look() 无分支命中、视频不播放
        const playablePlatforms = ["LIS", "Linkcvr", "Linkcvr0", "Linkcvr1", "Linkcvr2", "Easycvr", "LVC", "LVS"];
        const playable = data.probeEquipmentDO.find(
          (item) => item && playablePlatforms.includes(item.platform)
        );
        return playable || data.probeEquipmentDO[0];
      }
      return data.probeEquipmentDO;
    },

    openGwxlVideo(v) {
      const refName = "gwxlLookVideo" + v.id;
      this.$nextTick(() => {
        const lookVideoRef = this.$refs[refName];
        const targetRef = Array.isArray(lookVideoRef) ? lookVideoRef[0] : lookVideoRef;
        if (targetRef && targetRef.look) {
          // 优先用 videoRows 中当前选中的摄像头，否则回退到 videoRow
          const rows = v.videoRows || [];
          const idx = v.activeCameraIndex || 0;
          const row = (rows.length && rows[idx]) ? rows[idx] : (v.videoRow || this.getGwxlVideoRow(v.ref || v));
          targetRef.look(row);
        }
      });
    },

    switchGwxlCamera(v, index) {
      if (v.activeCameraIndex === index) return;
      v.activeCameraIndex = index;
      const refName = "gwxlLookVideo" + v.id;
      const lookVideoRef = this.$refs[refName];
      const targetRef = Array.isArray(lookVideoRef) ? lookVideoRef[0] : lookVideoRef;
      if (targetRef) {
        // 先关闭当前视频流，再播放新的
        if (targetRef.closeVideo) {
          targetRef.closeVideo();
        }
        const rows = v.videoRows || [];
        if (rows[index] && targetRef.look) {
          targetRef.look(rows[index]);
        }
      }
    },

    closeGwxlVideo(v) {
      const refName = "gwxlLookVideo" + v.id;
      const lookVideoRef = this.$refs[refName];
      const targetRef = Array.isArray(lookVideoRef) ? lookVideoRef[0] : lookVideoRef;
      if (targetRef && targetRef.closeVideo) {
        targetRef.closeVideo();
      }
      v.dialogCameraIndexGwxl = false;
      v.dialogCameraIndexGwxlList = false;
    },

    //关闭的公共事件
    close_dialong(msgSourceId, type) {
      let _this = this;
      if (msgSourceId == 22) {
        //====手报
        if (_this.isButt_sb) {
          //如果视频弹框打开中,关闭弹框，关闭视频，关闭音频
          //关闭语音
          if (
            !_this.player_voice.sign &&
            _this.player_voice.type == "player_sb"
          ) {
            _this.player_sb.closeAudio();
            end(_this.player_voice.cvrDevice, _this.player_voice.cvrChannel);
          }
          //关闭视频
          if (
            _this.player_voice.forbid &&
            _this.player_voice.type == "player_sb"
          ) {
            _this.player_sb.destroy();
            _this.player_sb = "";
          }
          //清空语音
          _this.player_voice.sign = true;
          _this.player_voice.forbid = false;
          _this.player_voice.type = "";
          _this.player_voice.cvrDevice = "";
          _this.player_voice.cvrChannel = "";
          //销毁定时器
          clearInterval(_this.setInterval.sbvideo);
          _this.setInterval.sbvideo = null;
          //关闭右侧视频框
          _this.isButt_sb = false;
        }
      } else if (msgSourceId == 14) {
        //====电动车
        if (_this.isButt_ddc) {
          //如果视频弹框打开中,关闭弹框，关闭视频，关闭音频
          //关闭语音
          if (
            !_this.player_voice.sign &&
            _this.player_voice.type == "player_ddc"
          ) {
            _this.player_ddc.closeAudio();
            end(_this.player_voice.cvrDevice, _this.player_voice.cvrChannel);
          }
          //关闭视频
          if (
            _this.player_voice.forbid &&
            _this.player_voice.type == "player_ddc"
          ) {
            _this.player_ddc.destroy();
            _this.player_ddc = "";
          }
          //清空语音
          _this.player_voice.sign = true;
          _this.player_voice.forbid = false;
          _this.player_voice.type = "";
          _this.player_voice.cvrDevice = "";
          _this.player_voice.cvrChannel = "";
          //销毁定时器
          clearInterval(_this.setInterval.ddcvideo);
          _this.setInterval.ddcvideo = null;
          //关闭右侧视频框
          _this.isButt_ddc = false;
        }
      } else if (msgSourceId == 40) {
        //====共享单车
        if (_this.isButt_gxche) {
          //如果视频弹框打开中,关闭弹框，关闭视频，关闭音频
          //关闭语音
          if (
            !_this.player_voice.sign &&
            _this.player_voice.type == "player_gxche"
          ) {
            _this.player_gxche.closeAudio();
            end(_this.player_voice.cvrDevice, _this.player_voice.cvrChannel);
          }
          //关闭视频
          if (
            _this.player_voice.forbid &&
            _this.player_voice.type == "player_gxche"
          ) {
            _this.player_gxche.destroy();
            _this.player_gxche = "";
          }
          //清空语音
          _this.player_voice.sign = true;
          _this.player_voice.forbid = false;
          _this.player_voice.type = "";
          _this.player_voice.cvrDevice = "";
          _this.player_voice.cvrChannel = "";
          //销毁定时器
          clearInterval(_this.setInterval.gxchevideo);
          _this.setInterval.gxchevideo = null;
          //关闭右侧视频框
          _this.isButt_gxche = false;
        }
      } else if (msgSourceId == 26) {
        //====电池
        //如果视频弹框打开中,关闭弹框，关闭视频，关闭音频
        if (_this.isButt_dc) {
          //关闭语音
          if (
            !_this.player_voice.sign &&
            _this.player_voice.type == "player_dc"
          ) {
            _this.player_dc.closeAudio();
            end(_this.player_voice.cvrDevice, _this.player_voice.cvrChannel);
          }
          //关闭视频
          if (
            _this.player_voice.forbid &&
            _this.player_voice.type == "player_dc"
          ) {
            _this.player_dc.destroy();
            _this.player_dc = "";
          }
          //清空语音
          _this.player_voice.sign = true;
          _this.player_voice.forbid = false;
          _this.player_voice.type = "";
          _this.player_voice.cvrDevice = "";
          _this.player_voice.cvrChannel = "";
          //销毁定时器
          clearInterval(_this.setInterval.dcvideo);
          _this.setInterval.dcvideo = null;
          //关闭右侧视频框
          _this.isButt_dc = false;
        }
      } else if (msgSourceId == 27) {
        //====rfid
        if (_this.isButt_rfid) {
          //关闭语音
          if (
            !_this.player_voice.sign &&
            _this.player_voice.type == "player_rfid"
          ) {
            _this.player_rfid.closeAudio();
            end(_this.player_voice.cvrDevice, _this.player_voice.cvrChannel);
          }
          //关闭视频
          if (
            _this.player_voice.forbid &&
            _this.player_voice.type == "player_rfid"
          ) {
            _this.player_rfid.destroy();
            _this.player_rfid = "";
          }
          //清空语音
          _this.player_voice.sign = true;
          _this.player_voice.forbid = false;
          _this.player_voice.type = "";
          _this.player_voice.cvrDevice = "";
          _this.player_voice.cvrChannel = "";
          //销毁定时器
          clearInterval(_this.setInterval.rfidvideo);
          _this.setInterval.rfidvideo = null;
          //关闭右侧视频框
          _this.isButt_rfid = false;
        }
      } else if (msgSourceId == 25) {
        //====后厨
        if (_this.isButt_cf) {
          //关闭语音
          if (
            !_this.player_voice.sign &&
            _this.player_voice.type == "player_cf"
          ) {
            _this.player_cf.closeAudio();
            end(_this.player_voice.cvrDevice, _this.player_voice.cvrChannel);
          }
          //关闭视频
          if (
            _this.player_voice.forbid &&
            _this.player_voice.type == "player_cf"
          ) {
            _this.player_cf.destroy();
            _this.player_cf = "";
          }
          //清空语音
          _this.player_voice.sign = true;
          _this.player_voice.forbid = false;
          _this.player_voice.type = "";
          _this.player_voice.cvrDevice = "";
          _this.player_voice.cvrChannel = "";
          //销毁定时器
          clearInterval(_this.setInterval.cfvideo);
          _this.setInterval.cfvideo = null;
          //关闭右侧视频框
          _this.isButt_cf = false;
        }
      } else if (msgSourceId == 18) {
        //====防火门
        if (_this.isButt_fhm) {
          if (
            _this.player_voice.forbid &&
            _this.player_voice.type == "player_fhm"
          ) {
            _this.player_fhm.destroy();
            _this.player_fhm = "";
          }
          _this.player_voice.forbid = false;
          _this.player_voice.type = "";
          //销毁定时器
          clearInterval(_this.setInterval.fhmvideo);
          _this.setInterval.fhmvideo = null;
          //关闭右侧视频框
          _this.isButt_fhm = false;
        }
      } else if (msgSourceId == 17) {
        //====堆物堆料
        if (_this.isButt_dwdl) {
          if (
            _this.player_voice.forbid &&
            _this.player_voice.type == "player_dwdl"
          ) {
            _this.player_dwdl.destroy();
            _this.player_dwdl = "";
          }
          _this.player_voice.forbid = false;
          _this.player_voice.type = "";
          //销毁定时器
          clearInterval(_this.setInterval.dwdlvideo);
          _this.setInterval.dwdlvideo = null;
          //关闭右侧视频框
          _this.isButt_dwdl = false;
        }
      } else if (msgSourceId == 16) {
        //====消防车道
        if (_this.isButt_xftd) {
          if (
            _this.player_voice.forbid &&
            _this.player_voice.type == "player_xftd"
          ) {
            _this.player_xftd.destroy();
            _this.player_xftd = "";
          }
          _this.player_voice.forbid = false;
          _this.player_voice.type = "";
          //销毁定时器
          clearInterval(_this.setInterval.xftdvideo);
          _this.setInterval.xftdvideo = null;
          //关闭右侧视频框
          _this.isButt_xftd = false;
        }
      } else if (msgSourceId == 15) {
        //====火眼
        if (_this.isButt_hy) {
          if (
            _this.player_voice.forbid &&
            _this.player_voice.type == "player_hy"
          ) {
            _this.isButt_hy.destroy();
            _this.isButt_hy = "";
          }
          _this.player_voice.forbid = false;
          _this.player_voice.type = "";
          //销毁定时器
          clearInterval(_this.setInterval.hyvideo);
          _this.setInterval.hyvideo = null;
          //关闭右侧视频框
          _this.isButt_hy = false;
        }
      } else if (msgSourceId == 30) {
        // 刷新呼叫报警数据
        _this.$root.eventHub.$emit('RefreshVideoAlarmList')
        //呼叫报警
        if (_this.isButt_spbj) {
          //关闭视频
          _this.jumpVideo2_spbj("", type);

        }
      } else if (msgSourceId == 39) {
        //====感温线缆
        if (_this.dialogCameraGwxlListNew.length > 0) {
          _this.dialogCameraGwxlListNew = _this.dialogCameraGwxlListNew.filter(
            (v) => v.id != data.id
          );
        }
        if (_this.dialogCameraGwxlList.length > 0) {
          _this.dialogCameraGwxlList = _this.dialogCameraGwxlList.filter(
            (v) => v.id != data.id
          );
        }
      }
    },

    auditInfo() {
      let _this = this;
      if (!_this.content) {
        _this.$message.warning("请输入审核内容");
        return;
      }

      var data = {
        content: _this.content,
        id: _this.alarmId,
      };
      var success = function (resp) {
        if (resp.code == "0") {
          _this.dialog.handAlarmVisibled = false;
          _this.dialog.smokeAlarmVisible = false;
          _this.content = ""; //清空审核内容
          _this.closePinkAlarmDialog();
          _this.stopBellRing();
          _this.$message.success("提交成功！");

          //刷新列表
          let msgSourceId = _this.jssd.jssdData.msgSource;
          let routeName = _this.$route.name; //获取当前的路径；

          if (msgSourceId == 19 && routeName == "securityDoor") {
            //防火门
            location.reload();
          } else if (msgSourceId == 19 && routeName == "handNewspaperDangers") {
            //手报
            location.reload();
          } else if (msgSourceId == 19 && routeName == "monitorDangers") {
            //电动车
            location.reload();
          } else if (msgSourceId == 19 && routeName == "monitorDcDangers") {
            //电池
            location.reload();
          } else if (msgSourceId == 19 && routeName == "rfidDangers") {
            //rfid
            location.reload();
          } else if (msgSourceId == 19 && routeName == "pinkeyeDangers") {
            //火眼
            location.reload();
          } else if (msgSourceId == 19 && routeName == "kitchenDangers") {
            //后厨报警
            location.reload();
          } else if (msgSourceId == 19 && routeName == "pileThing") {
            //堆物堆料
            location.reload();
          } else if (msgSourceId == 19 && routeName == "fireEngine") {
            //消防车道
            location.reload();
          }
        } else {
          _this.$message({
            type: "error",
            message: "获取视频流失败!",
            customClass: "messageIndex",
          });
        }
      };
      _this.http.post("/webapi/writ/submitAudit", data, success);
    },
    openReview(data) {
      _this.dialog.handAlarmVisibled = true;
      _this.jssd.jssdData = data;
      _this.stopBellRing();
    },
    triggerAlarm() {
      _this.probeFun();
      _this.dialog.probeAlarmDialog = true;
    },
  },
};
</script>
<style lang="less" scoped>
.alarmDialogDiv {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0px;
  z-index: 20000;

  .videoContent {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .closeButton {
    position: absolute;
    right: 10px;
    top: 10px;
    color: #fff;
    font-size: 40px;
    display: inline-block;
    cursor: pointer;
    cursor: pointer;
  }
}

.indexLeft {
  position: relative;

  .back {
    width: 90%;
    height: 60%;
    position: absolute;
    top: 3%;
    left: 5%;
  }

  .duty {
    color: #fff;
    height: 64%;
    line-height: 26px;
    border-radius: 10px;
  }

  .lIcon {
    cursor: pointer;
  }

  .lIcon img {
    display: block;
    margin: auto;
    margin-top: 4%;
  }
}

.rigFlex {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
}

.rBtn {
  // margin: 0 10px 20px 0;
  width: 230px;
  height: 160px;
  padding: 18px 0 0 0;
  background: rgba(42, 46, 55, 1);
  //border-image:linear-gradient(0deg, rgba(0,0,0,1), rgba(101,105,114,1)) 2 2;
  border-radius: 16px;
  /* 圆角属性测试 */
  border: 1px solid;
  background-image: linear-gradient(rgba(42, 46, 55, 1), rgba(42, 46, 55, 1)),
  linear-gradient(rgba(0, 0, 0, 1), rgba(101, 105, 114, 1));
  /* 模拟渐变边框 */
  background-clip: padding-box, border-box;
  background-origin: border-box;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.7);
  cursor: pointer;
}

.rBtn img {
  display: block;
  margin: auto;
}

.middle {
  padding: 0 20px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
}

.midBtn p img {
  display: block;
  padding-top: 18px;
  margin: auto;
}

.midBtn {
  width: 100%;
  height: 103px;
  background: rgba(42, 46, 55, 1);
  border: 2px solid #ebeef5;
  box-sizing: border-box;
  padding: 5px;
  border-radius: 16px;
  //  border-image:linear-gradient(0deg, rgba(0,0,0,1), rgba(101,105,114,1)) 2 2;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.7);
  position: relative;
  cursor: pointer;
}

.tag {
  position: absolute;
  top: 34px;
  left: 30px;
  width: 40px;
  height: 40px;
  font-size: 26px;
  line-height: 40px;
  border-radius: 50%;
  text-align: center;
  background: rgba(247, 250, 99, 1);
  font-family: SourceHanSansCN;
  font-weight: 800;
  color: rgba(42, 46, 55, 1);
}

.callDialogRight {
  font-size: 16px;
  margin-left: 20px !important;
  line-height: 28px;

  .callDialogTime {
    font-weight: bold;
    // background:rgb(242, 242, 242) ;
  }

  .callDialogThings {
    font-size: 18px;
    font-family: Source Han Sans CN;
    color: rgb(0, 0, 0);
    padding: 0px 0 0px 48px;
    line-height: 40px;
  }
}

.sureVisibleTip {
  text-align: center;
  font-size: 16px;
  line-height: 24px;
}

.videoCallBtn {
  line-height: 82px;
  height: 82px;
  width: 260px;
  padding: 0;
  font-weight: bold;
  font-size: 24px;
}

.Fun {
  color: #fff;
}

.videoBtn {
  position: relative;
}

.el-icon-close {
  position: absolute;
  top: 10px;
  left: 570px;
  cursor: pointer;
  font-size: 18px;
  color: #fff;
}

.jcjc-tag {
  .autoAddress {
    font-size: 18px !important;
  }

  .autoAddress:not(:last-child)::after {
    content: '|';
    margin: 0 10px;
    color: rgba(255, 255, 255, 0.5);
  }
}
</style>
<style lang="less">
.set-video-wrapper {
  position: absolute;
  width: 400px;
  height: 351px;
  top: 0;
  right: -400px;

  #players {
    width: 100%;
    height: 351px;
    padding: 0px !important;
  }

  //  #Player {
  //   width: 100%;
  //   height: 351px;
  //   padding: 0px !important;
  // }

  .el-icon-close {
    position: absolute;
    right: 0 !important;
    top: 0;
    cursor: pointer;
    left: 0;
    z-index: 99999;
  }
}

.video-wrapper {
  width: 490px;
  height: 800px;
  float: left;
  position: relative;

  #Player {
    width: 100%;
    height: 49% !important;
    padding: 0px !important;
  }

  .el-icon-close {
    position: absolute;
    right: 0 !important;
    top: 0;
    cursor: pointer;
    left: 0;
    z-index: 99999;
    left: 92%;
    top: 1.5%;
  }
}

.policeInfo {
  width: auto;
  border: 1px solid #ebeef5;

  .el-form-item__content {
    img {
      cursor: pointer;
    }
  }

  .policeInfoTop {
    text-align: center;
    height: 60px;
    line-height: 60px;
    border-bottom: 1px solid #ebeef5;
    position: relative;

    .policeNum {
      text-align: right;
    }

    .policeText {
      text-align: left;
    }

    .police {
      height: 280px;
      overflow-y: scroll;
    }
  }

  .lineHei {
    line-height: 32px;
    font-size: 20px;
    color: #fff;
  }

  .policeInfoBot {
    padding: 10px 0 10px 43px;

    .el-form-item {
      margin: 0;
    }

    .piBot {
      span {
        line-height: 46px;
      }

      .piTopText {
        margin: 0 30px 0 0px;
        color: #fff;
        font-size: 18px;
      }
    }

    .piTopImg {
      vertical-align: middle;
    }

    .piBtn {
      width: 132px;
      height: 39px;
      border: 1px solid #ebeef5;
      border-radius: 20px;
      background: #3b3b3b;
      color: #fff;
      margin-bottom: 6px;
      margin-right: 23px;
    }

    .el-input {
      height: 32px;
      border-radius: 10px;
    }

    .el-textarea__inner {
      border-radius: 10px;
    }
  }
}

.proOrder {
  color: #ffffff;
  line-height: 30px;
  text-shadow: 0px 2px 10px rgba(4, 0, 0, 0.7);
  font-size: 24px;
  font-weight: 800;
}

.electric-wrapper {
  .el-dialog__header {
    // padding: 15px 20px 15px;
    padding: 25px;
    border-radius: 18px 18px 0px 0px;
    text-align: center;

    .el-dialog__title {
      font-size: 24px;
    }
  }

  .el-dialog__body {
    .el-checkbox__label {
      font-size: 16px;
    }
  }

  .el-dialog__footer {
    .el-button {
      margin: 0px 35px;
      font-size: 16px;
    }
  }
}

.endNoticeDialogone {
  .el-dialog {
    background: transparent;

    .el-dialog__header {
      background: #0080db !important;
      border-radius: 18px 18px 0px 0px;
      padding: 25px;

      .el-dialog__title {
        color: white;
        font-size: 20px;
      }

      .el-dialog__headerbtn .el-icon-close {
        color: #fff;
      }
    }

    .el-dialog__body {
      padding: 0px !important;
      border-radius: 0px 0px 18px 18px;

      p {
        color: #fff;
      }

      h2 {
        color: #fff;
      }
    }
  }
}

.endNoticeDialog {
  .probeFun {
    width: 942px;
    margin: auto;
    border-radius: 10px;
  }

  .proImg {
    overflow: hidden;

    .el-checkbox {
      line-height: 42px;
    }
  }

  .proImgImg {
    float: left;
    width: 29%;
    margin: 5px 16px 0 16px;

    .proPicVid {
      position: relative;

      .el-icon-circle-close:before {
        color: #fff;
      }
    }
    .q-address {
      padding: 10px 0;
      font-size: 20px;
      font-weight: bold;
      text-align: left;
      height: 30px;
      color: #fff;
    }

    .proBot {
      width: 200px;
      color: #fff;
      text-align: center;
      background: #3b3b3b;
      opacity: 0.7;
      position: absolute;
      left: 0;
      bottom: 0;
    }
  }
}

.fire_margin {
  .el-dialog {
    margin-top: 10vh !important;

    .el-dialog__body .fireeye-body .fireeye-bg {
      width: 1000px !important;
    }
  }
}

.callDialog {
  .el-dialog__header {
    text-align: left;
    border-radius: 18px 18px 0px 0px;
  }

  .el-dialog__title {
    color: #fff;
  }
}

.phoneCallDialog {
  text-align: center;
  font-size: 18px;
  line-height: 30px;
  color: #fff;
}

.phoningDialog {
  text-align: center !important;

  .el-dialog {
    background: #fff !important;
  }

  .phoneCallDialog {
    text-align: center !important;
    font-size: 15px !important;
    line-height: 25px !important;
    color: #000 !important;
  }

  img {
    height: 40px !important;
  }

  .el-dialog__header {
    // border-radius:16px 16px 0 0  !important;
    height: 10px !important;
    background: rgb(41, 143, 248) !important;
  }
}

.el-dialog__body {
  .shoubao {
    width: 1120px;
  }
}

.autoDialog-wrap {
  background: none !important;
  box-shadow: none !important;

  .el-dialog__header {
    padding: 0px !important;
  }

  .el-dialog__body {
    padding: 0px !important;
  }

  .wrapper-content {
    width: 980px !important;
  }
}

.shoubao {
  .auto-dialog {
    width: 590px;
    height: 343px;
  }
}

.auto-dialog {
  width: 460px;
  padding: 25px 20px;
  float: left;
  background: rgba(242, 70, 53, 1) !important;

  .el-dialog__header {
    .el-dialog__headerbtn {
      .el-dialog__close {
        color: #fff;
      }
    }
  }

  .autoContent {
    text-align: center;

    .autoAddress {
      padding: 19px 0 46px 0;
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      line-height: 30px;
    }
  }
}

.pull-dialog {
  background: #5a16e0 !important;
  border-radius: 18px !important;

  .el-dialog__header {
    .el-dialog__headerbtn {
      .el-dialog__close {
        color: #fff;
      }
    }
  }

  .autoContent {
    text-align: center;

    .autoAddress {
      padding: 19px 0 46px 0;
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      line-height: 30px;
    }
  }
}

.auto-dialog1 {
  background: rgb(41, 143, 248) !important;
  border-radius: 18px !important;

  .el-dialog__header {
    .el-dialog__headerbtn {
      .el-dialog__close {
        color: #000;
      }
    }
  }

  .autoContent {
    text-align: center;

    .autoAddress {
      padding: 19px 0 46px 0;
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      line-height: 30px;
    }
  }
}

.el-dialog__wrapper {
  .summon-dialog {
    background: rgb(242, 70, 53) !important;

    .el-dialog__header {
      .el-dialog__headerbtn .el-icon-close {
        color: #fff;
        font-size: 20px;
      }
    }

    .el-dialog__body {
      padding: 10px 20px 30px 20px;

      button {
        padding: 8px 15px;
        cursor: pointer;
      }
    }
  }
}

//手报设备误报
.setHandArarm {
  .hand-alarm {
    .el-dialog__header {
      .el-dialog__headerbtn {
        .el-dialog__close {
          color: #fff;
        }
      }
    }
  }
}

//微信隐患推出按钮
.el-dialog__wrapper {
  .wache {
    border-radius: 0px !important;

    .el-dialog__header .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
    }
  }
}

//烟感呼叫中弹框
.smokeAlarmCopy {
  .autoWidth {
    width: 700px;
  }

  .el-dialog {
    background: #ffffff;
    border-radius: 18px;

    .el-pager li {
      background: rgba(242, 70, 53, 1);
    }
  }

  .el-dialog__header {
    height: 40px;
    line-height: 40px;
    background: #0080db;
    border-radius: 18px 18px 0px 0px;

    .el-dialog__headerbtn {
      .el-icon-close {
        color: #fff;
      }
    }
  }

  .el-dialog__title {
    width: 142px;
    height: 24px;
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ffffff;
    line-height: 24px;
  }
}

.endNoticeDialog {
  .el-dialog {
    background: #ffffff !important;
    border-radius: 18px;

    .el-dialog__header {
      background: #0080db;
      border-radius: 18px 18px 0px 0px;
      padding: 25px;

      .el-dialog__title {
        color: white;
      }

      .el-dialog__headerbtn .el-icon-close {
        color: #fff;
      }
    }
  }
}

.q-paidan2 {
  padding-top: 20px;

  img {
    cursor: pointer;
  }
}

.el-dialog__wrapper {
  .el-dialog__headerbtn {
    position: absolute;
    padding: 0;
    border: none;
    outline: 0;
    cursor: pointer;
    font-size: 16px;
  }

  .q-report {
    width: 622px;
    border-radius: 18px;

    .el-dialog__header {

      .el-dialog__title,
      .el-dialog__headerbtn i {
        color: #fff;
        line-height: 30px;
        text-shadow: 0px 2px 10px rgba(4, 0, 0, 0.7);
        font-size: 27px;
        font-weight: 800;
        text-indent: 2em;
      }
    }

    .el-form-item__label {
      color: #000;
    }
  }
}

//火眼报警弹窗公用
.el-dialog__wrapper {
  .q-dialog-wb {
    width: 800px;
    height: 500px;
    background: #3d3fbb;
    margin-top: -250px !important;
    margin-left: -400px !important;
    top: 50%;
    left: 50%;

    .el-dialog__header {
      .el-dialog__headerbtn {
        background: none;
      }

      .el-dialog__title,
      .el-dialog__headerbtn i {
        color: #ffffff;
        line-height: 30px;
        text-shadow: 0px 2px 10px rgba(4, 0, 0, 0.7);
        font-size: 27px;
        font-weight: 800;
      }

      .el-dialog__headerbtn .el-icon-close {
        color: #fff;
        z-index: 10;
      }
    }
  }

  .q-dialog {
    img {
      cursor: pointer;
    }

    width: 622px;
    // 报警弹屏高度
    // height: 606px;
    background: #f24635;
    position: absolute;
    margin-top: -303px !important;
    margin-left: -311px !important;
    top: 50%;
    left: 50%;

    .el-image {
      margin: 0px auto;
      display: block;
    }

    .q-address {
      padding: 14px 0;
      font-size: 20px;
      font-weight: bold;
      text-align: left;
      height: 30px;
      color: #fff;
    }

    .proBot {
      padding: 10px 0px;
      // margin: 0px auto;
      // width: 0px;
      font-size: 20px;
      text-align: center;
      height: 30px;
      color: #fff;

      img {
        float: left;
      }

      span {
        width: 100px;
        display: inline-block;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding: 0px 10px;
        line-height: 30px;
      }
    }

    .el-dialog__header {
      .el-dialog__headerbtn {
        background: none;
      }

      .el-dialog__title,
      .el-dialog__headerbtn i {
        color: #ffffff;
        line-height: 30px;
        text-shadow: 0px 2px 10px rgba(4, 0, 0, 0.7);
        font-size: 27px;
        font-weight: 800;
      }

      .el-dialog__headerbtn .el-icon-close {
        color: #fff;
        z-index: 10;
      }
    }

    .el-dialog__body {
      .probeFun {
        .q-video {
          width: 622px;
          position: absolute;
          right: -622px;
          // 报警弹屏高度
          // height: 606px;
          top: 0px;
          bottom: 0px;
          background: #000 !important;
          overflow: hidden;

          .q-video-inside {
            width: 580px !important;
            height: 566px !important;
            margin: -30px auto 0;
          }

          .video-paading {
            height: 100% !important;
            padding-top: 0px !important;
          }

          #Player {
            height: 100% !important;
            padding-top: 0px !important;
          }

          #Player_sb {
            height: 100% !important;
            padding-top: 0px !important;
          }

          #Player_ddc {
            height: 100% !important;
            padding-top: 0px !important;
          }

          #Player_fhm {
            height: 100% !important;
            padding-top: 0px !important;
          }

          #Player_xftd {
            height: 100% !important;
            padding-top: 0px !important;
          }

          .el-icon-close {
            cursor: pointer;
            position: absolute;
            top: 15px;
            right: 15px;
            cursor: pointer;
            left: auto;
            color: #fff;
            z-index: 10;
          }
        }
      }

      // .autoDialog-wrap-sb-n{
      //   left:0px;
      //   background: none;
      //   box-shadow: none;
      // }
      // .autoDialog-wrap-sb-n .el-dialog__header{
      //   padding:0px
      // }
      // .autoDialog-wrap-sb-n .el-dialog__body{
      //   padding:0px
      // }

      // .autoDialog-wrap-sb-y{
      //   left:-270px;
      //   background: none;
      //   box-shadow: none;
      // }
      // .autoDialog-wrap-sb-y .el-dialog__header{
      //   padding:0px
      // }
      // .autoDialog-wrap-sb-y .el-dialog__body{
      //   padding:0px
      // }
    }
  }

  .q-dialog-left {
    margin-left: -622px !important;
  }

  .gwxl-dialog {
    width: 1341px !important;
    height: auto;
    margin-top: -350px !important;
    margin-left: -670.5px !important;
    top: 50%;
    left: 50%;

    .el-dialog__body {
      padding: 0;
      background: #08111f;
    }

    .gwxl-dialog-content {
      display: flex;
      min-height: 700px;
      background: #08111f;
    }

    .gwxl-info-panel {
      width: 320px;
      padding: 24px 20px;
      box-sizing: border-box;
      background: linear-gradient(180deg, rgba(15, 37, 66, 0.98) 0%, rgba(8, 17, 31, 1) 100%);
      border-right: 1px solid rgba(80, 140, 200, 0.22);
      color: #fff;

      .gwxl-info-title {
        font-size: 20px;
        font-weight: 700;
        letter-spacing: 2px;
        margin-bottom: 24px;
        color: #d9efff;
      }

    .gwxl-info-item {
      margin-bottom: 20px;
      font-size: 16px;
      line-height: 28px;

        .label {
          color: #8fb5d8;
        }

        .value {
          color: #fff;
          word-break: break-all;
        }
      }

      .gwxl-alarm-card {
        margin-bottom: 18px;
        padding: 14px 16px;
        border-radius: 12px;
        background: rgba(255, 74, 74, 0.08);
        border: 1px solid rgba(255, 74, 74, 0.22);

        .gwxl-alarm-card-title {
          font-size: 18px;
          font-weight: 700;
          color: #ffdbdb;
          margin-bottom: 10px;
          letter-spacing: 1px;
        }

        .gwxl-alarm-card-row {
          font-size: 15px;
          line-height: 24px;
          margin-bottom: 6px;

          .label {
            color: #ffb4b4;
          }

          .value {
            color: #fff;
            word-break: break-all;
          }
        }
      }
    }

    .gwxl-video-panel {
      flex: 1;
      min-width: 0;
      background: #000;
    }

    .gwxl-look-video {
      margin-top: 0 !important;
      height: 100% !important;
    }

    .lookVideo {
      margin-top: 0 !important;
      height: 700px !important;
    }

    .lookVideo-content {
      padding-top: 0 !important;
      height: 100% !important;
    }
  }

  //烟感
  .smoke-dialog {
    background: #f24635;

    .el-dialog__header {
      .el-dialog__headerbtn .el-icon-close {
        color: #fff;
      }
    }

    .el-dialog__body {
      .autoContent {
        text-align: center;

        .autoAddress {
          padding: 19px 0 10px 0;
          font-size: 24px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
          line-height: 30px;
        }
      }
    }
  }

  .smoke-wrap {
    .el-dialog__header {
      .el-dialog__headerbtn .el-icon-close {
        color: #fff;
      }
    }
  }
}

.phoningDialog1 .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

.q-dialog-au {
  margin-left: -575px !important;

  .el-dialog__body {
    .probeFun {
      .q-video {
        #Player {
          height: 23% !important;
        }
      }
    }
  }
}

.el-dialog__wrapper {
  .q-dialog1 {
    img {
      cursor: pointer;
    }

    width: 622px;
    height: 528px;
    background: #1cb8c1;
    border-radius: 18px;
    position: absolute;
    margin-top: -264px !important;
    margin-left: -311px;
    top: 50%;
    left: 50%;

    .q-video {
      width: 528px;
      position: absolute;
      right: -528px;
      height: 528px;
      top: 0px;
      bottom: 0px;

      .el-icon-close {
        cursor: pointer;
        position: absolute;
        top: 5px;
        right: 5px;
        cursor: pointer;
        left: auto;
        color: #fff;
      }
    }

    .el-image {
      margin: 0px auto;
      display: block;
    }
    .q-address {
      padding: 14px 0;
      font-size: 20px;
      font-weight: bold;
      text-align: left;
      height: 30px;
      color: #fff;
    }

    .proBot {
      padding: 26px 0px;
      // margin: 0px auto;
      width: 0px;
      font-size: 20px;
      text-align: center;
      height: 30px;
      color: #fff;

      img {
        float: left;
      }

      span {
        width: 100px;
        display: inline-block;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding: 0px 10px;
        line-height: 30px;
      }
    }

    .el-dialog__header {

      .el-dialog__title,
      .el-dialog__headerbtn i {
        color: #fff;
        color: #ffffff;
        line-height: 30px;
        text-shadow: 0px 2px 10px rgba(4, 0, 0, 0.7);
        font-size: 27px;
        font-weight: 800;
      }
    }
  }
}

.el-dialog__wrapper {
  .q-dialog2 {
    img {
      cursor: pointer;
    }

    width: 622px;
    height: 528px;
    background: #b6a426;
    border-radius: 18px;
    position: absolute;
    margin-top: -264px !important;
    margin-left: -311px;
    top: 50%;
    left: 50%;

    .q-video {
      width: 528px;
      position: absolute;
      right: -528px;
      height: 528px;
      top: 0px;
      bottom: 0px;

      .el-icon-close {
        cursor: pointer;
        position: absolute;
        top: 5px;
        right: 5px;
        cursor: pointer;
        left: auto;
        color: #fff;
      }
    }

    .el-image {
      margin: 0px auto;
      display: block;
    }

    .q-address {
      padding: 14px 0;
      font-size: 20px;
      font-weight: bold;
      text-align: left;
      height: 30px;
      color: #fff;
    }

    .proBot {
      padding: 26px 0px;
      // margin: 0px auto;
      width: 0px;
      font-size: 20px;
      text-align: center;
      height: 30px;
      color: #fff;

      img {
        float: left;
      }

      span {
        width: 100px;
        display: inline-block;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding: 0px 10px;
        line-height: 30px;
      }
    }

    .el-dialog__header {

      .el-dialog__title,
      .el-dialog__headerbtn i {
        color: #fff;
        line-height: 30px;
        text-shadow: 0px 2px 10px rgba(4, 0, 0, 0.7);
        font-size: 27px;
        font-weight: 800;
      }
    }
  }
}

.fireDoc {
  .el-dialog__header {
    padding: 20px;
    background-color: #0080db;

    .el-dialog__title {
      color: rgb(247, 247, 247);
    }
  }
}

.mrl {
  margin-left: 400px;
}

.hand-alarm {
  background: #fff;
  border-radius: 18px;
  width: 700px;

  .el-dialog__header {
    padding: 0px;
  }

  .el-dialog__body {
    padding: 0px;
    margin-top: 30px;
    // margin-right:40px;
    padding-bottom: 10px;
  }
}

.el-dialog__wrapper .el-dialog .auto-dialog {
  background: #f24635;
}

.index-firelight {
  margin-left: 22%;
  top: 10px;
  z-index: 2000;

  .el-notification__title {
    font-size: 16px;
    display: none;
  }

  .el-notification__content {
    font-size: 13px;
    margin: 0px 0px 0px 50px;

    p {
      line-height: 50px;
      height: 50px;
      overflow: hidden;

      span {
        color: red;
        font-size: 16px;
        padding: 0px 3px;
      }
    }
  }

  .icon-firelight {
    float: left;
    width: 50px;
  }
}

.nowPolice img {
  width: 100px;
  height: 42px;
  margin: 10px 20px 0 20px;
}

.nowPolice {
  display: flex;
  // justify-content: space-between;
  justify-content: center;
}

#dialogTip {
  position: absolute;
  top: 50px;
  left: 50%;
  display: none;
  z-index: 9999;
  color: #67c23a;
  background: #e1f3d8;
  padding: 0px 100px;
  line-height: 45px;
  border-radius: 3px;
}

.el-message {
  z-index: 200001 !important;
}
.gwxl-dialog-warp .el-dialog__body{
  padding: 0 20px 20px;
}
/* 感温线缆弹窗摄像头切换标签 - 全局样式（el-dialog append-to-body 需要） */
.gwxl-camera-tabs {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px 0;
}

.gwxl-camera-tab {
  display: inline-block;
  padding: 5px 14px;
  font-size: 13px;
  color: #fff;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 15px;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s;
  user-select: none;
}

.gwxl-camera-tab:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: #fff;
}

.gwxl-camera-tab.active {
  color: #f24635;
  background: #fff;
  border-color: #fff;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/pages/baseCall/baseCall.vue